/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { AccessBlock } from "../../models/accessBlock.ts";

import type { AccessBlockPage } from "../../models/accessBlockPage.ts";

import type { AccountIPReport } from "../../models/accountIPReport.ts";

import type { AccuracyTrendsResponse } from "../../models/accuracyTrendsResponse.ts";

import type { AddUserCreditsResponse } from "../../models/addUserCreditsResponse.ts";

import type { AgentDiagnosticsResponse } from "../../models/agentDiagnosticsResponse.ts";

import type { BlockCostEstimatesResponse } from "../../models/blockCostEstimatesResponse.ts";

import type { BodyPostV2AddCreditsToUser } from "../../models/bodyPostV2AddCreditsToUser.ts";

import type { BodyPostV2ResetUserRateLimitUsage } from "../../models/bodyPostV2ResetUserRateLimitUsage.ts";

import type { BotAnalyticsSummary } from "../../models/botAnalyticsSummary.ts";

import type { BotCommandUsage } from "../../models/botCommandUsage.ts";

import type { BotGuildInfo } from "../../models/botGuildInfo.ts";

import type { BotServerActivity } from "../../models/botServerActivity.ts";

import type { BotServerCountPoint } from "../../models/botServerCountPoint.ts";

import type { BotTimeseriesPoint } from "../../models/botTimeseriesPoint.ts";

import type { CommunityListResponse } from "../../models/communityListResponse.ts";

import type { CommunityRebuildJobStatus } from "../../models/communityRebuildJobStatus.ts";

import type { CopilotUsageExportResponse } from "../../models/copilotUsageExportResponse.ts";

import type { CreateAccessBlockRequest } from "../../models/createAccessBlockRequest.ts";

import type { CreditTransactionsExportResponse } from "../../models/creditTransactionsExportResponse.ts";

import type { DreamJobStatus } from "../../models/dreamJobStatus.ts";

import type { DreamPassCancelRequest } from "../../models/dreamPassCancelRequest.ts";

import type { DreamPassListResponse } from "../../models/dreamPassListResponse.ts";

import type { DreamPassRecordResponse } from "../../models/dreamPassRecordResponse.ts";

import type { EntityListResponse } from "../../models/entityListResponse.ts";

import type { ExecutionAnalyticsConfig } from "../../models/executionAnalyticsConfig.ts";

import type { ExecutionAnalyticsRequest } from "../../models/executionAnalyticsRequest.ts";

import type { ExecutionAnalyticsResponse } from "../../models/executionAnalyticsResponse.ts";

import type { ExecutionDiagnosticsResponse } from "../../models/executionDiagnosticsResponse.ts";

import type { FactListResponse } from "../../models/factListResponse.ts";

import type { FailedExecutionsListResponse } from "../../models/failedExecutionsListResponse.ts";

import type { GenerateTestDataRequest } from "../../models/generateTestDataRequest.ts";

import type { GenerateTestDataResponse } from "../../models/generateTestDataResponse.ts";

import type { GetAdminListAccessBlocksParams } from "../../models/getAdminListAccessBlocksParams.ts";

import type { GetV2BotMessageTimeseriesParams } from "../../models/getV2BotMessageTimeseriesParams.ts";

import type { GetV2BotServerCountTimeseriesShardingCurveParams } from "../../models/getV2BotServerCountTimeseriesShardingCurveParams.ts";

import type { GetV2BotServerRosterParams } from "../../models/getV2BotServerRosterParams.ts";

import type { GetV2BotUsageSummaryParams } from "../../models/getV2BotUsageSummaryParams.ts";

import type { GetV2CommandUsageBreakdownParams } from "../../models/getV2CommandUsageBreakdownParams.ts";

import type { GetV2ExportBlockCostEstimatesParams } from "../../models/getV2ExportBlockCostEstimatesParams.ts";

import type { GetV2ExportCopilotWeeklyUsageVsRateLimitParams } from "../../models/getV2ExportCopilotWeeklyUsageVsRateLimitParams.ts";

import type { GetV2ExportCreditTransactionsParams } from "../../models/getV2ExportCreditTransactionsParams.ts";

import type { GetV2ExportPlatformCostLogsParams } from "../../models/getV2ExportPlatformCostLogsParams.ts";

import type { GetV2GetAdminListingsHistoryParams } from "../../models/getV2GetAdminListingsHistoryParams.ts";

import type { GetV2GetAllUsersHistoryParams } from "../../models/getV2GetAllUsersHistoryParams.ts";

import type { GetV2GetExecutionAccuracyTrendsAndAlertsParams } from "../../models/getV2GetExecutionAccuracyTrendsAndAlertsParams.ts";

import type { GetV2GetExpertGraphParams } from "../../models/getV2GetExpertGraphParams.ts";

import type { GetV2GetGraphParams } from "../../models/getV2GetGraphParams.ts";

import type { GetV2GetPlatformCostDashboardParams } from "../../models/getV2GetPlatformCostDashboardParams.ts";

import type { GetV2GetPlatformCostLogsParams } from "../../models/getV2GetPlatformCostLogsParams.ts";

import type { GetV2GetUserRateLimitParams } from "../../models/getV2GetUserRateLimitParams.ts";

import type { GetV2GetUserRateLimitTierParams } from "../../models/getV2GetUserRateLimitTierParams.ts";

import type { GetV2ListAllUserSchedulesParams } from "../../models/getV2ListAllUserSchedulesParams.ts";

import type { GetV2ListCommunitiesParams } from "../../models/getV2ListCommunitiesParams.ts";

import type { GetV2ListDreamPassRecordsParams } from "../../models/getV2ListDreamPassRecordsParams.ts";

import type { GetV2ListEntitiesParams } from "../../models/getV2ListEntitiesParams.ts";

import type { GetV2ListExpertCommunitiesParams } from "../../models/getV2ListExpertCommunitiesParams.ts";

import type { GetV2ListExpertEntitiesParams } from "../../models/getV2ListExpertEntitiesParams.ts";

import type { GetV2ListExpertFactsParams } from "../../models/getV2ListExpertFactsParams.ts";

import type { GetV2ListFactsParams } from "../../models/getV2ListFactsParams.ts";

import type { GetV2ListFailedExecutionsParams } from "../../models/getV2ListFailedExecutionsParams.ts";

import type { GetV2ListInvalidExecutionsParams } from "../../models/getV2ListInvalidExecutionsParams.ts";

import type { GetV2ListLongRunningExecutionsParams } from "../../models/getV2ListLongRunningExecutionsParams.ts";

import type { GetV2ListOrphanedExecutionsParams } from "../../models/getV2ListOrphanedExecutionsParams.ts";

import type { GetV2ListRunningExecutionsParams } from "../../models/getV2ListRunningExecutionsParams.ts";

import type { GetV2ListStuckQueuedExecutionsParams } from "../../models/getV2ListStuckQueuedExecutionsParams.ts";

import type { GetV2SearchUsersByNameOrEmailParams } from "../../models/getV2SearchUsersByNameOrEmailParams.ts";

import type { GetV2TopServersByActivityParams } from "../../models/getV2TopServersByActivityParams.ts";

import type { GraphResponse } from "../../models/graphResponse.ts";

import type { HTTP401NotAuthenticatedErrorResponse } from "../../models/hTTP401NotAuthenticatedErrorResponse.ts";

import type { HTTPValidationError } from "../../models/hTTPValidationError.ts";

import type { ImpersonationNotifyRequest } from "../../models/impersonationNotifyRequest.ts";

import type { ImpersonationNotifyResponse } from "../../models/impersonationNotifyResponse.ts";

import type { JobTriggerResponse } from "../../models/jobTriggerResponse.ts";

import type { LibraryAgent } from "../../models/libraryAgent.ts";

import type { MemoryOverview } from "../../models/memoryOverview.ts";

import type { NightlyJobStatus } from "../../models/nightlyJobStatus.ts";

import type { OrgResponse } from "../../models/orgResponse.ts";

import type { OrphanedSchedulesListResponse } from "../../models/orphanedSchedulesListResponse.ts";

import type { PlatformCostDashboard } from "../../models/platformCostDashboard.ts";

import type { PlatformCostExportResponse } from "../../models/platformCostExportResponse.ts";

import type { PlatformCostLogsResponse } from "../../models/platformCostLogsResponse.ts";

import type { PostV2RebuildCommunitiesParams } from "../../models/postV2RebuildCommunitiesParams.ts";

import type { PostV2TriggerDreamPassParams } from "../../models/postV2TriggerDreamPassParams.ts";

import type { RatificationResult } from "../../models/ratificationResult.ts";

import type { RequeueExecutionResponse } from "../../models/requeueExecutionResponse.ts";

import type { ReviewSubmissionRequest } from "../../models/reviewSubmissionRequest.ts";

import type { RunningExecutionsListResponse } from "../../models/runningExecutionsListResponse.ts";

import type { ScheduleCleanupRequest } from "../../models/scheduleCleanupRequest.ts";

import type { ScheduleCleanupResponse } from "../../models/scheduleCleanupResponse.ts";

import type { ScheduleHealthMetrics } from "../../models/scheduleHealthMetrics.ts";

import type { SchedulesListResponse } from "../../models/schedulesListResponse.ts";

import type { SetUserTierRequest } from "../../models/setUserTierRequest.ts";

import type { SkillReviewRequest } from "../../models/skillReviewRequest.ts";

import type { SkillSubmission } from "../../models/skillSubmission.ts";

import type { StopExecutionRequest } from "../../models/stopExecutionRequest.ts";

import type { StopExecutionResponse } from "../../models/stopExecutionResponse.ts";

import type { StopExecutionsRequest } from "../../models/stopExecutionsRequest.ts";

import type { StoreAgentDetails } from "../../models/storeAgentDetails.ts";

import type { StoreListingsWithVersionsAdminViewResponse } from "../../models/storeListingsWithVersionsAdminViewResponse.ts";

import type { StoreSubmissionAdminView } from "../../models/storeSubmissionAdminView.ts";

import type { UserHistoryResponse } from "../../models/userHistoryResponse.ts";

import type { UserRateLimitResponse } from "../../models/userRateLimitResponse.ts";

import type { UserSearchResult } from "../../models/userSearchResult.ts";

import type { UserTierResponse } from "../../models/userTierResponse.ts";

import { customMutator } from "../../../mutators/custom-mutator.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getAdminListAccessBlocksResponse200 = {
  data: AccessBlockPage;
  status: 200;
};

export type getAdminListAccessBlocksResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getAdminListAccessBlocksResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getAdminListAccessBlocksResponseSuccess =
  getAdminListAccessBlocksResponse200 & {
    headers: Headers;
  };
export type getAdminListAccessBlocksResponseError = (
  | getAdminListAccessBlocksResponse401
  | getAdminListAccessBlocksResponse422
) & {
  headers: Headers;
};

export type getAdminListAccessBlocksResponse =
  | getAdminListAccessBlocksResponseSuccess
  | getAdminListAccessBlocksResponseError;

export const getGetAdminListAccessBlocksUrl = (
  params?: GetAdminListAccessBlocksParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/access-blocks?${stringifiedParams}`
    : `/api/admin/access-blocks`;
};

/**
 * The IP and email domain blocks in force, newest first. Admin-only.
 * @summary List access blocks
 */
export const getAdminListAccessBlocks = async (
  params?: GetAdminListAccessBlocksParams,
  options?: RequestInit,
): Promise<getAdminListAccessBlocksResponse> => {
  return customMutator<getAdminListAccessBlocksResponse>(
    getGetAdminListAccessBlocksUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminListAccessBlocksQueryKey = (
  params?: GetAdminListAccessBlocksParams,
) => {
  return [`/api/admin/access-blocks`, ...(params ? [params] : [])] as const;
};

export const getGetAdminListAccessBlocksQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminListAccessBlocks>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetAdminListAccessBlocksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminListAccessBlocks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminListAccessBlocksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminListAccessBlocks>>
  > = ({ signal }) =>
    getAdminListAccessBlocks(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminListAccessBlocks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminListAccessBlocksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminListAccessBlocks>>
>;
export type GetAdminListAccessBlocksQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetAdminListAccessBlocks<
  TData = Awaited<ReturnType<typeof getAdminListAccessBlocks>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetAdminListAccessBlocksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminListAccessBlocks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminListAccessBlocks>>,
          TError,
          Awaited<ReturnType<typeof getAdminListAccessBlocks>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminListAccessBlocks<
  TData = Awaited<ReturnType<typeof getAdminListAccessBlocks>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetAdminListAccessBlocksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminListAccessBlocks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminListAccessBlocks>>,
          TError,
          Awaited<ReturnType<typeof getAdminListAccessBlocks>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminListAccessBlocks<
  TData = Awaited<ReturnType<typeof getAdminListAccessBlocks>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetAdminListAccessBlocksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminListAccessBlocks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List access blocks
 */

export function useGetAdminListAccessBlocks<
  TData = Awaited<ReturnType<typeof getAdminListAccessBlocks>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetAdminListAccessBlocksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminListAccessBlocks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminListAccessBlocksQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List access blocks
 */
export const prefetchGetAdminListAccessBlocksQuery = async <
  TData = Awaited<ReturnType<typeof getAdminListAccessBlocks>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetAdminListAccessBlocksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminListAccessBlocks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetAdminListAccessBlocksQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postAdminCreateAccessBlockResponse201 = {
  data: AccessBlock;
  status: 201;
};

export type postAdminCreateAccessBlockResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postAdminCreateAccessBlockResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postAdminCreateAccessBlockResponseSuccess =
  postAdminCreateAccessBlockResponse201 & {
    headers: Headers;
  };
export type postAdminCreateAccessBlockResponseError = (
  | postAdminCreateAccessBlockResponse401
  | postAdminCreateAccessBlockResponse422
) & {
  headers: Headers;
};

export type postAdminCreateAccessBlockResponse =
  | postAdminCreateAccessBlockResponseSuccess
  | postAdminCreateAccessBlockResponseError;

export const getPostAdminCreateAccessBlockUrl = () => {
  return `/api/admin/access-blocks`;
};

/**
 * Refuse new sign-ups (and, for an IP, sign-ins) from an IP or email
 * domain. 409 while a block on the same value is in force. Admin-only.
 * @summary Create access block
 */
export const postAdminCreateAccessBlock = async (
  createAccessBlockRequest: CreateAccessBlockRequest,
  options?: RequestInit,
): Promise<postAdminCreateAccessBlockResponse> => {
  return customMutator<postAdminCreateAccessBlockResponse>(
    getPostAdminCreateAccessBlockUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createAccessBlockRequest),
    },
  );
};

export const getPostAdminCreateAccessBlockMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAdminCreateAccessBlock>>,
    TError,
    { data: CreateAccessBlockRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAdminCreateAccessBlock>>,
  TError,
  { data: CreateAccessBlockRequest },
  TContext
> => {
  const mutationKey = ["postAdminCreateAccessBlock"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAdminCreateAccessBlock>>,
    { data: CreateAccessBlockRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postAdminCreateAccessBlock(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAdminCreateAccessBlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminCreateAccessBlock>>
>;
export type PostAdminCreateAccessBlockMutationBody = CreateAccessBlockRequest;
export type PostAdminCreateAccessBlockMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Create access block
 */
export const usePostAdminCreateAccessBlock = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAdminCreateAccessBlock>>,
      TError,
      { data: CreateAccessBlockRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAdminCreateAccessBlock>>,
  TError,
  { data: CreateAccessBlockRequest },
  TContext
> => {
  return useMutation(
    getPostAdminCreateAccessBlockMutationOptions(options),
    queryClient,
  );
};
export type deleteAdminDeleteAccessBlockResponse204 = {
  data: void;
  status: 204;
};

export type deleteAdminDeleteAccessBlockResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type deleteAdminDeleteAccessBlockResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteAdminDeleteAccessBlockResponseSuccess =
  deleteAdminDeleteAccessBlockResponse204 & {
    headers: Headers;
  };
export type deleteAdminDeleteAccessBlockResponseError = (
  | deleteAdminDeleteAccessBlockResponse401
  | deleteAdminDeleteAccessBlockResponse422
) & {
  headers: Headers;
};

export type deleteAdminDeleteAccessBlockResponse =
  | deleteAdminDeleteAccessBlockResponseSuccess
  | deleteAdminDeleteAccessBlockResponseError;

export const getDeleteAdminDeleteAccessBlockUrl = (blockId: string) => {
  return `/api/admin/access-blocks/${blockId}`;
};

/**
 * Lift a block. Admin-only.
 * @summary Delete access block
 */
export const deleteAdminDeleteAccessBlock = async (
  blockId: string,
  options?: RequestInit,
): Promise<deleteAdminDeleteAccessBlockResponse> => {
  return customMutator<deleteAdminDeleteAccessBlockResponse>(
    getDeleteAdminDeleteAccessBlockUrl(blockId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteAdminDeleteAccessBlockMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminDeleteAccessBlock>>,
    TError,
    { blockId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminDeleteAccessBlock>>,
  TError,
  { blockId: string },
  TContext
> => {
  const mutationKey = ["deleteAdminDeleteAccessBlock"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminDeleteAccessBlock>>,
    { blockId: string }
  > = (props) => {
    const { blockId } = props ?? {};

    return deleteAdminDeleteAccessBlock(blockId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminDeleteAccessBlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminDeleteAccessBlock>>
>;

export type DeleteAdminDeleteAccessBlockMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Delete access block
 */
export const useDeleteAdminDeleteAccessBlock = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAdminDeleteAccessBlock>>,
      TError,
      { blockId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminDeleteAccessBlock>>,
  TError,
  { blockId: string },
  TContext
> => {
  return useMutation(
    getDeleteAdminDeleteAccessBlockMutationOptions(options),
    queryClient,
  );
};
export type getV2ExportBlockCostEstimatesResponse200 = {
  data: BlockCostEstimatesResponse;
  status: 200;
};

export type getV2ExportBlockCostEstimatesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ExportBlockCostEstimatesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ExportBlockCostEstimatesResponseSuccess =
  getV2ExportBlockCostEstimatesResponse200 & {
    headers: Headers;
  };
export type getV2ExportBlockCostEstimatesResponseError = (
  | getV2ExportBlockCostEstimatesResponse401
  | getV2ExportBlockCostEstimatesResponse422
) & {
  headers: Headers;
};

export type getV2ExportBlockCostEstimatesResponse =
  | getV2ExportBlockCostEstimatesResponseSuccess
  | getV2ExportBlockCostEstimatesResponseError;

export const getGetV2ExportBlockCostEstimatesUrl = (
  params?: GetV2ExportBlockCostEstimatesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/blocks/cost-estimates?${stringifiedParams}`
    : `/api/admin/blocks/cost-estimates`;
};

/**
 * Aggregate per-block average credits-per-execution over [start, end].
 *
 * Capped at ANALYTICS_MAX_DAYS days. Returns only blocks whose current cost
 * type is dynamic (SECOND/ITEMS/COST_USD) — static-cost blocks already
 * charge correctly pre-flight and don't need an estimate override. TOKENS
 * is excluded because `compute_token_credits` already supplies a per-model
 * floor at pre-flight; a per-block historical mean would lose that
 * granularity.
 * @summary Export Block Cost Estimates
 */
export const getV2ExportBlockCostEstimates = async (
  params?: GetV2ExportBlockCostEstimatesParams,
  options?: RequestInit,
): Promise<getV2ExportBlockCostEstimatesResponse> => {
  return customMutator<getV2ExportBlockCostEstimatesResponse>(
    getGetV2ExportBlockCostEstimatesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ExportBlockCostEstimatesQueryKey = (
  params?: GetV2ExportBlockCostEstimatesParams,
) => {
  return [
    `/api/admin/blocks/cost-estimates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ExportBlockCostEstimatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportBlockCostEstimatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ExportBlockCostEstimatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>
  > = ({ signal }) =>
    getV2ExportBlockCostEstimates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ExportBlockCostEstimatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>
>;
export type GetV2ExportBlockCostEstimatesQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ExportBlockCostEstimates<
  TData = Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ExportBlockCostEstimatesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>,
          TError,
          Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ExportBlockCostEstimates<
  TData = Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportBlockCostEstimatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>,
          TError,
          Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ExportBlockCostEstimates<
  TData = Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportBlockCostEstimatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Block Cost Estimates
 */

export function useGetV2ExportBlockCostEstimates<
  TData = Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportBlockCostEstimatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ExportBlockCostEstimatesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Export Block Cost Estimates
 */
export const prefetchGetV2ExportBlockCostEstimatesQuery = async <
  TData = Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ExportBlockCostEstimatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportBlockCostEstimates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ExportBlockCostEstimatesQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2CommandUsageBreakdownResponse200 = {
  data: BotCommandUsage[];
  status: 200;
};

export type getV2CommandUsageBreakdownResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2CommandUsageBreakdownResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2CommandUsageBreakdownResponseSuccess =
  getV2CommandUsageBreakdownResponse200 & {
    headers: Headers;
  };
export type getV2CommandUsageBreakdownResponseError = (
  | getV2CommandUsageBreakdownResponse401
  | getV2CommandUsageBreakdownResponse422
) & {
  headers: Headers;
};

export type getV2CommandUsageBreakdownResponse =
  | getV2CommandUsageBreakdownResponseSuccess
  | getV2CommandUsageBreakdownResponseError;

export const getGetV2CommandUsageBreakdownUrl = (
  params?: GetV2CommandUsageBreakdownParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/bot-analytics/command-usage?${stringifiedParams}`
    : `/api/admin/bot-analytics/command-usage`;
};

/**
 * @summary Command Usage Breakdown
 */
export const getV2CommandUsageBreakdown = async (
  params?: GetV2CommandUsageBreakdownParams,
  options?: RequestInit,
): Promise<getV2CommandUsageBreakdownResponse> => {
  return customMutator<getV2CommandUsageBreakdownResponse>(
    getGetV2CommandUsageBreakdownUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2CommandUsageBreakdownQueryKey = (
  params?: GetV2CommandUsageBreakdownParams,
) => {
  return [
    `/api/admin/bot-analytics/command-usage`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2CommandUsageBreakdownQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2CommandUsageBreakdownParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2CommandUsageBreakdownQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>
  > = ({ signal }) =>
    getV2CommandUsageBreakdown(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2CommandUsageBreakdownQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>
>;
export type GetV2CommandUsageBreakdownQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2CommandUsageBreakdown<
  TData = Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2CommandUsageBreakdownParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>,
          TError,
          Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2CommandUsageBreakdown<
  TData = Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2CommandUsageBreakdownParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>,
          TError,
          Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2CommandUsageBreakdown<
  TData = Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2CommandUsageBreakdownParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Command Usage Breakdown
 */

export function useGetV2CommandUsageBreakdown<
  TData = Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2CommandUsageBreakdownParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2CommandUsageBreakdownQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Command Usage Breakdown
 */
export const prefetchGetV2CommandUsageBreakdownQuery = async <
  TData = Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2CommandUsageBreakdownParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2CommandUsageBreakdown>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2CommandUsageBreakdownQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2BotServerRosterResponse200 = {
  data: BotGuildInfo[];
  status: 200;
};

export type getV2BotServerRosterResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2BotServerRosterResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2BotServerRosterResponseSuccess =
  getV2BotServerRosterResponse200 & {
    headers: Headers;
  };
export type getV2BotServerRosterResponseError = (
  | getV2BotServerRosterResponse401
  | getV2BotServerRosterResponse422
) & {
  headers: Headers;
};

export type getV2BotServerRosterResponse =
  | getV2BotServerRosterResponseSuccess
  | getV2BotServerRosterResponseError;

export const getGetV2BotServerRosterUrl = (
  params?: GetV2BotServerRosterParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/bot-analytics/guilds?${stringifiedParams}`
    : `/api/admin/bot-analytics/guilds`;
};

/**
 * @summary Bot Server Roster
 */
export const getV2BotServerRoster = async (
  params?: GetV2BotServerRosterParams,
  options?: RequestInit,
): Promise<getV2BotServerRosterResponse> => {
  return customMutator<getV2BotServerRosterResponse>(
    getGetV2BotServerRosterUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2BotServerRosterQueryKey = (
  params?: GetV2BotServerRosterParams,
) => {
  return [
    `/api/admin/bot-analytics/guilds`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2BotServerRosterQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2BotServerRoster>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotServerRosterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotServerRoster>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2BotServerRosterQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2BotServerRoster>>
  > = ({ signal }) =>
    getV2BotServerRoster(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2BotServerRoster>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2BotServerRosterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2BotServerRoster>>
>;
export type GetV2BotServerRosterQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2BotServerRoster<
  TData = Awaited<ReturnType<typeof getV2BotServerRoster>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2BotServerRosterParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotServerRoster>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2BotServerRoster>>,
          TError,
          Awaited<ReturnType<typeof getV2BotServerRoster>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2BotServerRoster<
  TData = Awaited<ReturnType<typeof getV2BotServerRoster>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotServerRosterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotServerRoster>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2BotServerRoster>>,
          TError,
          Awaited<ReturnType<typeof getV2BotServerRoster>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2BotServerRoster<
  TData = Awaited<ReturnType<typeof getV2BotServerRoster>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotServerRosterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotServerRoster>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Bot Server Roster
 */

export function useGetV2BotServerRoster<
  TData = Awaited<ReturnType<typeof getV2BotServerRoster>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotServerRosterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotServerRoster>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2BotServerRosterQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Bot Server Roster
 */
export const prefetchGetV2BotServerRosterQuery = async <
  TData = Awaited<ReturnType<typeof getV2BotServerRoster>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2BotServerRosterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotServerRoster>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2BotServerRosterQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2BotServerCountTimeseriesShardingCurveResponse200 = {
  data: BotServerCountPoint[];
  status: 200;
};

export type getV2BotServerCountTimeseriesShardingCurveResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2BotServerCountTimeseriesShardingCurveResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2BotServerCountTimeseriesShardingCurveResponseSuccess =
  getV2BotServerCountTimeseriesShardingCurveResponse200 & {
    headers: Headers;
  };
export type getV2BotServerCountTimeseriesShardingCurveResponseError = (
  | getV2BotServerCountTimeseriesShardingCurveResponse401
  | getV2BotServerCountTimeseriesShardingCurveResponse422
) & {
  headers: Headers;
};

export type getV2BotServerCountTimeseriesShardingCurveResponse =
  | getV2BotServerCountTimeseriesShardingCurveResponseSuccess
  | getV2BotServerCountTimeseriesShardingCurveResponseError;

export const getGetV2BotServerCountTimeseriesShardingCurveUrl = (
  params?: GetV2BotServerCountTimeseriesShardingCurveParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/bot-analytics/server-timeseries?${stringifiedParams}`
    : `/api/admin/bot-analytics/server-timeseries`;
};

/**
 * @summary Bot Server-Count Timeseries (sharding curve)
 */
export const getV2BotServerCountTimeseriesShardingCurve = async (
  params?: GetV2BotServerCountTimeseriesShardingCurveParams,
  options?: RequestInit,
): Promise<getV2BotServerCountTimeseriesShardingCurveResponse> => {
  return customMutator<getV2BotServerCountTimeseriesShardingCurveResponse>(
    getGetV2BotServerCountTimeseriesShardingCurveUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2BotServerCountTimeseriesShardingCurveQueryKey = (
  params?: GetV2BotServerCountTimeseriesShardingCurveParams,
) => {
  return [
    `/api/admin/bot-analytics/server-timeseries`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2BotServerCountTimeseriesShardingCurveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotServerCountTimeseriesShardingCurveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2BotServerCountTimeseriesShardingCurveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>>
  > = ({ signal }) =>
    getV2BotServerCountTimeseriesShardingCurve(params, {
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2BotServerCountTimeseriesShardingCurveQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>>
>;
export type GetV2BotServerCountTimeseriesShardingCurveQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2BotServerCountTimeseriesShardingCurve<
  TData = Awaited<
    ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2BotServerCountTimeseriesShardingCurveParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>
          >,
          TError,
          Awaited<ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2BotServerCountTimeseriesShardingCurve<
  TData = Awaited<
    ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotServerCountTimeseriesShardingCurveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>
          >,
          TError,
          Awaited<ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2BotServerCountTimeseriesShardingCurve<
  TData = Awaited<
    ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotServerCountTimeseriesShardingCurveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Bot Server-Count Timeseries (sharding curve)
 */

export function useGetV2BotServerCountTimeseriesShardingCurve<
  TData = Awaited<
    ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotServerCountTimeseriesShardingCurveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetV2BotServerCountTimeseriesShardingCurveQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Bot Server-Count Timeseries (sharding curve)
 */
export const prefetchGetV2BotServerCountTimeseriesShardingCurveQuery = async <
  TData = Awaited<
    ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2BotServerCountTimeseriesShardingCurveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotServerCountTimeseriesShardingCurve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions =
    getGetV2BotServerCountTimeseriesShardingCurveQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2BotUsageSummaryResponse200 = {
  data: BotAnalyticsSummary;
  status: 200;
};

export type getV2BotUsageSummaryResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2BotUsageSummaryResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2BotUsageSummaryResponseSuccess =
  getV2BotUsageSummaryResponse200 & {
    headers: Headers;
  };
export type getV2BotUsageSummaryResponseError = (
  | getV2BotUsageSummaryResponse401
  | getV2BotUsageSummaryResponse422
) & {
  headers: Headers;
};

export type getV2BotUsageSummaryResponse =
  | getV2BotUsageSummaryResponseSuccess
  | getV2BotUsageSummaryResponseError;

export const getGetV2BotUsageSummaryUrl = (
  params?: GetV2BotUsageSummaryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/bot-analytics/summary?${stringifiedParams}`
    : `/api/admin/bot-analytics/summary`;
};

/**
 * @summary Bot Usage Summary
 */
export const getV2BotUsageSummary = async (
  params?: GetV2BotUsageSummaryParams,
  options?: RequestInit,
): Promise<getV2BotUsageSummaryResponse> => {
  return customMutator<getV2BotUsageSummaryResponse>(
    getGetV2BotUsageSummaryUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2BotUsageSummaryQueryKey = (
  params?: GetV2BotUsageSummaryParams,
) => {
  return [
    `/api/admin/bot-analytics/summary`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2BotUsageSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2BotUsageSummary>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotUsageSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotUsageSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2BotUsageSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2BotUsageSummary>>
  > = ({ signal }) =>
    getV2BotUsageSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2BotUsageSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2BotUsageSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2BotUsageSummary>>
>;
export type GetV2BotUsageSummaryQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2BotUsageSummary<
  TData = Awaited<ReturnType<typeof getV2BotUsageSummary>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2BotUsageSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotUsageSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2BotUsageSummary>>,
          TError,
          Awaited<ReturnType<typeof getV2BotUsageSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2BotUsageSummary<
  TData = Awaited<ReturnType<typeof getV2BotUsageSummary>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotUsageSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotUsageSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2BotUsageSummary>>,
          TError,
          Awaited<ReturnType<typeof getV2BotUsageSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2BotUsageSummary<
  TData = Awaited<ReturnType<typeof getV2BotUsageSummary>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotUsageSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotUsageSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Bot Usage Summary
 */

export function useGetV2BotUsageSummary<
  TData = Awaited<ReturnType<typeof getV2BotUsageSummary>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotUsageSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotUsageSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2BotUsageSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Bot Usage Summary
 */
export const prefetchGetV2BotUsageSummaryQuery = async <
  TData = Awaited<ReturnType<typeof getV2BotUsageSummary>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2BotUsageSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotUsageSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2BotUsageSummaryQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2BotMessageTimeseriesResponse200 = {
  data: BotTimeseriesPoint[];
  status: 200;
};

export type getV2BotMessageTimeseriesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2BotMessageTimeseriesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2BotMessageTimeseriesResponseSuccess =
  getV2BotMessageTimeseriesResponse200 & {
    headers: Headers;
  };
export type getV2BotMessageTimeseriesResponseError = (
  | getV2BotMessageTimeseriesResponse401
  | getV2BotMessageTimeseriesResponse422
) & {
  headers: Headers;
};

export type getV2BotMessageTimeseriesResponse =
  | getV2BotMessageTimeseriesResponseSuccess
  | getV2BotMessageTimeseriesResponseError;

export const getGetV2BotMessageTimeseriesUrl = (
  params?: GetV2BotMessageTimeseriesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/bot-analytics/timeseries?${stringifiedParams}`
    : `/api/admin/bot-analytics/timeseries`;
};

/**
 * @summary Bot Message Timeseries
 */
export const getV2BotMessageTimeseries = async (
  params?: GetV2BotMessageTimeseriesParams,
  options?: RequestInit,
): Promise<getV2BotMessageTimeseriesResponse> => {
  return customMutator<getV2BotMessageTimeseriesResponse>(
    getGetV2BotMessageTimeseriesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2BotMessageTimeseriesQueryKey = (
  params?: GetV2BotMessageTimeseriesParams,
) => {
  return [
    `/api/admin/bot-analytics/timeseries`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2BotMessageTimeseriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2BotMessageTimeseries>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotMessageTimeseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotMessageTimeseries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2BotMessageTimeseriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2BotMessageTimeseries>>
  > = ({ signal }) =>
    getV2BotMessageTimeseries(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2BotMessageTimeseries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2BotMessageTimeseriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2BotMessageTimeseries>>
>;
export type GetV2BotMessageTimeseriesQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2BotMessageTimeseries<
  TData = Awaited<ReturnType<typeof getV2BotMessageTimeseries>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2BotMessageTimeseriesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotMessageTimeseries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2BotMessageTimeseries>>,
          TError,
          Awaited<ReturnType<typeof getV2BotMessageTimeseries>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2BotMessageTimeseries<
  TData = Awaited<ReturnType<typeof getV2BotMessageTimeseries>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotMessageTimeseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotMessageTimeseries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2BotMessageTimeseries>>,
          TError,
          Awaited<ReturnType<typeof getV2BotMessageTimeseries>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2BotMessageTimeseries<
  TData = Awaited<ReturnType<typeof getV2BotMessageTimeseries>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotMessageTimeseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotMessageTimeseries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Bot Message Timeseries
 */

export function useGetV2BotMessageTimeseries<
  TData = Awaited<ReturnType<typeof getV2BotMessageTimeseries>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BotMessageTimeseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotMessageTimeseries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2BotMessageTimeseriesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Bot Message Timeseries
 */
export const prefetchGetV2BotMessageTimeseriesQuery = async <
  TData = Awaited<ReturnType<typeof getV2BotMessageTimeseries>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2BotMessageTimeseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BotMessageTimeseries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2BotMessageTimeseriesQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2TopServersByActivityResponse200 = {
  data: BotServerActivity[];
  status: 200;
};

export type getV2TopServersByActivityResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2TopServersByActivityResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2TopServersByActivityResponseSuccess =
  getV2TopServersByActivityResponse200 & {
    headers: Headers;
  };
export type getV2TopServersByActivityResponseError = (
  | getV2TopServersByActivityResponse401
  | getV2TopServersByActivityResponse422
) & {
  headers: Headers;
};

export type getV2TopServersByActivityResponse =
  | getV2TopServersByActivityResponseSuccess
  | getV2TopServersByActivityResponseError;

export const getGetV2TopServersByActivityUrl = (
  params?: GetV2TopServersByActivityParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/bot-analytics/top-servers?${stringifiedParams}`
    : `/api/admin/bot-analytics/top-servers`;
};

/**
 * @summary Top Servers by Activity
 */
export const getV2TopServersByActivity = async (
  params?: GetV2TopServersByActivityParams,
  options?: RequestInit,
): Promise<getV2TopServersByActivityResponse> => {
  return customMutator<getV2TopServersByActivityResponse>(
    getGetV2TopServersByActivityUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2TopServersByActivityQueryKey = (
  params?: GetV2TopServersByActivityParams,
) => {
  return [
    `/api/admin/bot-analytics/top-servers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2TopServersByActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2TopServersByActivity>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2TopServersByActivityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2TopServersByActivity>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2TopServersByActivityQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2TopServersByActivity>>
  > = ({ signal }) =>
    getV2TopServersByActivity(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2TopServersByActivity>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2TopServersByActivityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2TopServersByActivity>>
>;
export type GetV2TopServersByActivityQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2TopServersByActivity<
  TData = Awaited<ReturnType<typeof getV2TopServersByActivity>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2TopServersByActivityParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2TopServersByActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2TopServersByActivity>>,
          TError,
          Awaited<ReturnType<typeof getV2TopServersByActivity>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2TopServersByActivity<
  TData = Awaited<ReturnType<typeof getV2TopServersByActivity>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2TopServersByActivityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2TopServersByActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2TopServersByActivity>>,
          TError,
          Awaited<ReturnType<typeof getV2TopServersByActivity>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2TopServersByActivity<
  TData = Awaited<ReturnType<typeof getV2TopServersByActivity>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2TopServersByActivityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2TopServersByActivity>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Top Servers by Activity
 */

export function useGetV2TopServersByActivity<
  TData = Awaited<ReturnType<typeof getV2TopServersByActivity>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2TopServersByActivityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2TopServersByActivity>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2TopServersByActivityQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Top Servers by Activity
 */
export const prefetchGetV2TopServersByActivityQuery = async <
  TData = Awaited<ReturnType<typeof getV2TopServersByActivity>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2TopServersByActivityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2TopServersByActivity>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2TopServersByActivityQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetAgentDiagnosticsResponse200 = {
  data: AgentDiagnosticsResponse;
  status: 200;
};

export type getV2GetAgentDiagnosticsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetAgentDiagnosticsResponseSuccess =
  getV2GetAgentDiagnosticsResponse200 & {
    headers: Headers;
  };
export type getV2GetAgentDiagnosticsResponseError =
  getV2GetAgentDiagnosticsResponse401 & {
    headers: Headers;
  };

export type getV2GetAgentDiagnosticsResponse =
  | getV2GetAgentDiagnosticsResponseSuccess
  | getV2GetAgentDiagnosticsResponseError;

export const getGetV2GetAgentDiagnosticsUrl = () => {
  return `/api/admin/diagnostics/agents`;
};

/**
 * Get diagnostic information about agents.
 *
 * Returns:
 *     - agents_with_active_executions: Number of unique agents with running/queued executions
 *     - timestamp: Current timestamp
 * @summary Get Agent Diagnostics
 */
export const getV2GetAgentDiagnostics = async (
  options?: RequestInit,
): Promise<getV2GetAgentDiagnosticsResponse> => {
  return customMutator<getV2GetAgentDiagnosticsResponse>(
    getGetV2GetAgentDiagnosticsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetAgentDiagnosticsQueryKey = () => {
  return [`/api/admin/diagnostics/agents`] as const;
};

export const getGetV2GetAgentDiagnosticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetAgentDiagnosticsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>
  > = ({ signal }) => getV2GetAgentDiagnostics({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetAgentDiagnosticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>
>;
export type GetV2GetAgentDiagnosticsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV2GetAgentDiagnostics<
  TData = Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>,
          TError,
          Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetAgentDiagnostics<
  TData = Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>,
          TError,
          Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetAgentDiagnostics<
  TData = Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Agent Diagnostics
 */

export function useGetV2GetAgentDiagnostics<
  TData = Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetAgentDiagnosticsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Agent Diagnostics
 */
export const prefetchGetV2GetAgentDiagnosticsQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentDiagnostics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetAgentDiagnosticsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetExecutionDiagnosticsResponse200 = {
  data: ExecutionDiagnosticsResponse;
  status: 200;
};

export type getV2GetExecutionDiagnosticsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetExecutionDiagnosticsResponseSuccess =
  getV2GetExecutionDiagnosticsResponse200 & {
    headers: Headers;
  };
export type getV2GetExecutionDiagnosticsResponseError =
  getV2GetExecutionDiagnosticsResponse401 & {
    headers: Headers;
  };

export type getV2GetExecutionDiagnosticsResponse =
  | getV2GetExecutionDiagnosticsResponseSuccess
  | getV2GetExecutionDiagnosticsResponseError;

export const getGetV2GetExecutionDiagnosticsUrl = () => {
  return `/api/admin/diagnostics/executions`;
};

/**
 * Get comprehensive diagnostic information about execution status.
 *
 * Returns all execution metrics including:
 * - Current state (running, queued)
 * - Orphaned executions (>24h old, likely not in executor)
 * - Failure metrics (1h, 24h, rate)
 * - Long-running detection (stuck >1h, >24h)
 * - Stuck queued detection
 * - Throughput metrics (completions/hour)
 * - RabbitMQ queue depths
 * @summary Get Execution Diagnostics
 */
export const getV2GetExecutionDiagnostics = async (
  options?: RequestInit,
): Promise<getV2GetExecutionDiagnosticsResponse> => {
  return customMutator<getV2GetExecutionDiagnosticsResponse>(
    getGetV2GetExecutionDiagnosticsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetExecutionDiagnosticsQueryKey = () => {
  return [`/api/admin/diagnostics/executions`] as const;
};

export const getGetV2GetExecutionDiagnosticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetExecutionDiagnosticsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>
  > = ({ signal }) =>
    getV2GetExecutionDiagnostics({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetExecutionDiagnosticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>
>;
export type GetV2GetExecutionDiagnosticsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV2GetExecutionDiagnostics<
  TData = Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>,
          TError,
          Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetExecutionDiagnostics<
  TData = Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>,
          TError,
          Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetExecutionDiagnostics<
  TData = Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Execution Diagnostics
 */

export function useGetV2GetExecutionDiagnostics<
  TData = Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetExecutionDiagnosticsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Execution Diagnostics
 */
export const prefetchGetV2GetExecutionDiagnosticsQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionDiagnostics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetExecutionDiagnosticsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2CleanupAllOrphanedExecutionsResponse200 = {
  data: StopExecutionResponse;
  status: 200;
};

export type postV2CleanupAllOrphanedExecutionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2CleanupAllOrphanedExecutionsResponseSuccess =
  postV2CleanupAllOrphanedExecutionsResponse200 & {
    headers: Headers;
  };
export type postV2CleanupAllOrphanedExecutionsResponseError =
  postV2CleanupAllOrphanedExecutionsResponse401 & {
    headers: Headers;
  };

export type postV2CleanupAllOrphanedExecutionsResponse =
  | postV2CleanupAllOrphanedExecutionsResponseSuccess
  | postV2CleanupAllOrphanedExecutionsResponseError;

export const getPostV2CleanupAllOrphanedExecutionsUrl = () => {
  return `/api/admin/diagnostics/executions/cleanup-all-orphaned`;
};

/**
 * Cleanup ALL orphaned executions (>24h old) by directly updating DB status.
 * Operates on all executions, not just paginated results.
 *
 * Returns:
 *     Number of executions cleaned up and success message
 * @summary Cleanup ALL Orphaned Executions
 */
export const postV2CleanupAllOrphanedExecutions = async (
  options?: RequestInit,
): Promise<postV2CleanupAllOrphanedExecutionsResponse> => {
  return customMutator<postV2CleanupAllOrphanedExecutionsResponse>(
    getPostV2CleanupAllOrphanedExecutionsUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2CleanupAllOrphanedExecutionsMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2CleanupAllOrphanedExecutions>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2CleanupAllOrphanedExecutions>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postV2CleanupAllOrphanedExecutions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2CleanupAllOrphanedExecutions>>,
    void
  > = () => {
    return postV2CleanupAllOrphanedExecutions(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2CleanupAllOrphanedExecutionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2CleanupAllOrphanedExecutions>>
>;

export type PostV2CleanupAllOrphanedExecutionsMutationError =
  HTTP401NotAuthenticatedErrorResponse;

/**
 * @summary Cleanup ALL Orphaned Executions
 */
export const usePostV2CleanupAllOrphanedExecutions = <
  TError = HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2CleanupAllOrphanedExecutions>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2CleanupAllOrphanedExecutions>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostV2CleanupAllOrphanedExecutionsMutationOptions(options),
    queryClient,
  );
};
export type postV2CleanupAllStuckQueuedExecutionsResponse200 = {
  data: StopExecutionResponse;
  status: 200;
};

export type postV2CleanupAllStuckQueuedExecutionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2CleanupAllStuckQueuedExecutionsResponseSuccess =
  postV2CleanupAllStuckQueuedExecutionsResponse200 & {
    headers: Headers;
  };
export type postV2CleanupAllStuckQueuedExecutionsResponseError =
  postV2CleanupAllStuckQueuedExecutionsResponse401 & {
    headers: Headers;
  };

export type postV2CleanupAllStuckQueuedExecutionsResponse =
  | postV2CleanupAllStuckQueuedExecutionsResponseSuccess
  | postV2CleanupAllStuckQueuedExecutionsResponseError;

export const getPostV2CleanupAllStuckQueuedExecutionsUrl = () => {
  return `/api/admin/diagnostics/executions/cleanup-all-stuck-queued`;
};

/**
 * Cleanup ALL stuck queued executions (QUEUED >1h) by updating DB status (admin only).
 * Operates on entire dataset, not limited to pagination.
 *
 * Returns:
 *     Number of executions cleaned up and success message
 * @summary Cleanup ALL Stuck Queued Executions
 */
export const postV2CleanupAllStuckQueuedExecutions = async (
  options?: RequestInit,
): Promise<postV2CleanupAllStuckQueuedExecutionsResponse> => {
  return customMutator<postV2CleanupAllStuckQueuedExecutionsResponse>(
    getPostV2CleanupAllStuckQueuedExecutionsUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2CleanupAllStuckQueuedExecutionsMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2CleanupAllStuckQueuedExecutions>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2CleanupAllStuckQueuedExecutions>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postV2CleanupAllStuckQueuedExecutions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2CleanupAllStuckQueuedExecutions>>,
    void
  > = () => {
    return postV2CleanupAllStuckQueuedExecutions(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2CleanupAllStuckQueuedExecutionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2CleanupAllStuckQueuedExecutions>>
>;

export type PostV2CleanupAllStuckQueuedExecutionsMutationError =
  HTTP401NotAuthenticatedErrorResponse;

/**
 * @summary Cleanup ALL Stuck Queued Executions
 */
export const usePostV2CleanupAllStuckQueuedExecutions = <
  TError = HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2CleanupAllStuckQueuedExecutions>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2CleanupAllStuckQueuedExecutions>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostV2CleanupAllStuckQueuedExecutionsMutationOptions(options),
    queryClient,
  );
};
export type postV2CleanupOrphanedExecutionsResponse200 = {
  data: StopExecutionResponse;
  status: 200;
};

export type postV2CleanupOrphanedExecutionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2CleanupOrphanedExecutionsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2CleanupOrphanedExecutionsResponseSuccess =
  postV2CleanupOrphanedExecutionsResponse200 & {
    headers: Headers;
  };
export type postV2CleanupOrphanedExecutionsResponseError = (
  | postV2CleanupOrphanedExecutionsResponse401
  | postV2CleanupOrphanedExecutionsResponse422
) & {
  headers: Headers;
};

export type postV2CleanupOrphanedExecutionsResponse =
  | postV2CleanupOrphanedExecutionsResponseSuccess
  | postV2CleanupOrphanedExecutionsResponseError;

export const getPostV2CleanupOrphanedExecutionsUrl = () => {
  return `/api/admin/diagnostics/executions/cleanup-orphaned`;
};

/**
 * Cleanup orphaned executions by directly updating DB status (admin only).
 * For executions in DB but not actually running in executor (old/stale records).
 *
 * Args:
 *     request: Contains list of execution_ids to cleanup
 *
 * Returns:
 *     Number of executions cleaned up and success message
 * @summary Cleanup Orphaned Executions
 */
export const postV2CleanupOrphanedExecutions = async (
  stopExecutionsRequest: StopExecutionsRequest,
  options?: RequestInit,
): Promise<postV2CleanupOrphanedExecutionsResponse> => {
  return customMutator<postV2CleanupOrphanedExecutionsResponse>(
    getPostV2CleanupOrphanedExecutionsUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(stopExecutionsRequest),
    },
  );
};

export const getPostV2CleanupOrphanedExecutionsMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2CleanupOrphanedExecutions>>,
    TError,
    { data: StopExecutionsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2CleanupOrphanedExecutions>>,
  TError,
  { data: StopExecutionsRequest },
  TContext
> => {
  const mutationKey = ["postV2CleanupOrphanedExecutions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2CleanupOrphanedExecutions>>,
    { data: StopExecutionsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2CleanupOrphanedExecutions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2CleanupOrphanedExecutionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2CleanupOrphanedExecutions>>
>;
export type PostV2CleanupOrphanedExecutionsMutationBody = StopExecutionsRequest;
export type PostV2CleanupOrphanedExecutionsMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Cleanup Orphaned Executions
 */
export const usePostV2CleanupOrphanedExecutions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2CleanupOrphanedExecutions>>,
      TError,
      { data: StopExecutionsRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2CleanupOrphanedExecutions>>,
  TError,
  { data: StopExecutionsRequest },
  TContext
> => {
  return useMutation(
    getPostV2CleanupOrphanedExecutionsMutationOptions(options),
    queryClient,
  );
};
export type getV2ListFailedExecutionsResponse200 = {
  data: FailedExecutionsListResponse;
  status: 200;
};

export type getV2ListFailedExecutionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListFailedExecutionsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListFailedExecutionsResponseSuccess =
  getV2ListFailedExecutionsResponse200 & {
    headers: Headers;
  };
export type getV2ListFailedExecutionsResponseError = (
  | getV2ListFailedExecutionsResponse401
  | getV2ListFailedExecutionsResponse422
) & {
  headers: Headers;
};

export type getV2ListFailedExecutionsResponse =
  | getV2ListFailedExecutionsResponseSuccess
  | getV2ListFailedExecutionsResponseError;

export const getGetV2ListFailedExecutionsUrl = (
  params?: GetV2ListFailedExecutionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/diagnostics/executions/failed?${stringifiedParams}`
    : `/api/admin/diagnostics/executions/failed`;
};

/**
 * Get detailed list of failed executions.
 *
 * Args:
 *     limit: Maximum number of executions to return (default 100)
 *     offset: Number of executions to skip (default 0)
 *     hours: Number of hours to look back (default 24)
 *
 * Returns:
 *     List of failed executions with error details
 * @summary List Failed Executions
 */
export const getV2ListFailedExecutions = async (
  params?: GetV2ListFailedExecutionsParams,
  options?: RequestInit,
): Promise<getV2ListFailedExecutionsResponse> => {
  return customMutator<getV2ListFailedExecutionsResponse>(
    getGetV2ListFailedExecutionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListFailedExecutionsQueryKey = (
  params?: GetV2ListFailedExecutionsParams,
) => {
  return [
    `/api/admin/diagnostics/executions/failed`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListFailedExecutionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListFailedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListFailedExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListFailedExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListFailedExecutionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListFailedExecutions>>
  > = ({ signal }) =>
    getV2ListFailedExecutions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListFailedExecutions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListFailedExecutionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListFailedExecutions>>
>;
export type GetV2ListFailedExecutionsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListFailedExecutions<
  TData = Awaited<ReturnType<typeof getV2ListFailedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ListFailedExecutionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListFailedExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListFailedExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListFailedExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListFailedExecutions<
  TData = Awaited<ReturnType<typeof getV2ListFailedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListFailedExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListFailedExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListFailedExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListFailedExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListFailedExecutions<
  TData = Awaited<ReturnType<typeof getV2ListFailedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListFailedExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListFailedExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Failed Executions
 */

export function useGetV2ListFailedExecutions<
  TData = Awaited<ReturnType<typeof getV2ListFailedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListFailedExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListFailedExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListFailedExecutionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Failed Executions
 */
export const prefetchGetV2ListFailedExecutionsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListFailedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListFailedExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListFailedExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListFailedExecutionsQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListInvalidExecutionsResponse200 = {
  data: RunningExecutionsListResponse;
  status: 200;
};

export type getV2ListInvalidExecutionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListInvalidExecutionsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListInvalidExecutionsResponseSuccess =
  getV2ListInvalidExecutionsResponse200 & {
    headers: Headers;
  };
export type getV2ListInvalidExecutionsResponseError = (
  | getV2ListInvalidExecutionsResponse401
  | getV2ListInvalidExecutionsResponse422
) & {
  headers: Headers;
};

export type getV2ListInvalidExecutionsResponse =
  | getV2ListInvalidExecutionsResponseSuccess
  | getV2ListInvalidExecutionsResponseError;

export const getGetV2ListInvalidExecutionsUrl = (
  params?: GetV2ListInvalidExecutionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/diagnostics/executions/invalid?${stringifiedParams}`
    : `/api/admin/diagnostics/executions/invalid`;
};

/**
 * Get detailed list of executions in invalid states (READ-ONLY).
 *
 * Invalid states indicate data corruption and require manual investigation:
 * - QUEUED but has startedAt (impossible - can't start while queued)
 * - RUNNING but no startedAt (impossible - can't run without starting)
 *
 * ⚠️ NO BULK ACTIONS PROVIDED - These need case-by-case investigation.
 *
 * Each invalid execution likely has a different root cause (crashes, race conditions,
 * DB corruption). Investigate the execution history and logs to determine appropriate
 * action (manual cleanup, status fix, or leave as-is if system recovered).
 *
 * Args:
 *     limit: Maximum number of executions to return (default 100)
 *     offset: Number of executions to skip (default 0)
 *
 * Returns:
 *     List of invalid state executions with details
 * @summary List Invalid Executions
 */
export const getV2ListInvalidExecutions = async (
  params?: GetV2ListInvalidExecutionsParams,
  options?: RequestInit,
): Promise<getV2ListInvalidExecutionsResponse> => {
  return customMutator<getV2ListInvalidExecutionsResponse>(
    getGetV2ListInvalidExecutionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListInvalidExecutionsQueryKey = (
  params?: GetV2ListInvalidExecutionsParams,
) => {
  return [
    `/api/admin/diagnostics/executions/invalid`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListInvalidExecutionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListInvalidExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListInvalidExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListInvalidExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListInvalidExecutionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListInvalidExecutions>>
  > = ({ signal }) =>
    getV2ListInvalidExecutions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListInvalidExecutions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListInvalidExecutionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListInvalidExecutions>>
>;
export type GetV2ListInvalidExecutionsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListInvalidExecutions<
  TData = Awaited<ReturnType<typeof getV2ListInvalidExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ListInvalidExecutionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListInvalidExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListInvalidExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListInvalidExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListInvalidExecutions<
  TData = Awaited<ReturnType<typeof getV2ListInvalidExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListInvalidExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListInvalidExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListInvalidExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListInvalidExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListInvalidExecutions<
  TData = Awaited<ReturnType<typeof getV2ListInvalidExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListInvalidExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListInvalidExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Invalid Executions
 */

export function useGetV2ListInvalidExecutions<
  TData = Awaited<ReturnType<typeof getV2ListInvalidExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListInvalidExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListInvalidExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListInvalidExecutionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Invalid Executions
 */
export const prefetchGetV2ListInvalidExecutionsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListInvalidExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListInvalidExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListInvalidExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListInvalidExecutionsQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListLongRunningExecutionsResponse200 = {
  data: RunningExecutionsListResponse;
  status: 200;
};

export type getV2ListLongRunningExecutionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListLongRunningExecutionsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListLongRunningExecutionsResponseSuccess =
  getV2ListLongRunningExecutionsResponse200 & {
    headers: Headers;
  };
export type getV2ListLongRunningExecutionsResponseError = (
  | getV2ListLongRunningExecutionsResponse401
  | getV2ListLongRunningExecutionsResponse422
) & {
  headers: Headers;
};

export type getV2ListLongRunningExecutionsResponse =
  | getV2ListLongRunningExecutionsResponseSuccess
  | getV2ListLongRunningExecutionsResponseError;

export const getGetV2ListLongRunningExecutionsUrl = (
  params?: GetV2ListLongRunningExecutionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/diagnostics/executions/long-running?${stringifiedParams}`
    : `/api/admin/diagnostics/executions/long-running`;
};

/**
 * Get detailed list of long-running executions (RUNNING status >24h).
 *
 * Args:
 *     limit: Maximum number of executions to return (default 100)
 *     offset: Number of executions to skip (default 0)
 *
 * Returns:
 *     List of long-running executions with details
 * @summary List Long-Running Executions
 */
export const getV2ListLongRunningExecutions = async (
  params?: GetV2ListLongRunningExecutionsParams,
  options?: RequestInit,
): Promise<getV2ListLongRunningExecutionsResponse> => {
  return customMutator<getV2ListLongRunningExecutionsResponse>(
    getGetV2ListLongRunningExecutionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListLongRunningExecutionsQueryKey = (
  params?: GetV2ListLongRunningExecutionsParams,
) => {
  return [
    `/api/admin/diagnostics/executions/long-running`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListLongRunningExecutionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListLongRunningExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListLongRunningExecutionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>
  > = ({ signal }) =>
    getV2ListLongRunningExecutions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListLongRunningExecutionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>
>;
export type GetV2ListLongRunningExecutionsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListLongRunningExecutions<
  TData = Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ListLongRunningExecutionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListLongRunningExecutions<
  TData = Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListLongRunningExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListLongRunningExecutions<
  TData = Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListLongRunningExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Long-Running Executions
 */

export function useGetV2ListLongRunningExecutions<
  TData = Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListLongRunningExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListLongRunningExecutionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Long-Running Executions
 */
export const prefetchGetV2ListLongRunningExecutionsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListLongRunningExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListLongRunningExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListLongRunningExecutionsQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListOrphanedExecutionsResponse200 = {
  data: RunningExecutionsListResponse;
  status: 200;
};

export type getV2ListOrphanedExecutionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListOrphanedExecutionsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListOrphanedExecutionsResponseSuccess =
  getV2ListOrphanedExecutionsResponse200 & {
    headers: Headers;
  };
export type getV2ListOrphanedExecutionsResponseError = (
  | getV2ListOrphanedExecutionsResponse401
  | getV2ListOrphanedExecutionsResponse422
) & {
  headers: Headers;
};

export type getV2ListOrphanedExecutionsResponse =
  | getV2ListOrphanedExecutionsResponseSuccess
  | getV2ListOrphanedExecutionsResponseError;

export const getGetV2ListOrphanedExecutionsUrl = (
  params?: GetV2ListOrphanedExecutionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/diagnostics/executions/orphaned?${stringifiedParams}`
    : `/api/admin/diagnostics/executions/orphaned`;
};

/**
 * Get detailed list of orphaned executions (>24h old, likely not in executor).
 *
 * Args:
 *     limit: Maximum number of executions to return (default 100)
 *     offset: Number of executions to skip (default 0)
 *
 * Returns:
 *     List of orphaned executions with details
 * @summary List Orphaned Executions
 */
export const getV2ListOrphanedExecutions = async (
  params?: GetV2ListOrphanedExecutionsParams,
  options?: RequestInit,
): Promise<getV2ListOrphanedExecutionsResponse> => {
  return customMutator<getV2ListOrphanedExecutionsResponse>(
    getGetV2ListOrphanedExecutionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListOrphanedExecutionsQueryKey = (
  params?: GetV2ListOrphanedExecutionsParams,
) => {
  return [
    `/api/admin/diagnostics/executions/orphaned`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListOrphanedExecutionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListOrphanedExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListOrphanedExecutionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>
  > = ({ signal }) =>
    getV2ListOrphanedExecutions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListOrphanedExecutionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>
>;
export type GetV2ListOrphanedExecutionsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListOrphanedExecutions<
  TData = Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ListOrphanedExecutionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListOrphanedExecutions<
  TData = Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListOrphanedExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListOrphanedExecutions<
  TData = Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListOrphanedExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Orphaned Executions
 */

export function useGetV2ListOrphanedExecutions<
  TData = Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListOrphanedExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListOrphanedExecutionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Orphaned Executions
 */
export const prefetchGetV2ListOrphanedExecutionsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListOrphanedExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListOrphanedExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListOrphanedExecutionsQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2RequeueStuckExecutionResponse200 = {
  data: RequeueExecutionResponse;
  status: 200;
};

export type postV2RequeueStuckExecutionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2RequeueStuckExecutionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2RequeueStuckExecutionResponseSuccess =
  postV2RequeueStuckExecutionResponse200 & {
    headers: Headers;
  };
export type postV2RequeueStuckExecutionResponseError = (
  | postV2RequeueStuckExecutionResponse401
  | postV2RequeueStuckExecutionResponse422
) & {
  headers: Headers;
};

export type postV2RequeueStuckExecutionResponse =
  | postV2RequeueStuckExecutionResponseSuccess
  | postV2RequeueStuckExecutionResponseError;

export const getPostV2RequeueStuckExecutionUrl = () => {
  return `/api/admin/diagnostics/executions/requeue`;
};

/**
 * Requeue a stuck QUEUED execution (admin only).
 *
 * Uses add_graph_execution with existing graph_exec_id to requeue.
 *
 * ⚠️ WARNING: Only use for stuck executions. This will re-execute and may cost credits.
 *
 * Args:
 *     request: Contains execution_id to requeue
 *
 * Returns:
 *     Success status and message
 * @summary Requeue Stuck Execution
 */
export const postV2RequeueStuckExecution = async (
  stopExecutionRequest: StopExecutionRequest,
  options?: RequestInit,
): Promise<postV2RequeueStuckExecutionResponse> => {
  return customMutator<postV2RequeueStuckExecutionResponse>(
    getPostV2RequeueStuckExecutionUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(stopExecutionRequest),
    },
  );
};

export const getPostV2RequeueStuckExecutionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2RequeueStuckExecution>>,
    TError,
    { data: StopExecutionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2RequeueStuckExecution>>,
  TError,
  { data: StopExecutionRequest },
  TContext
> => {
  const mutationKey = ["postV2RequeueStuckExecution"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2RequeueStuckExecution>>,
    { data: StopExecutionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2RequeueStuckExecution(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2RequeueStuckExecutionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2RequeueStuckExecution>>
>;
export type PostV2RequeueStuckExecutionMutationBody = StopExecutionRequest;
export type PostV2RequeueStuckExecutionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Requeue Stuck Execution
 */
export const usePostV2RequeueStuckExecution = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2RequeueStuckExecution>>,
      TError,
      { data: StopExecutionRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2RequeueStuckExecution>>,
  TError,
  { data: StopExecutionRequest },
  TContext
> => {
  return useMutation(
    getPostV2RequeueStuckExecutionMutationOptions(options),
    queryClient,
  );
};
export type postV2RequeueAllStuckQueuedExecutionsResponse200 = {
  data: RequeueExecutionResponse;
  status: 200;
};

export type postV2RequeueAllStuckQueuedExecutionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2RequeueAllStuckQueuedExecutionsResponseSuccess =
  postV2RequeueAllStuckQueuedExecutionsResponse200 & {
    headers: Headers;
  };
export type postV2RequeueAllStuckQueuedExecutionsResponseError =
  postV2RequeueAllStuckQueuedExecutionsResponse401 & {
    headers: Headers;
  };

export type postV2RequeueAllStuckQueuedExecutionsResponse =
  | postV2RequeueAllStuckQueuedExecutionsResponseSuccess
  | postV2RequeueAllStuckQueuedExecutionsResponseError;

export const getPostV2RequeueAllStuckQueuedExecutionsUrl = () => {
  return `/api/admin/diagnostics/executions/requeue-all-stuck`;
};

/**
 * Requeue ALL stuck queued executions (QUEUED >1h) by publishing to RabbitMQ.
 * Operates on all executions, not just paginated results.
 *
 * Uses add_graph_execution with existing graph_exec_id to requeue.
 *
 * ⚠️ WARNING: This will re-execute ALL stuck executions and may cost significant credits.
 *
 * Returns:
 *     Number of executions requeued and success message
 * @summary Requeue ALL Stuck Queued Executions
 */
export const postV2RequeueAllStuckQueuedExecutions = async (
  options?: RequestInit,
): Promise<postV2RequeueAllStuckQueuedExecutionsResponse> => {
  return customMutator<postV2RequeueAllStuckQueuedExecutionsResponse>(
    getPostV2RequeueAllStuckQueuedExecutionsUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2RequeueAllStuckQueuedExecutionsMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2RequeueAllStuckQueuedExecutions>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2RequeueAllStuckQueuedExecutions>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postV2RequeueAllStuckQueuedExecutions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2RequeueAllStuckQueuedExecutions>>,
    void
  > = () => {
    return postV2RequeueAllStuckQueuedExecutions(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2RequeueAllStuckQueuedExecutionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2RequeueAllStuckQueuedExecutions>>
>;

export type PostV2RequeueAllStuckQueuedExecutionsMutationError =
  HTTP401NotAuthenticatedErrorResponse;

/**
 * @summary Requeue ALL Stuck Queued Executions
 */
export const usePostV2RequeueAllStuckQueuedExecutions = <
  TError = HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2RequeueAllStuckQueuedExecutions>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2RequeueAllStuckQueuedExecutions>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostV2RequeueAllStuckQueuedExecutionsMutationOptions(options),
    queryClient,
  );
};
export type postV2RequeueMultipleStuckExecutionsResponse200 = {
  data: RequeueExecutionResponse;
  status: 200;
};

export type postV2RequeueMultipleStuckExecutionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2RequeueMultipleStuckExecutionsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2RequeueMultipleStuckExecutionsResponseSuccess =
  postV2RequeueMultipleStuckExecutionsResponse200 & {
    headers: Headers;
  };
export type postV2RequeueMultipleStuckExecutionsResponseError = (
  | postV2RequeueMultipleStuckExecutionsResponse401
  | postV2RequeueMultipleStuckExecutionsResponse422
) & {
  headers: Headers;
};

export type postV2RequeueMultipleStuckExecutionsResponse =
  | postV2RequeueMultipleStuckExecutionsResponseSuccess
  | postV2RequeueMultipleStuckExecutionsResponseError;

export const getPostV2RequeueMultipleStuckExecutionsUrl = () => {
  return `/api/admin/diagnostics/executions/requeue-bulk`;
};

/**
 * Requeue multiple stuck QUEUED executions (admin only).
 *
 * Uses add_graph_execution with existing graph_exec_id to requeue.
 *
 * ⚠️ WARNING: Only use for stuck executions. This will re-execute and may cost credits.
 *
 * Args:
 *     request: Contains list of execution_ids to requeue
 *
 * Returns:
 *     Number of executions requeued and success message
 * @summary Requeue Multiple Stuck Executions
 */
export const postV2RequeueMultipleStuckExecutions = async (
  stopExecutionsRequest: StopExecutionsRequest,
  options?: RequestInit,
): Promise<postV2RequeueMultipleStuckExecutionsResponse> => {
  return customMutator<postV2RequeueMultipleStuckExecutionsResponse>(
    getPostV2RequeueMultipleStuckExecutionsUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(stopExecutionsRequest),
    },
  );
};

export const getPostV2RequeueMultipleStuckExecutionsMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2RequeueMultipleStuckExecutions>>,
    TError,
    { data: StopExecutionsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2RequeueMultipleStuckExecutions>>,
  TError,
  { data: StopExecutionsRequest },
  TContext
> => {
  const mutationKey = ["postV2RequeueMultipleStuckExecutions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2RequeueMultipleStuckExecutions>>,
    { data: StopExecutionsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2RequeueMultipleStuckExecutions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2RequeueMultipleStuckExecutionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2RequeueMultipleStuckExecutions>>
>;
export type PostV2RequeueMultipleStuckExecutionsMutationBody =
  StopExecutionsRequest;
export type PostV2RequeueMultipleStuckExecutionsMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Requeue Multiple Stuck Executions
 */
export const usePostV2RequeueMultipleStuckExecutions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2RequeueMultipleStuckExecutions>>,
      TError,
      { data: StopExecutionsRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2RequeueMultipleStuckExecutions>>,
  TError,
  { data: StopExecutionsRequest },
  TContext
> => {
  return useMutation(
    getPostV2RequeueMultipleStuckExecutionsMutationOptions(options),
    queryClient,
  );
};
export type getV2ListRunningExecutionsResponse200 = {
  data: RunningExecutionsListResponse;
  status: 200;
};

export type getV2ListRunningExecutionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListRunningExecutionsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListRunningExecutionsResponseSuccess =
  getV2ListRunningExecutionsResponse200 & {
    headers: Headers;
  };
export type getV2ListRunningExecutionsResponseError = (
  | getV2ListRunningExecutionsResponse401
  | getV2ListRunningExecutionsResponse422
) & {
  headers: Headers;
};

export type getV2ListRunningExecutionsResponse =
  | getV2ListRunningExecutionsResponseSuccess
  | getV2ListRunningExecutionsResponseError;

export const getGetV2ListRunningExecutionsUrl = (
  params?: GetV2ListRunningExecutionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/diagnostics/executions/running?${stringifiedParams}`
    : `/api/admin/diagnostics/executions/running`;
};

/**
 * Get detailed list of running and queued executions (recent, likely active).
 *
 * Args:
 *     limit: Maximum number of executions to return (default 100)
 *     offset: Number of executions to skip (default 0)
 *
 * Returns:
 *     List of running executions with details
 * @summary List Running Executions
 */
export const getV2ListRunningExecutions = async (
  params?: GetV2ListRunningExecutionsParams,
  options?: RequestInit,
): Promise<getV2ListRunningExecutionsResponse> => {
  return customMutator<getV2ListRunningExecutionsResponse>(
    getGetV2ListRunningExecutionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListRunningExecutionsQueryKey = (
  params?: GetV2ListRunningExecutionsParams,
) => {
  return [
    `/api/admin/diagnostics/executions/running`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListRunningExecutionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListRunningExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListRunningExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListRunningExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListRunningExecutionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListRunningExecutions>>
  > = ({ signal }) =>
    getV2ListRunningExecutions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListRunningExecutions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListRunningExecutionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListRunningExecutions>>
>;
export type GetV2ListRunningExecutionsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListRunningExecutions<
  TData = Awaited<ReturnType<typeof getV2ListRunningExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ListRunningExecutionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListRunningExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListRunningExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListRunningExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListRunningExecutions<
  TData = Awaited<ReturnType<typeof getV2ListRunningExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListRunningExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListRunningExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListRunningExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListRunningExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListRunningExecutions<
  TData = Awaited<ReturnType<typeof getV2ListRunningExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListRunningExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListRunningExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Running Executions
 */

export function useGetV2ListRunningExecutions<
  TData = Awaited<ReturnType<typeof getV2ListRunningExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListRunningExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListRunningExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListRunningExecutionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Running Executions
 */
export const prefetchGetV2ListRunningExecutionsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListRunningExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListRunningExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListRunningExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListRunningExecutionsQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2StopSingleExecutionResponse200 = {
  data: StopExecutionResponse;
  status: 200;
};

export type postV2StopSingleExecutionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2StopSingleExecutionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2StopSingleExecutionResponseSuccess =
  postV2StopSingleExecutionResponse200 & {
    headers: Headers;
  };
export type postV2StopSingleExecutionResponseError = (
  | postV2StopSingleExecutionResponse401
  | postV2StopSingleExecutionResponse422
) & {
  headers: Headers;
};

export type postV2StopSingleExecutionResponse =
  | postV2StopSingleExecutionResponseSuccess
  | postV2StopSingleExecutionResponseError;

export const getPostV2StopSingleExecutionUrl = () => {
  return `/api/admin/diagnostics/executions/stop`;
};

/**
 * Stop a single execution (admin only).
 *
 * Uses robust stop_graph_execution which cascades to children and waits for termination.
 *
 * Args:
 *     request: Contains execution_id to stop
 *
 * Returns:
 *     Success status and message
 * @summary Stop Single Execution
 */
export const postV2StopSingleExecution = async (
  stopExecutionRequest: StopExecutionRequest,
  options?: RequestInit,
): Promise<postV2StopSingleExecutionResponse> => {
  return customMutator<postV2StopSingleExecutionResponse>(
    getPostV2StopSingleExecutionUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(stopExecutionRequest),
    },
  );
};

export const getPostV2StopSingleExecutionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2StopSingleExecution>>,
    TError,
    { data: StopExecutionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2StopSingleExecution>>,
  TError,
  { data: StopExecutionRequest },
  TContext
> => {
  const mutationKey = ["postV2StopSingleExecution"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2StopSingleExecution>>,
    { data: StopExecutionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2StopSingleExecution(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2StopSingleExecutionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2StopSingleExecution>>
>;
export type PostV2StopSingleExecutionMutationBody = StopExecutionRequest;
export type PostV2StopSingleExecutionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Stop Single Execution
 */
export const usePostV2StopSingleExecution = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2StopSingleExecution>>,
      TError,
      { data: StopExecutionRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2StopSingleExecution>>,
  TError,
  { data: StopExecutionRequest },
  TContext
> => {
  return useMutation(
    getPostV2StopSingleExecutionMutationOptions(options),
    queryClient,
  );
};
export type postV2StopAllLongRunningExecutionsResponse200 = {
  data: StopExecutionResponse;
  status: 200;
};

export type postV2StopAllLongRunningExecutionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2StopAllLongRunningExecutionsResponseSuccess =
  postV2StopAllLongRunningExecutionsResponse200 & {
    headers: Headers;
  };
export type postV2StopAllLongRunningExecutionsResponseError =
  postV2StopAllLongRunningExecutionsResponse401 & {
    headers: Headers;
  };

export type postV2StopAllLongRunningExecutionsResponse =
  | postV2StopAllLongRunningExecutionsResponseSuccess
  | postV2StopAllLongRunningExecutionsResponseError;

export const getPostV2StopAllLongRunningExecutionsUrl = () => {
  return `/api/admin/diagnostics/executions/stop-all-long-running`;
};

/**
 * Stop ALL long-running executions (RUNNING >24h) by sending cancel signals (admin only).
 * Operates on entire dataset, not limited to pagination.
 *
 * Returns:
 *     Number of executions stopped and success message
 * @summary Stop ALL Long-Running Executions
 */
export const postV2StopAllLongRunningExecutions = async (
  options?: RequestInit,
): Promise<postV2StopAllLongRunningExecutionsResponse> => {
  return customMutator<postV2StopAllLongRunningExecutionsResponse>(
    getPostV2StopAllLongRunningExecutionsUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2StopAllLongRunningExecutionsMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2StopAllLongRunningExecutions>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2StopAllLongRunningExecutions>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postV2StopAllLongRunningExecutions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2StopAllLongRunningExecutions>>,
    void
  > = () => {
    return postV2StopAllLongRunningExecutions(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2StopAllLongRunningExecutionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2StopAllLongRunningExecutions>>
>;

export type PostV2StopAllLongRunningExecutionsMutationError =
  HTTP401NotAuthenticatedErrorResponse;

/**
 * @summary Stop ALL Long-Running Executions
 */
export const usePostV2StopAllLongRunningExecutions = <
  TError = HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2StopAllLongRunningExecutions>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2StopAllLongRunningExecutions>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostV2StopAllLongRunningExecutionsMutationOptions(options),
    queryClient,
  );
};
export type postV2StopMultipleExecutionsResponse200 = {
  data: StopExecutionResponse;
  status: 200;
};

export type postV2StopMultipleExecutionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2StopMultipleExecutionsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2StopMultipleExecutionsResponseSuccess =
  postV2StopMultipleExecutionsResponse200 & {
    headers: Headers;
  };
export type postV2StopMultipleExecutionsResponseError = (
  | postV2StopMultipleExecutionsResponse401
  | postV2StopMultipleExecutionsResponse422
) & {
  headers: Headers;
};

export type postV2StopMultipleExecutionsResponse =
  | postV2StopMultipleExecutionsResponseSuccess
  | postV2StopMultipleExecutionsResponseError;

export const getPostV2StopMultipleExecutionsUrl = () => {
  return `/api/admin/diagnostics/executions/stop-bulk`;
};

/**
 * Stop multiple active executions (admin only).
 *
 * Uses robust stop_graph_execution which cascades to children and waits for termination.
 *
 * Args:
 *     request: Contains list of execution_ids to stop
 *
 * Returns:
 *     Number of executions stopped and success message
 * @summary Stop Multiple Executions
 */
export const postV2StopMultipleExecutions = async (
  stopExecutionsRequest: StopExecutionsRequest,
  options?: RequestInit,
): Promise<postV2StopMultipleExecutionsResponse> => {
  return customMutator<postV2StopMultipleExecutionsResponse>(
    getPostV2StopMultipleExecutionsUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(stopExecutionsRequest),
    },
  );
};

export const getPostV2StopMultipleExecutionsMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2StopMultipleExecutions>>,
    TError,
    { data: StopExecutionsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2StopMultipleExecutions>>,
  TError,
  { data: StopExecutionsRequest },
  TContext
> => {
  const mutationKey = ["postV2StopMultipleExecutions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2StopMultipleExecutions>>,
    { data: StopExecutionsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2StopMultipleExecutions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2StopMultipleExecutionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2StopMultipleExecutions>>
>;
export type PostV2StopMultipleExecutionsMutationBody = StopExecutionsRequest;
export type PostV2StopMultipleExecutionsMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Stop Multiple Executions
 */
export const usePostV2StopMultipleExecutions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2StopMultipleExecutions>>,
      TError,
      { data: StopExecutionsRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2StopMultipleExecutions>>,
  TError,
  { data: StopExecutionsRequest },
  TContext
> => {
  return useMutation(
    getPostV2StopMultipleExecutionsMutationOptions(options),
    queryClient,
  );
};
export type getV2ListStuckQueuedExecutionsResponse200 = {
  data: RunningExecutionsListResponse;
  status: 200;
};

export type getV2ListStuckQueuedExecutionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListStuckQueuedExecutionsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListStuckQueuedExecutionsResponseSuccess =
  getV2ListStuckQueuedExecutionsResponse200 & {
    headers: Headers;
  };
export type getV2ListStuckQueuedExecutionsResponseError = (
  | getV2ListStuckQueuedExecutionsResponse401
  | getV2ListStuckQueuedExecutionsResponse422
) & {
  headers: Headers;
};

export type getV2ListStuckQueuedExecutionsResponse =
  | getV2ListStuckQueuedExecutionsResponseSuccess
  | getV2ListStuckQueuedExecutionsResponseError;

export const getGetV2ListStuckQueuedExecutionsUrl = (
  params?: GetV2ListStuckQueuedExecutionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/diagnostics/executions/stuck-queued?${stringifiedParams}`
    : `/api/admin/diagnostics/executions/stuck-queued`;
};

/**
 * Get detailed list of stuck queued executions (QUEUED >1h, never started).
 *
 * Args:
 *     limit: Maximum number of executions to return (default 100)
 *     offset: Number of executions to skip (default 0)
 *
 * Returns:
 *     List of stuck queued executions with details
 * @summary List Stuck Queued Executions
 */
export const getV2ListStuckQueuedExecutions = async (
  params?: GetV2ListStuckQueuedExecutionsParams,
  options?: RequestInit,
): Promise<getV2ListStuckQueuedExecutionsResponse> => {
  return customMutator<getV2ListStuckQueuedExecutionsResponse>(
    getGetV2ListStuckQueuedExecutionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListStuckQueuedExecutionsQueryKey = (
  params?: GetV2ListStuckQueuedExecutionsParams,
) => {
  return [
    `/api/admin/diagnostics/executions/stuck-queued`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListStuckQueuedExecutionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListStuckQueuedExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListStuckQueuedExecutionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>
  > = ({ signal }) =>
    getV2ListStuckQueuedExecutions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListStuckQueuedExecutionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>
>;
export type GetV2ListStuckQueuedExecutionsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListStuckQueuedExecutions<
  TData = Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ListStuckQueuedExecutionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListStuckQueuedExecutions<
  TData = Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListStuckQueuedExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListStuckQueuedExecutions<
  TData = Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListStuckQueuedExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Stuck Queued Executions
 */

export function useGetV2ListStuckQueuedExecutions<
  TData = Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListStuckQueuedExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListStuckQueuedExecutionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Stuck Queued Executions
 */
export const prefetchGetV2ListStuckQueuedExecutionsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListStuckQueuedExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStuckQueuedExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListStuckQueuedExecutionsQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetScheduleDiagnosticsResponse200 = {
  data: ScheduleHealthMetrics;
  status: 200;
};

export type getV2GetScheduleDiagnosticsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetScheduleDiagnosticsResponseSuccess =
  getV2GetScheduleDiagnosticsResponse200 & {
    headers: Headers;
  };
export type getV2GetScheduleDiagnosticsResponseError =
  getV2GetScheduleDiagnosticsResponse401 & {
    headers: Headers;
  };

export type getV2GetScheduleDiagnosticsResponse =
  | getV2GetScheduleDiagnosticsResponseSuccess
  | getV2GetScheduleDiagnosticsResponseError;

export const getGetV2GetScheduleDiagnosticsUrl = () => {
  return `/api/admin/diagnostics/schedules`;
};

/**
 * Get comprehensive diagnostic information about schedule health.
 *
 * Returns schedule metrics including:
 * - Total schedules (user vs system)
 * - Orphaned schedules by category
 * - Upcoming executions
 * @summary Get Schedule Diagnostics
 */
export const getV2GetScheduleDiagnostics = async (
  options?: RequestInit,
): Promise<getV2GetScheduleDiagnosticsResponse> => {
  return customMutator<getV2GetScheduleDiagnosticsResponse>(
    getGetV2GetScheduleDiagnosticsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetScheduleDiagnosticsQueryKey = () => {
  return [`/api/admin/diagnostics/schedules`] as const;
};

export const getGetV2GetScheduleDiagnosticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetScheduleDiagnosticsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>
  > = ({ signal }) =>
    getV2GetScheduleDiagnostics({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetScheduleDiagnosticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>
>;
export type GetV2GetScheduleDiagnosticsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV2GetScheduleDiagnostics<
  TData = Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>,
          TError,
          Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetScheduleDiagnostics<
  TData = Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>,
          TError,
          Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetScheduleDiagnostics<
  TData = Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Schedule Diagnostics
 */

export function useGetV2GetScheduleDiagnostics<
  TData = Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetScheduleDiagnosticsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Schedule Diagnostics
 */
export const prefetchGetV2GetScheduleDiagnosticsQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetScheduleDiagnostics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetScheduleDiagnosticsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListAllUserSchedulesResponse200 = {
  data: SchedulesListResponse;
  status: 200;
};

export type getV2ListAllUserSchedulesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListAllUserSchedulesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListAllUserSchedulesResponseSuccess =
  getV2ListAllUserSchedulesResponse200 & {
    headers: Headers;
  };
export type getV2ListAllUserSchedulesResponseError = (
  | getV2ListAllUserSchedulesResponse401
  | getV2ListAllUserSchedulesResponse422
) & {
  headers: Headers;
};

export type getV2ListAllUserSchedulesResponse =
  | getV2ListAllUserSchedulesResponseSuccess
  | getV2ListAllUserSchedulesResponseError;

export const getGetV2ListAllUserSchedulesUrl = (
  params?: GetV2ListAllUserSchedulesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/diagnostics/schedules/all?${stringifiedParams}`
    : `/api/admin/diagnostics/schedules/all`;
};

/**
 * Get detailed list of all user schedules (excludes system monitoring jobs).
 *
 * Args:
 *     limit: Maximum number of schedules to return (default 100)
 *     offset: Number of schedules to skip (default 0)
 *
 * Returns:
 *     List of schedules with details
 * @summary List All User Schedules
 */
export const getV2ListAllUserSchedules = async (
  params?: GetV2ListAllUserSchedulesParams,
  options?: RequestInit,
): Promise<getV2ListAllUserSchedulesResponse> => {
  return customMutator<getV2ListAllUserSchedulesResponse>(
    getGetV2ListAllUserSchedulesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListAllUserSchedulesQueryKey = (
  params?: GetV2ListAllUserSchedulesParams,
) => {
  return [
    `/api/admin/diagnostics/schedules/all`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListAllUserSchedulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListAllUserSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListAllUserSchedulesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListAllUserSchedules>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListAllUserSchedulesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListAllUserSchedules>>
  > = ({ signal }) =>
    getV2ListAllUserSchedules(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListAllUserSchedules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListAllUserSchedulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListAllUserSchedules>>
>;
export type GetV2ListAllUserSchedulesQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListAllUserSchedules<
  TData = Awaited<ReturnType<typeof getV2ListAllUserSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ListAllUserSchedulesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListAllUserSchedules>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListAllUserSchedules>>,
          TError,
          Awaited<ReturnType<typeof getV2ListAllUserSchedules>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListAllUserSchedules<
  TData = Awaited<ReturnType<typeof getV2ListAllUserSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListAllUserSchedulesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListAllUserSchedules>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListAllUserSchedules>>,
          TError,
          Awaited<ReturnType<typeof getV2ListAllUserSchedules>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListAllUserSchedules<
  TData = Awaited<ReturnType<typeof getV2ListAllUserSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListAllUserSchedulesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListAllUserSchedules>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List All User Schedules
 */

export function useGetV2ListAllUserSchedules<
  TData = Awaited<ReturnType<typeof getV2ListAllUserSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListAllUserSchedulesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListAllUserSchedules>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListAllUserSchedulesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List All User Schedules
 */
export const prefetchGetV2ListAllUserSchedulesQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListAllUserSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListAllUserSchedulesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListAllUserSchedules>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListAllUserSchedulesQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2CleanupOrphanedSchedulesResponse200 = {
  data: ScheduleCleanupResponse;
  status: 200;
};

export type postV2CleanupOrphanedSchedulesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2CleanupOrphanedSchedulesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2CleanupOrphanedSchedulesResponseSuccess =
  postV2CleanupOrphanedSchedulesResponse200 & {
    headers: Headers;
  };
export type postV2CleanupOrphanedSchedulesResponseError = (
  | postV2CleanupOrphanedSchedulesResponse401
  | postV2CleanupOrphanedSchedulesResponse422
) & {
  headers: Headers;
};

export type postV2CleanupOrphanedSchedulesResponse =
  | postV2CleanupOrphanedSchedulesResponseSuccess
  | postV2CleanupOrphanedSchedulesResponseError;

export const getPostV2CleanupOrphanedSchedulesUrl = () => {
  return `/api/admin/diagnostics/schedules/cleanup-orphaned`;
};

/**
 * Cleanup orphaned schedules by deleting from scheduler (admin only).
 *
 * Args:
 *     request: Contains list of schedule_ids to delete
 *
 * Returns:
 *     Number of schedules deleted and success message
 * @summary Cleanup Orphaned Schedules
 */
export const postV2CleanupOrphanedSchedules = async (
  scheduleCleanupRequest: ScheduleCleanupRequest,
  options?: RequestInit,
): Promise<postV2CleanupOrphanedSchedulesResponse> => {
  return customMutator<postV2CleanupOrphanedSchedulesResponse>(
    getPostV2CleanupOrphanedSchedulesUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(scheduleCleanupRequest),
    },
  );
};

export const getPostV2CleanupOrphanedSchedulesMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2CleanupOrphanedSchedules>>,
    TError,
    { data: ScheduleCleanupRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2CleanupOrphanedSchedules>>,
  TError,
  { data: ScheduleCleanupRequest },
  TContext
> => {
  const mutationKey = ["postV2CleanupOrphanedSchedules"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2CleanupOrphanedSchedules>>,
    { data: ScheduleCleanupRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2CleanupOrphanedSchedules(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2CleanupOrphanedSchedulesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2CleanupOrphanedSchedules>>
>;
export type PostV2CleanupOrphanedSchedulesMutationBody = ScheduleCleanupRequest;
export type PostV2CleanupOrphanedSchedulesMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Cleanup Orphaned Schedules
 */
export const usePostV2CleanupOrphanedSchedules = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2CleanupOrphanedSchedules>>,
      TError,
      { data: ScheduleCleanupRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2CleanupOrphanedSchedules>>,
  TError,
  { data: ScheduleCleanupRequest },
  TContext
> => {
  return useMutation(
    getPostV2CleanupOrphanedSchedulesMutationOptions(options),
    queryClient,
  );
};
export type getV2ListOrphanedSchedulesResponse200 = {
  data: OrphanedSchedulesListResponse;
  status: 200;
};

export type getV2ListOrphanedSchedulesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListOrphanedSchedulesResponseSuccess =
  getV2ListOrphanedSchedulesResponse200 & {
    headers: Headers;
  };
export type getV2ListOrphanedSchedulesResponseError =
  getV2ListOrphanedSchedulesResponse401 & {
    headers: Headers;
  };

export type getV2ListOrphanedSchedulesResponse =
  | getV2ListOrphanedSchedulesResponseSuccess
  | getV2ListOrphanedSchedulesResponseError;

export const getGetV2ListOrphanedSchedulesUrl = () => {
  return `/api/admin/diagnostics/schedules/orphaned`;
};

/**
 * Get detailed list of orphaned schedules with orphan reasons.
 *
 * Returns:
 *     List of orphaned schedules categorized by orphan type
 * @summary List Orphaned Schedules
 */
export const getV2ListOrphanedSchedules = async (
  options?: RequestInit,
): Promise<getV2ListOrphanedSchedulesResponse> => {
  return customMutator<getV2ListOrphanedSchedulesResponse>(
    getGetV2ListOrphanedSchedulesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListOrphanedSchedulesQueryKey = () => {
  return [`/api/admin/diagnostics/schedules/orphaned`] as const;
};

export const getGetV2ListOrphanedSchedulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListOrphanedSchedulesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>
  > = ({ signal }) => getV2ListOrphanedSchedules({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListOrphanedSchedulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>
>;
export type GetV2ListOrphanedSchedulesQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV2ListOrphanedSchedules<
  TData = Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>,
          TError,
          Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListOrphanedSchedules<
  TData = Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>,
          TError,
          Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListOrphanedSchedules<
  TData = Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Orphaned Schedules
 */

export function useGetV2ListOrphanedSchedules<
  TData = Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListOrphanedSchedulesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Orphaned Schedules
 */
export const prefetchGetV2ListOrphanedSchedulesQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListOrphanedSchedules>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListOrphanedSchedulesQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2GenerateTestDataResponse200 = {
  data: GenerateTestDataResponse;
  status: 200;
};

export type postV2GenerateTestDataResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2GenerateTestDataResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2GenerateTestDataResponseSuccess =
  postV2GenerateTestDataResponse200 & {
    headers: Headers;
  };
export type postV2GenerateTestDataResponseError = (
  | postV2GenerateTestDataResponse401
  | postV2GenerateTestDataResponse422
) & {
  headers: Headers;
};

export type postV2GenerateTestDataResponse =
  | postV2GenerateTestDataResponseSuccess
  | postV2GenerateTestDataResponseError;

export const getPostV2GenerateTestDataUrl = () => {
  return `/api/admin/generate-test-data`;
};

/**
 * Generate test data for the platform.
 *
 * This endpoint runs the test data generation scripts to populate the database
 * with sample users, agents, graphs, executions, store listings, and more.
 *
 * Available script types:
 * - `e2e`: Creates a set of test users with graphs, library agents, presets,
 *          and store submissions. Uses API functions for better compatibility.
 * - `full`: Creates 100+ users with comprehensive test data using direct Prisma
 *           calls. Generates more data but may take longer.
 *
 * **Warning**: This will add significant data to your database. Use with caution.
 * **Note**: This endpoint is only available in local environments; requests from
 * any shared/cloud environment are rejected and alerted on.
 * @summary Generate Test Data
 */
export const postV2GenerateTestData = async (
  generateTestDataRequest: GenerateTestDataRequest,
  options?: RequestInit,
): Promise<postV2GenerateTestDataResponse> => {
  return customMutator<postV2GenerateTestDataResponse>(
    getPostV2GenerateTestDataUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(generateTestDataRequest),
    },
  );
};

export const getPostV2GenerateTestDataMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2GenerateTestData>>,
    TError,
    { data: GenerateTestDataRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2GenerateTestData>>,
  TError,
  { data: GenerateTestDataRequest },
  TContext
> => {
  const mutationKey = ["postV2GenerateTestData"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2GenerateTestData>>,
    { data: GenerateTestDataRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2GenerateTestData(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2GenerateTestDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2GenerateTestData>>
>;
export type PostV2GenerateTestDataMutationBody = GenerateTestDataRequest;
export type PostV2GenerateTestDataMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Generate Test Data
 */
export const usePostV2GenerateTestData = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2GenerateTestData>>,
      TError,
      { data: GenerateTestDataRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2GenerateTestData>>,
  TError,
  { data: GenerateTestDataRequest },
  TContext
> => {
  return useMutation(
    getPostV2GenerateTestDataMutationOptions(options),
    queryClient,
  );
};
export type postV2NotifyImpersonationStartResponse200 = {
  data: ImpersonationNotifyResponse;
  status: 200;
};

export type postV2NotifyImpersonationStartResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2NotifyImpersonationStartResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2NotifyImpersonationStartResponseSuccess =
  postV2NotifyImpersonationStartResponse200 & {
    headers: Headers;
  };
export type postV2NotifyImpersonationStartResponseError = (
  | postV2NotifyImpersonationStartResponse401
  | postV2NotifyImpersonationStartResponse422
) & {
  headers: Headers;
};

export type postV2NotifyImpersonationStartResponse =
  | postV2NotifyImpersonationStartResponseSuccess
  | postV2NotifyImpersonationStartResponseError;

export const getPostV2NotifyImpersonationStartUrl = () => {
  return `/api/admin/impersonation/notify`;
};

/**
 * Emit a Discord audit alert when an admin starts impersonating a user.
 *
 * Admin-only. The alert gates impersonation: callers must treat a non-2xx
 * response as "do not impersonate".
 * @summary Notify Impersonation Start
 */
export const postV2NotifyImpersonationStart = async (
  impersonationNotifyRequest: ImpersonationNotifyRequest,
  options?: RequestInit,
): Promise<postV2NotifyImpersonationStartResponse> => {
  return customMutator<postV2NotifyImpersonationStartResponse>(
    getPostV2NotifyImpersonationStartUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(impersonationNotifyRequest),
    },
  );
};

export const getPostV2NotifyImpersonationStartMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2NotifyImpersonationStart>>,
    TError,
    { data: ImpersonationNotifyRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2NotifyImpersonationStart>>,
  TError,
  { data: ImpersonationNotifyRequest },
  TContext
> => {
  const mutationKey = ["postV2NotifyImpersonationStart"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2NotifyImpersonationStart>>,
    { data: ImpersonationNotifyRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2NotifyImpersonationStart(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2NotifyImpersonationStartMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2NotifyImpersonationStart>>
>;
export type PostV2NotifyImpersonationStartMutationBody =
  ImpersonationNotifyRequest;
export type PostV2NotifyImpersonationStartMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Notify Impersonation Start
 */
export const usePostV2NotifyImpersonationStart = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2NotifyImpersonationStart>>,
      TError,
      { data: ImpersonationNotifyRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2NotifyImpersonationStart>>,
  TError,
  { data: ImpersonationNotifyRequest },
  TContext
> => {
  return useMutation(
    getPostV2NotifyImpersonationStartMutationOptions(options),
    queryClient,
  );
};
export type getV2ListCommunitiesResponse200 = {
  data: CommunityListResponse;
  status: 200;
};

export type getV2ListCommunitiesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListCommunitiesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListCommunitiesResponseSuccess =
  getV2ListCommunitiesResponse200 & {
    headers: Headers;
  };
export type getV2ListCommunitiesResponseError = (
  | getV2ListCommunitiesResponse401
  | getV2ListCommunitiesResponse422
) & {
  headers: Headers;
};

export type getV2ListCommunitiesResponse =
  | getV2ListCommunitiesResponseSuccess
  | getV2ListCommunitiesResponseError;

export const getGetV2ListCommunitiesUrl = (
  userId: string,
  params?: GetV2ListCommunitiesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/memory/${userId}/communities?${stringifiedParams}`
    : `/api/admin/memory/${userId}/communities`;
};

/**
 * Communities in the user's account (Otto) memory graph.
 * @summary List Communities
 */
export const getV2ListCommunities = async (
  userId: string,
  params?: GetV2ListCommunitiesParams,
  options?: RequestInit,
): Promise<getV2ListCommunitiesResponse> => {
  return customMutator<getV2ListCommunitiesResponse>(
    getGetV2ListCommunitiesUrl(userId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListCommunitiesQueryKey = (
  userId: string,
  params?: GetV2ListCommunitiesParams,
) => {
  return [
    `/api/admin/memory/${userId}/communities`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListCommunitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListCommunities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListCommunities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListCommunitiesQueryKey(userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListCommunities>>
  > = ({ signal }) =>
    getV2ListCommunities(userId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListCommunities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListCommunitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListCommunities>>
>;
export type GetV2ListCommunitiesQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListCommunities<
  TData = Awaited<ReturnType<typeof getV2ListCommunities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params: undefined | GetV2ListCommunitiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListCommunities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListCommunities>>,
          TError,
          Awaited<ReturnType<typeof getV2ListCommunities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListCommunities<
  TData = Awaited<ReturnType<typeof getV2ListCommunities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListCommunities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListCommunities>>,
          TError,
          Awaited<ReturnType<typeof getV2ListCommunities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListCommunities<
  TData = Awaited<ReturnType<typeof getV2ListCommunities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListCommunities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Communities
 */

export function useGetV2ListCommunities<
  TData = Awaited<ReturnType<typeof getV2ListCommunities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListCommunities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListCommunitiesQueryOptions(
    userId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Communities
 */
export const prefetchGetV2ListCommunitiesQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListCommunities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  params?: GetV2ListCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListCommunities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListCommunitiesQueryOptions(
    userId,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2RebuildCommunitiesResponse202 = {
  data: JobTriggerResponse;
  status: 202;
};

export type postV2RebuildCommunitiesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2RebuildCommunitiesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2RebuildCommunitiesResponseSuccess =
  postV2RebuildCommunitiesResponse202 & {
    headers: Headers;
  };
export type postV2RebuildCommunitiesResponseError = (
  | postV2RebuildCommunitiesResponse401
  | postV2RebuildCommunitiesResponse422
) & {
  headers: Headers;
};

export type postV2RebuildCommunitiesResponse =
  | postV2RebuildCommunitiesResponseSuccess
  | postV2RebuildCommunitiesResponseError;

export const getPostV2RebuildCommunitiesUrl = (
  userId: string,
  params?: PostV2RebuildCommunitiesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/memory/${userId}/communities/rebuild?${stringifiedParams}`
    : `/api/admin/memory/${userId}/communities/rebuild`;
};

/**
 * Fire a community rebuild and return 202 + job_id immediately.
 *
 * Frontend polls
 * ``GET /api/admin/memory/{user_id}/communities/rebuild/{job_id}``
 * for progress.
 * @summary Rebuild Communities
 */
export const postV2RebuildCommunities = async (
  userId: string,
  params?: PostV2RebuildCommunitiesParams,
  options?: RequestInit,
): Promise<postV2RebuildCommunitiesResponse> => {
  return customMutator<postV2RebuildCommunitiesResponse>(
    getPostV2RebuildCommunitiesUrl(userId, params),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2RebuildCommunitiesMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2RebuildCommunities>>,
    TError,
    { userId: string; params?: PostV2RebuildCommunitiesParams },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2RebuildCommunities>>,
  TError,
  { userId: string; params?: PostV2RebuildCommunitiesParams },
  TContext
> => {
  const mutationKey = ["postV2RebuildCommunities"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2RebuildCommunities>>,
    { userId: string; params?: PostV2RebuildCommunitiesParams }
  > = (props) => {
    const { userId, params } = props ?? {};

    return postV2RebuildCommunities(userId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2RebuildCommunitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2RebuildCommunities>>
>;

export type PostV2RebuildCommunitiesMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Rebuild Communities
 */
export const usePostV2RebuildCommunities = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2RebuildCommunities>>,
      TError,
      { userId: string; params?: PostV2RebuildCommunitiesParams },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2RebuildCommunities>>,
  TError,
  { userId: string; params?: PostV2RebuildCommunitiesParams },
  TContext
> => {
  return useMutation(
    getPostV2RebuildCommunitiesMutationOptions(options),
    queryClient,
  );
};
export type getV2GetCommunityRebuildStatusResponse200 = {
  data: CommunityRebuildJobStatus;
  status: 200;
};

export type getV2GetCommunityRebuildStatusResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetCommunityRebuildStatusResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetCommunityRebuildStatusResponseSuccess =
  getV2GetCommunityRebuildStatusResponse200 & {
    headers: Headers;
  };
export type getV2GetCommunityRebuildStatusResponseError = (
  | getV2GetCommunityRebuildStatusResponse401
  | getV2GetCommunityRebuildStatusResponse422
) & {
  headers: Headers;
};

export type getV2GetCommunityRebuildStatusResponse =
  | getV2GetCommunityRebuildStatusResponseSuccess
  | getV2GetCommunityRebuildStatusResponseError;

export const getGetV2GetCommunityRebuildStatusUrl = (
  userId: string,
  jobId: string,
) => {
  return `/api/admin/memory/${userId}/communities/rebuild/${jobId}`;
};

/**
 * Read the current status of a fire-and-forget community rebuild job.
 * @summary Get Community Rebuild Status
 */
export const getV2GetCommunityRebuildStatus = async (
  userId: string,
  jobId: string,
  options?: RequestInit,
): Promise<getV2GetCommunityRebuildStatusResponse> => {
  return customMutator<getV2GetCommunityRebuildStatusResponse>(
    getGetV2GetCommunityRebuildStatusUrl(userId, jobId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetCommunityRebuildStatusQueryKey = (
  userId: string,
  jobId: string,
) => {
  return [`/api/admin/memory/${userId}/communities/rebuild/${jobId}`] as const;
};

export const getGetV2GetCommunityRebuildStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2GetCommunityRebuildStatusQueryKey(userId, jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>
  > = ({ signal }) =>
    getV2GetCommunityRebuildStatus(userId, jobId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      userId !== null &&
      userId !== undefined &&
      jobId !== null &&
      jobId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetCommunityRebuildStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>
>;
export type GetV2GetCommunityRebuildStatusQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetCommunityRebuildStatus<
  TData = Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  jobId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>,
          TError,
          Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetCommunityRebuildStatus<
  TData = Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>,
          TError,
          Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetCommunityRebuildStatus<
  TData = Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Community Rebuild Status
 */

export function useGetV2GetCommunityRebuildStatus<
  TData = Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetCommunityRebuildStatusQueryOptions(
    userId,
    jobId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Community Rebuild Status
 */
export const prefetchGetV2GetCommunityRebuildStatusQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCommunityRebuildStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetCommunityRebuildStatusQueryOptions(
    userId,
    jobId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2TriggerDreamPassResponse202 = {
  data: JobTriggerResponse;
  status: 202;
};

export type postV2TriggerDreamPassResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2TriggerDreamPassResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2TriggerDreamPassResponseSuccess =
  postV2TriggerDreamPassResponse202 & {
    headers: Headers;
  };
export type postV2TriggerDreamPassResponseError = (
  | postV2TriggerDreamPassResponse401
  | postV2TriggerDreamPassResponse422
) & {
  headers: Headers;
};

export type postV2TriggerDreamPassResponse =
  | postV2TriggerDreamPassResponseSuccess
  | postV2TriggerDreamPassResponseError;

export const getPostV2TriggerDreamPassUrl = (
  userId: string,
  params?: PostV2TriggerDreamPassParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/memory/${userId}/dream?${stringifiedParams}`
    : `/api/admin/memory/${userId}/dream`;
};

/**
 * Fire a dream pass and return 202 + job_id immediately.
 *
 * Frontend polls ``GET /api/admin/memory/{user_id}/dream/{job_id}``
 * for progress. Runs ONLY the dream pass submitter — for the full
 * nightly fan-out use ``POST /{user_id}/nightly``. The pass goes through
 * the same guard as the nightly one: it skips behind a fresh open pass of
 * the account unless ``force`` expires that pass first. ``force`` does not
 * take a lock another pass holds.
 * @summary Trigger Dream Pass
 */
export const postV2TriggerDreamPass = async (
  userId: string,
  params?: PostV2TriggerDreamPassParams,
  options?: RequestInit,
): Promise<postV2TriggerDreamPassResponse> => {
  return customMutator<postV2TriggerDreamPassResponse>(
    getPostV2TriggerDreamPassUrl(userId, params),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2TriggerDreamPassMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2TriggerDreamPass>>,
    TError,
    { userId: string; params?: PostV2TriggerDreamPassParams },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2TriggerDreamPass>>,
  TError,
  { userId: string; params?: PostV2TriggerDreamPassParams },
  TContext
> => {
  const mutationKey = ["postV2TriggerDreamPass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2TriggerDreamPass>>,
    { userId: string; params?: PostV2TriggerDreamPassParams }
  > = (props) => {
    const { userId, params } = props ?? {};

    return postV2TriggerDreamPass(userId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2TriggerDreamPassMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2TriggerDreamPass>>
>;

export type PostV2TriggerDreamPassMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Trigger Dream Pass
 */
export const usePostV2TriggerDreamPass = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2TriggerDreamPass>>,
      TError,
      { userId: string; params?: PostV2TriggerDreamPassParams },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2TriggerDreamPass>>,
  TError,
  { userId: string; params?: PostV2TriggerDreamPassParams },
  TContext
> => {
  return useMutation(
    getPostV2TriggerDreamPassMutationOptions(options),
    queryClient,
  );
};
export type getV2ListDreamPassRecordsResponse200 = {
  data: DreamPassListResponse;
  status: 200;
};

export type getV2ListDreamPassRecordsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListDreamPassRecordsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListDreamPassRecordsResponseSuccess =
  getV2ListDreamPassRecordsResponse200 & {
    headers: Headers;
  };
export type getV2ListDreamPassRecordsResponseError = (
  | getV2ListDreamPassRecordsResponse401
  | getV2ListDreamPassRecordsResponse422
) & {
  headers: Headers;
};

export type getV2ListDreamPassRecordsResponse =
  | getV2ListDreamPassRecordsResponseSuccess
  | getV2ListDreamPassRecordsResponseError;

export const getGetV2ListDreamPassRecordsUrl = (
  userId: string,
  params?: GetV2ListDreamPassRecordsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/memory/${userId}/dream/passes?${stringifiedParams}`
    : `/api/admin/memory/${userId}/dream/passes`;
};

/**
 * List a user's dream passes, across the account and every expert,
 * newest first: the durable records, each as ``GET .../record`` returns
 * it. A finished pass keeps its phase outputs, operations and usage; its
 * input bundle went when it closed, and its lease with it, or, for a pass
 * whose close left a cleanup pending, once that cleanup finished.
 * @summary List Dream Pass Records
 */
export const getV2ListDreamPassRecords = async (
  userId: string,
  params?: GetV2ListDreamPassRecordsParams,
  options?: RequestInit,
): Promise<getV2ListDreamPassRecordsResponse> => {
  return customMutator<getV2ListDreamPassRecordsResponse>(
    getGetV2ListDreamPassRecordsUrl(userId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListDreamPassRecordsQueryKey = (
  userId: string,
  params?: GetV2ListDreamPassRecordsParams,
) => {
  return [
    `/api/admin/memory/${userId}/dream/passes`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListDreamPassRecordsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListDreamPassRecords>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListDreamPassRecordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListDreamPassRecords>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2ListDreamPassRecordsQueryKey(userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListDreamPassRecords>>
  > = ({ signal }) =>
    getV2ListDreamPassRecords(userId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListDreamPassRecords>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListDreamPassRecordsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListDreamPassRecords>>
>;
export type GetV2ListDreamPassRecordsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListDreamPassRecords<
  TData = Awaited<ReturnType<typeof getV2ListDreamPassRecords>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params: undefined | GetV2ListDreamPassRecordsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListDreamPassRecords>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListDreamPassRecords>>,
          TError,
          Awaited<ReturnType<typeof getV2ListDreamPassRecords>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListDreamPassRecords<
  TData = Awaited<ReturnType<typeof getV2ListDreamPassRecords>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListDreamPassRecordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListDreamPassRecords>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListDreamPassRecords>>,
          TError,
          Awaited<ReturnType<typeof getV2ListDreamPassRecords>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListDreamPassRecords<
  TData = Awaited<ReturnType<typeof getV2ListDreamPassRecords>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListDreamPassRecordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListDreamPassRecords>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Dream Pass Records
 */

export function useGetV2ListDreamPassRecords<
  TData = Awaited<ReturnType<typeof getV2ListDreamPassRecords>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListDreamPassRecordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListDreamPassRecords>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListDreamPassRecordsQueryOptions(
    userId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Dream Pass Records
 */
export const prefetchGetV2ListDreamPassRecordsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListDreamPassRecords>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  params?: GetV2ListDreamPassRecordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListDreamPassRecords>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListDreamPassRecordsQueryOptions(
    userId,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetDreamPassStatusResponse200 = {
  data: DreamJobStatus;
  status: 200;
};

export type getV2GetDreamPassStatusResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetDreamPassStatusResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetDreamPassStatusResponseSuccess =
  getV2GetDreamPassStatusResponse200 & {
    headers: Headers;
  };
export type getV2GetDreamPassStatusResponseError = (
  | getV2GetDreamPassStatusResponse401
  | getV2GetDreamPassStatusResponse422
) & {
  headers: Headers;
};

export type getV2GetDreamPassStatusResponse =
  | getV2GetDreamPassStatusResponseSuccess
  | getV2GetDreamPassStatusResponseError;

export const getGetV2GetDreamPassStatusUrl = (
  userId: string,
  jobId: string,
) => {
  return `/api/admin/memory/${userId}/dream/${jobId}`;
};

/**
 * Read the current status of a fire-and-forget dream pass job.
 * @summary Get Dream Pass Status
 */
export const getV2GetDreamPassStatus = async (
  userId: string,
  jobId: string,
  options?: RequestInit,
): Promise<getV2GetDreamPassStatusResponse> => {
  return customMutator<getV2GetDreamPassStatusResponse>(
    getGetV2GetDreamPassStatusUrl(userId, jobId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetDreamPassStatusQueryKey = (
  userId: string,
  jobId: string,
) => {
  return [`/api/admin/memory/${userId}/dream/${jobId}`] as const;
};

export const getGetV2GetDreamPassStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetDreamPassStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetDreamPassStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetDreamPassStatusQueryKey(userId, jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetDreamPassStatus>>
  > = ({ signal }) =>
    getV2GetDreamPassStatus(userId, jobId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      userId !== null &&
      userId !== undefined &&
      jobId !== null &&
      jobId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetDreamPassStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetDreamPassStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetDreamPassStatus>>
>;
export type GetV2GetDreamPassStatusQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetDreamPassStatus<
  TData = Awaited<ReturnType<typeof getV2GetDreamPassStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  jobId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetDreamPassStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetDreamPassStatus>>,
          TError,
          Awaited<ReturnType<typeof getV2GetDreamPassStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetDreamPassStatus<
  TData = Awaited<ReturnType<typeof getV2GetDreamPassStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetDreamPassStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetDreamPassStatus>>,
          TError,
          Awaited<ReturnType<typeof getV2GetDreamPassStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetDreamPassStatus<
  TData = Awaited<ReturnType<typeof getV2GetDreamPassStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetDreamPassStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Dream Pass Status
 */

export function useGetV2GetDreamPassStatus<
  TData = Awaited<ReturnType<typeof getV2GetDreamPassStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetDreamPassStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetDreamPassStatusQueryOptions(
    userId,
    jobId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Dream Pass Status
 */
export const prefetchGetV2GetDreamPassStatusQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetDreamPassStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetDreamPassStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetDreamPassStatusQueryOptions(
    userId,
    jobId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2CancelDreamPassRunResponse200 = {
  data: DreamPassRecordResponse;
  status: 200;
};

export type postV2CancelDreamPassRunResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2CancelDreamPassRunResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2CancelDreamPassRunResponseSuccess =
  postV2CancelDreamPassRunResponse200 & {
    headers: Headers;
  };
export type postV2CancelDreamPassRunResponseError = (
  | postV2CancelDreamPassRunResponse401
  | postV2CancelDreamPassRunResponse422
) & {
  headers: Headers;
};

export type postV2CancelDreamPassRunResponse =
  | postV2CancelDreamPassRunResponseSuccess
  | postV2CancelDreamPassRunResponseError;

export const getPostV2CancelDreamPassRunUrl = (
  userId: string,
  passId: string,
) => {
  return `/api/admin/memory/${userId}/dream/${passId}/cancel`;
};

/**
 * Cancel an open dream pass and return its record, now CANCELLED.
 *
 * The row closes at once; the pass itself stops at its next check (a phase
 * boundary, its batch submit, or just before apply, on either route)
 * without applying. A batch pass waiting on its provider has that batch
 * cancelled too, and the batch executor drops it at its next poll, which
 * releases the pass's lock. A pass already past its last check still
 * applies, once, and whatever a pass applied stays. 404 for a pass that
 * does not exist or belongs to another user, alike; 409 once the pass has
 * ended.
 * @summary Cancel Dream Pass Run
 */
export const postV2CancelDreamPassRun = async (
  userId: string,
  passId: string,
  dreamPassCancelRequestNull?: DreamPassCancelRequest | null,
  options?: RequestInit,
): Promise<postV2CancelDreamPassRunResponse> => {
  return customMutator<postV2CancelDreamPassRunResponse>(
    getPostV2CancelDreamPassRunUrl(userId, passId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(dreamPassCancelRequestNull),
    },
  );
};

export const getPostV2CancelDreamPassRunMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2CancelDreamPassRun>>,
    TError,
    { userId: string; passId: string; data?: DreamPassCancelRequest | null },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2CancelDreamPassRun>>,
  TError,
  { userId: string; passId: string; data?: DreamPassCancelRequest | null },
  TContext
> => {
  const mutationKey = ["postV2CancelDreamPassRun"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2CancelDreamPassRun>>,
    { userId: string; passId: string; data?: DreamPassCancelRequest | null }
  > = (props) => {
    const { userId, passId, data } = props ?? {};

    return postV2CancelDreamPassRun(userId, passId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2CancelDreamPassRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2CancelDreamPassRun>>
>;
export type PostV2CancelDreamPassRunMutationBody =
  | DreamPassCancelRequest
  | null
  | undefined;
export type PostV2CancelDreamPassRunMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Cancel Dream Pass Run
 */
export const usePostV2CancelDreamPassRun = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2CancelDreamPassRun>>,
      TError,
      { userId: string; passId: string; data?: DreamPassCancelRequest | null },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2CancelDreamPassRun>>,
  TError,
  { userId: string; passId: string; data?: DreamPassCancelRequest | null },
  TContext
> => {
  return useMutation(
    getPostV2CancelDreamPassRunMutationOptions(options),
    queryClient,
  );
};
export type getV2GetDreamPassRecordResponse200 = {
  data: DreamPassRecordResponse;
  status: 200;
};

export type getV2GetDreamPassRecordResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetDreamPassRecordResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetDreamPassRecordResponseSuccess =
  getV2GetDreamPassRecordResponse200 & {
    headers: Headers;
  };
export type getV2GetDreamPassRecordResponseError = (
  | getV2GetDreamPassRecordResponse401
  | getV2GetDreamPassRecordResponse422
) & {
  headers: Headers;
};

export type getV2GetDreamPassRecordResponse =
  | getV2GetDreamPassRecordResponseSuccess
  | getV2GetDreamPassRecordResponseError;

export const getGetV2GetDreamPassRecordUrl = (
  userId: string,
  passId: string,
) => {
  return `/api/admin/memory/${userId}/dream/${passId}/record`;
};

/**
 * Read one dream pass's durable record, on either route.
 *
 * The job status above is a Redis row that lapses after six hours and, for
 * a batch pass, carries no usage; the record outlives the pass and holds
 * what its phases used, unless a cancel or a newer pass closed it first
 * (the cost log still has that usage). 404 for a pass that does not exist
 * or belongs to another user, alike.
 * @summary Get Dream Pass Record
 */
export const getV2GetDreamPassRecord = async (
  userId: string,
  passId: string,
  options?: RequestInit,
): Promise<getV2GetDreamPassRecordResponse> => {
  return customMutator<getV2GetDreamPassRecordResponse>(
    getGetV2GetDreamPassRecordUrl(userId, passId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetDreamPassRecordQueryKey = (
  userId: string,
  passId: string,
) => {
  return [`/api/admin/memory/${userId}/dream/${passId}/record`] as const;
};

export const getGetV2GetDreamPassRecordQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetDreamPassRecord>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  passId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetDreamPassRecord>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2GetDreamPassRecordQueryKey(userId, passId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetDreamPassRecord>>
  > = ({ signal }) =>
    getV2GetDreamPassRecord(userId, passId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      userId !== null &&
      userId !== undefined &&
      passId !== null &&
      passId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetDreamPassRecord>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetDreamPassRecordQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetDreamPassRecord>>
>;
export type GetV2GetDreamPassRecordQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetDreamPassRecord<
  TData = Awaited<ReturnType<typeof getV2GetDreamPassRecord>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  passId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetDreamPassRecord>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetDreamPassRecord>>,
          TError,
          Awaited<ReturnType<typeof getV2GetDreamPassRecord>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetDreamPassRecord<
  TData = Awaited<ReturnType<typeof getV2GetDreamPassRecord>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  passId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetDreamPassRecord>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetDreamPassRecord>>,
          TError,
          Awaited<ReturnType<typeof getV2GetDreamPassRecord>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetDreamPassRecord<
  TData = Awaited<ReturnType<typeof getV2GetDreamPassRecord>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  passId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetDreamPassRecord>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Dream Pass Record
 */

export function useGetV2GetDreamPassRecord<
  TData = Awaited<ReturnType<typeof getV2GetDreamPassRecord>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  passId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetDreamPassRecord>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetDreamPassRecordQueryOptions(
    userId,
    passId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Dream Pass Record
 */
export const prefetchGetV2GetDreamPassRecordQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetDreamPassRecord>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  passId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetDreamPassRecord>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetDreamPassRecordQueryOptions(
    userId,
    passId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListEntitiesResponse200 = {
  data: EntityListResponse;
  status: 200;
};

export type getV2ListEntitiesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListEntitiesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListEntitiesResponseSuccess = getV2ListEntitiesResponse200 & {
  headers: Headers;
};
export type getV2ListEntitiesResponseError = (
  | getV2ListEntitiesResponse401
  | getV2ListEntitiesResponse422
) & {
  headers: Headers;
};

export type getV2ListEntitiesResponse =
  | getV2ListEntitiesResponseSuccess
  | getV2ListEntitiesResponseError;

export const getGetV2ListEntitiesUrl = (
  userId: string,
  params?: GetV2ListEntitiesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/memory/${userId}/entities?${stringifiedParams}`
    : `/api/admin/memory/${userId}/entities`;
};

/**
 * Entities in the user's account (Otto) memory graph.
 * @summary List Entities
 */
export const getV2ListEntities = async (
  userId: string,
  params?: GetV2ListEntitiesParams,
  options?: RequestInit,
): Promise<getV2ListEntitiesResponse> => {
  return customMutator<getV2ListEntitiesResponse>(
    getGetV2ListEntitiesUrl(userId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListEntitiesQueryKey = (
  userId: string,
  params?: GetV2ListEntitiesParams,
) => {
  return [
    `/api/admin/memory/${userId}/entities`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListEntitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListEntities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListEntitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListEntitiesQueryKey(userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListEntities>>
  > = ({ signal }) =>
    getV2ListEntities(userId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListEntities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListEntitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListEntities>>
>;
export type GetV2ListEntitiesQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListEntities<
  TData = Awaited<ReturnType<typeof getV2ListEntities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params: undefined | GetV2ListEntitiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListEntities>>,
          TError,
          Awaited<ReturnType<typeof getV2ListEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListEntities<
  TData = Awaited<ReturnType<typeof getV2ListEntities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListEntitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListEntities>>,
          TError,
          Awaited<ReturnType<typeof getV2ListEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListEntities<
  TData = Awaited<ReturnType<typeof getV2ListEntities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListEntitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Entities
 */

export function useGetV2ListEntities<
  TData = Awaited<ReturnType<typeof getV2ListEntities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListEntitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListEntitiesQueryOptions(
    userId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Entities
 */
export const prefetchGetV2ListEntitiesQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListEntities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  params?: GetV2ListEntitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListEntitiesQueryOptions(
    userId,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListExpertCommunitiesResponse200 = {
  data: CommunityListResponse;
  status: 200;
};

export type getV2ListExpertCommunitiesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListExpertCommunitiesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListExpertCommunitiesResponseSuccess =
  getV2ListExpertCommunitiesResponse200 & {
    headers: Headers;
  };
export type getV2ListExpertCommunitiesResponseError = (
  | getV2ListExpertCommunitiesResponse401
  | getV2ListExpertCommunitiesResponse422
) & {
  headers: Headers;
};

export type getV2ListExpertCommunitiesResponse =
  | getV2ListExpertCommunitiesResponseSuccess
  | getV2ListExpertCommunitiesResponseError;

export const getGetV2ListExpertCommunitiesUrl = (
  userId: string,
  expertId: string,
  params?: GetV2ListExpertCommunitiesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/memory/${userId}/experts/${expertId}/communities?${stringifiedParams}`
    : `/api/admin/memory/${userId}/experts/${expertId}/communities`;
};

/**
 * Communities in one expert's isolated memory graph.
 * @summary List Expert Communities
 */
export const getV2ListExpertCommunities = async (
  userId: string,
  expertId: string,
  params?: GetV2ListExpertCommunitiesParams,
  options?: RequestInit,
): Promise<getV2ListExpertCommunitiesResponse> => {
  return customMutator<getV2ListExpertCommunitiesResponse>(
    getGetV2ListExpertCommunitiesUrl(userId, expertId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListExpertCommunitiesQueryKey = (
  userId: string,
  expertId: string,
  params?: GetV2ListExpertCommunitiesParams,
) => {
  return [
    `/api/admin/memory/${userId}/experts/${expertId}/communities`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListExpertCommunitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListExpertCommunities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2ListExpertCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertCommunities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2ListExpertCommunitiesQueryKey(userId, expertId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListExpertCommunities>>
  > = ({ signal }) =>
    getV2ListExpertCommunities(userId, expertId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      userId !== null &&
      userId !== undefined &&
      expertId !== null &&
      expertId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListExpertCommunities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListExpertCommunitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListExpertCommunities>>
>;
export type GetV2ListExpertCommunitiesQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListExpertCommunities<
  TData = Awaited<ReturnType<typeof getV2ListExpertCommunities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params: undefined | GetV2ListExpertCommunitiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertCommunities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListExpertCommunities>>,
          TError,
          Awaited<ReturnType<typeof getV2ListExpertCommunities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListExpertCommunities<
  TData = Awaited<ReturnType<typeof getV2ListExpertCommunities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2ListExpertCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertCommunities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListExpertCommunities>>,
          TError,
          Awaited<ReturnType<typeof getV2ListExpertCommunities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListExpertCommunities<
  TData = Awaited<ReturnType<typeof getV2ListExpertCommunities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2ListExpertCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertCommunities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Expert Communities
 */

export function useGetV2ListExpertCommunities<
  TData = Awaited<ReturnType<typeof getV2ListExpertCommunities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2ListExpertCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertCommunities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListExpertCommunitiesQueryOptions(
    userId,
    expertId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Expert Communities
 */
export const prefetchGetV2ListExpertCommunitiesQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListExpertCommunities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  expertId: string,
  params?: GetV2ListExpertCommunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertCommunities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListExpertCommunitiesQueryOptions(
    userId,
    expertId,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListExpertEntitiesResponse200 = {
  data: EntityListResponse;
  status: 200;
};

export type getV2ListExpertEntitiesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListExpertEntitiesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListExpertEntitiesResponseSuccess =
  getV2ListExpertEntitiesResponse200 & {
    headers: Headers;
  };
export type getV2ListExpertEntitiesResponseError = (
  | getV2ListExpertEntitiesResponse401
  | getV2ListExpertEntitiesResponse422
) & {
  headers: Headers;
};

export type getV2ListExpertEntitiesResponse =
  | getV2ListExpertEntitiesResponseSuccess
  | getV2ListExpertEntitiesResponseError;

export const getGetV2ListExpertEntitiesUrl = (
  userId: string,
  expertId: string,
  params?: GetV2ListExpertEntitiesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/memory/${userId}/experts/${expertId}/entities?${stringifiedParams}`
    : `/api/admin/memory/${userId}/experts/${expertId}/entities`;
};

/**
 * Entities in one expert's isolated memory graph.
 * @summary List Expert Entities
 */
export const getV2ListExpertEntities = async (
  userId: string,
  expertId: string,
  params?: GetV2ListExpertEntitiesParams,
  options?: RequestInit,
): Promise<getV2ListExpertEntitiesResponse> => {
  return customMutator<getV2ListExpertEntitiesResponse>(
    getGetV2ListExpertEntitiesUrl(userId, expertId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListExpertEntitiesQueryKey = (
  userId: string,
  expertId: string,
  params?: GetV2ListExpertEntitiesParams,
) => {
  return [
    `/api/admin/memory/${userId}/experts/${expertId}/entities`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListExpertEntitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListExpertEntities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2ListExpertEntitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2ListExpertEntitiesQueryKey(userId, expertId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListExpertEntities>>
  > = ({ signal }) =>
    getV2ListExpertEntities(userId, expertId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      userId !== null &&
      userId !== undefined &&
      expertId !== null &&
      expertId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListExpertEntities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListExpertEntitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListExpertEntities>>
>;
export type GetV2ListExpertEntitiesQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListExpertEntities<
  TData = Awaited<ReturnType<typeof getV2ListExpertEntities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params: undefined | GetV2ListExpertEntitiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListExpertEntities>>,
          TError,
          Awaited<ReturnType<typeof getV2ListExpertEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListExpertEntities<
  TData = Awaited<ReturnType<typeof getV2ListExpertEntities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2ListExpertEntitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertEntities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListExpertEntities>>,
          TError,
          Awaited<ReturnType<typeof getV2ListExpertEntities>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListExpertEntities<
  TData = Awaited<ReturnType<typeof getV2ListExpertEntities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2ListExpertEntitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Expert Entities
 */

export function useGetV2ListExpertEntities<
  TData = Awaited<ReturnType<typeof getV2ListExpertEntities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2ListExpertEntitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListExpertEntitiesQueryOptions(
    userId,
    expertId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Expert Entities
 */
export const prefetchGetV2ListExpertEntitiesQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListExpertEntities>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  expertId: string,
  params?: GetV2ListExpertEntitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertEntities>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListExpertEntitiesQueryOptions(
    userId,
    expertId,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListExpertFactsResponse200 = {
  data: FactListResponse;
  status: 200;
};

export type getV2ListExpertFactsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListExpertFactsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListExpertFactsResponseSuccess =
  getV2ListExpertFactsResponse200 & {
    headers: Headers;
  };
export type getV2ListExpertFactsResponseError = (
  | getV2ListExpertFactsResponse401
  | getV2ListExpertFactsResponse422
) & {
  headers: Headers;
};

export type getV2ListExpertFactsResponse =
  | getV2ListExpertFactsResponseSuccess
  | getV2ListExpertFactsResponseError;

export const getGetV2ListExpertFactsUrl = (
  userId: string,
  expertId: string,
  params?: GetV2ListExpertFactsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/memory/${userId}/experts/${expertId}/facts?${stringifiedParams}`
    : `/api/admin/memory/${userId}/experts/${expertId}/facts`;
};

/**
 * Facts (RELATES_TO edges) in one expert's isolated memory graph.
 * @summary List Expert Facts
 */
export const getV2ListExpertFacts = async (
  userId: string,
  expertId: string,
  params?: GetV2ListExpertFactsParams,
  options?: RequestInit,
): Promise<getV2ListExpertFactsResponse> => {
  return customMutator<getV2ListExpertFactsResponse>(
    getGetV2ListExpertFactsUrl(userId, expertId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListExpertFactsQueryKey = (
  userId: string,
  expertId: string,
  params?: GetV2ListExpertFactsParams,
) => {
  return [
    `/api/admin/memory/${userId}/experts/${expertId}/facts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListExpertFactsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListExpertFacts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2ListExpertFactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertFacts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2ListExpertFactsQueryKey(userId, expertId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListExpertFacts>>
  > = ({ signal }) =>
    getV2ListExpertFacts(userId, expertId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      userId !== null &&
      userId !== undefined &&
      expertId !== null &&
      expertId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListExpertFacts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListExpertFactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListExpertFacts>>
>;
export type GetV2ListExpertFactsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListExpertFacts<
  TData = Awaited<ReturnType<typeof getV2ListExpertFacts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params: undefined | GetV2ListExpertFactsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertFacts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListExpertFacts>>,
          TError,
          Awaited<ReturnType<typeof getV2ListExpertFacts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListExpertFacts<
  TData = Awaited<ReturnType<typeof getV2ListExpertFacts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2ListExpertFactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertFacts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListExpertFacts>>,
          TError,
          Awaited<ReturnType<typeof getV2ListExpertFacts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListExpertFacts<
  TData = Awaited<ReturnType<typeof getV2ListExpertFacts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2ListExpertFactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertFacts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Expert Facts
 */

export function useGetV2ListExpertFacts<
  TData = Awaited<ReturnType<typeof getV2ListExpertFacts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2ListExpertFactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertFacts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListExpertFactsQueryOptions(
    userId,
    expertId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Expert Facts
 */
export const prefetchGetV2ListExpertFactsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListExpertFacts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  expertId: string,
  params?: GetV2ListExpertFactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListExpertFacts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListExpertFactsQueryOptions(
    userId,
    expertId,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetExpertGraphResponse200 = {
  data: GraphResponse;
  status: 200;
};

export type getV2GetExpertGraphResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetExpertGraphResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetExpertGraphResponseSuccess =
  getV2GetExpertGraphResponse200 & {
    headers: Headers;
  };
export type getV2GetExpertGraphResponseError = (
  | getV2GetExpertGraphResponse401
  | getV2GetExpertGraphResponse422
) & {
  headers: Headers;
};

export type getV2GetExpertGraphResponse =
  | getV2GetExpertGraphResponseSuccess
  | getV2GetExpertGraphResponseError;

export const getGetV2GetExpertGraphUrl = (
  userId: string,
  expertId: string,
  params?: GetV2GetExpertGraphParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/memory/${userId}/experts/${expertId}/graph?${stringifiedParams}`
    : `/api/admin/memory/${userId}/experts/${expertId}/graph`;
};

/**
 * Visualizer graph payload for one expert's isolated memory graph.
 * @summary Get Expert Graph
 */
export const getV2GetExpertGraph = async (
  userId: string,
  expertId: string,
  params?: GetV2GetExpertGraphParams,
  options?: RequestInit,
): Promise<getV2GetExpertGraphResponse> => {
  return customMutator<getV2GetExpertGraphResponse>(
    getGetV2GetExpertGraphUrl(userId, expertId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetExpertGraphQueryKey = (
  userId: string,
  expertId: string,
  params?: GetV2GetExpertGraphParams,
) => {
  return [
    `/api/admin/memory/${userId}/experts/${expertId}/graph`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2GetExpertGraphQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetExpertGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2GetExpertGraphParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2GetExpertGraphQueryKey(userId, expertId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetExpertGraph>>
  > = ({ signal }) =>
    getV2GetExpertGraph(userId, expertId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      userId !== null &&
      userId !== undefined &&
      expertId !== null &&
      expertId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetExpertGraph>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetExpertGraphQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetExpertGraph>>
>;
export type GetV2GetExpertGraphQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetExpertGraph<
  TData = Awaited<ReturnType<typeof getV2GetExpertGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params: undefined | GetV2GetExpertGraphParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertGraph>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetExpertGraph>>,
          TError,
          Awaited<ReturnType<typeof getV2GetExpertGraph>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetExpertGraph<
  TData = Awaited<ReturnType<typeof getV2GetExpertGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2GetExpertGraphParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertGraph>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetExpertGraph>>,
          TError,
          Awaited<ReturnType<typeof getV2GetExpertGraph>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetExpertGraph<
  TData = Awaited<ReturnType<typeof getV2GetExpertGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2GetExpertGraphParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Expert Graph
 */

export function useGetV2GetExpertGraph<
  TData = Awaited<ReturnType<typeof getV2GetExpertGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  params?: GetV2GetExpertGraphParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetExpertGraphQueryOptions(
    userId,
    expertId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Expert Graph
 */
export const prefetchGetV2GetExpertGraphQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetExpertGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  expertId: string,
  params?: GetV2GetExpertGraphParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetExpertGraphQueryOptions(
    userId,
    expertId,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetExpertMemoryOverviewResponse200 = {
  data: MemoryOverview;
  status: 200;
};

export type getV2GetExpertMemoryOverviewResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetExpertMemoryOverviewResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetExpertMemoryOverviewResponseSuccess =
  getV2GetExpertMemoryOverviewResponse200 & {
    headers: Headers;
  };
export type getV2GetExpertMemoryOverviewResponseError = (
  | getV2GetExpertMemoryOverviewResponse401
  | getV2GetExpertMemoryOverviewResponse422
) & {
  headers: Headers;
};

export type getV2GetExpertMemoryOverviewResponse =
  | getV2GetExpertMemoryOverviewResponseSuccess
  | getV2GetExpertMemoryOverviewResponseError;

export const getGetV2GetExpertMemoryOverviewUrl = (
  userId: string,
  expertId: string,
) => {
  return `/api/admin/memory/${userId}/experts/${expertId}/overview`;
};

/**
 * Count summary of one expert's isolated memory graph.
 * @summary Get Expert Memory Overview
 */
export const getV2GetExpertMemoryOverview = async (
  userId: string,
  expertId: string,
  options?: RequestInit,
): Promise<getV2GetExpertMemoryOverviewResponse> => {
  return customMutator<getV2GetExpertMemoryOverviewResponse>(
    getGetV2GetExpertMemoryOverviewUrl(userId, expertId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetExpertMemoryOverviewQueryKey = (
  userId: string,
  expertId: string,
) => {
  return [`/api/admin/memory/${userId}/experts/${expertId}/overview`] as const;
};

export const getGetV2GetExpertMemoryOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2GetExpertMemoryOverviewQueryKey(userId, expertId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>
  > = ({ signal }) =>
    getV2GetExpertMemoryOverview(userId, expertId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      userId !== null &&
      userId !== undefined &&
      expertId !== null &&
      expertId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetExpertMemoryOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>
>;
export type GetV2GetExpertMemoryOverviewQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetExpertMemoryOverview<
  TData = Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>,
          TError,
          Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetExpertMemoryOverview<
  TData = Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>,
          TError,
          Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetExpertMemoryOverview<
  TData = Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Expert Memory Overview
 */

export function useGetV2GetExpertMemoryOverview<
  TData = Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetExpertMemoryOverviewQueryOptions(
    userId,
    expertId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Expert Memory Overview
 */
export const prefetchGetV2GetExpertMemoryOverviewQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  expertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExpertMemoryOverview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetExpertMemoryOverviewQueryOptions(
    userId,
    expertId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListFactsResponse200 = {
  data: FactListResponse;
  status: 200;
};

export type getV2ListFactsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListFactsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListFactsResponseSuccess = getV2ListFactsResponse200 & {
  headers: Headers;
};
export type getV2ListFactsResponseError = (
  | getV2ListFactsResponse401
  | getV2ListFactsResponse422
) & {
  headers: Headers;
};

export type getV2ListFactsResponse =
  | getV2ListFactsResponseSuccess
  | getV2ListFactsResponseError;

export const getGetV2ListFactsUrl = (
  userId: string,
  params?: GetV2ListFactsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/memory/${userId}/facts?${stringifiedParams}`
    : `/api/admin/memory/${userId}/facts`;
};

/**
 * Facts (RELATES_TO edges) in the user's account (Otto) memory graph.
 * @summary List Facts
 */
export const getV2ListFacts = async (
  userId: string,
  params?: GetV2ListFactsParams,
  options?: RequestInit,
): Promise<getV2ListFactsResponse> => {
  return customMutator<getV2ListFactsResponse>(
    getGetV2ListFactsUrl(userId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListFactsQueryKey = (
  userId: string,
  params?: GetV2ListFactsParams,
) => {
  return [
    `/api/admin/memory/${userId}/facts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ListFactsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListFacts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListFactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV2ListFacts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListFactsQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2ListFacts>>> = ({
    signal,
  }) => getV2ListFacts(userId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListFacts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListFactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListFacts>>
>;
export type GetV2ListFactsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListFacts<
  TData = Awaited<ReturnType<typeof getV2ListFacts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params: undefined | GetV2ListFactsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV2ListFacts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListFacts>>,
          TError,
          Awaited<ReturnType<typeof getV2ListFacts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListFacts<
  TData = Awaited<ReturnType<typeof getV2ListFacts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListFactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV2ListFacts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListFacts>>,
          TError,
          Awaited<ReturnType<typeof getV2ListFacts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListFacts<
  TData = Awaited<ReturnType<typeof getV2ListFacts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListFactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV2ListFacts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Facts
 */

export function useGetV2ListFacts<
  TData = Awaited<ReturnType<typeof getV2ListFacts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2ListFactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV2ListFacts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListFactsQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Facts
 */
export const prefetchGetV2ListFactsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListFacts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  params?: GetV2ListFactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV2ListFacts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListFactsQueryOptions(userId, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetGraphResponse200 = {
  data: GraphResponse;
  status: 200;
};

export type getV2GetGraphResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetGraphResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetGraphResponseSuccess = getV2GetGraphResponse200 & {
  headers: Headers;
};
export type getV2GetGraphResponseError = (
  | getV2GetGraphResponse401
  | getV2GetGraphResponse422
) & {
  headers: Headers;
};

export type getV2GetGraphResponse =
  | getV2GetGraphResponseSuccess
  | getV2GetGraphResponseError;

export const getGetV2GetGraphUrl = (
  userId: string,
  params?: GetV2GetGraphParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/memory/${userId}/graph?${stringifiedParams}`
    : `/api/admin/memory/${userId}/graph`;
};

/**
 * Single-shot graph payload for the visualizer canvas (account scope).
 *
 * Returns nodes + edges in one round-trip so the frontend can hand
 * the whole thing to a force-directed layout without N+1 fetches.
 *
 * Defaults to entities + communities (the "what does my memory know
 * about" view). ``include_episodes=True`` adds the temporal
 * :Episodic nodes — useful for debugging extraction but noisy for the
 * typical inspector view.
 * @summary Get Graph
 */
export const getV2GetGraph = async (
  userId: string,
  params?: GetV2GetGraphParams,
  options?: RequestInit,
): Promise<getV2GetGraphResponse> => {
  return customMutator<getV2GetGraphResponse>(
    getGetV2GetGraphUrl(userId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetGraphQueryKey = (
  userId: string,
  params?: GetV2GetGraphParams,
) => {
  return [
    `/api/admin/memory/${userId}/graph`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2GetGraphQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2GetGraphParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV2GetGraph>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetGraphQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2GetGraph>>> = ({
    signal,
  }) => getV2GetGraph(userId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetGraph>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetGraphQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetGraph>>
>;
export type GetV2GetGraphQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetGraph<
  TData = Awaited<ReturnType<typeof getV2GetGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params: undefined | GetV2GetGraphParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV2GetGraph>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetGraph>>,
          TError,
          Awaited<ReturnType<typeof getV2GetGraph>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetGraph<
  TData = Awaited<ReturnType<typeof getV2GetGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2GetGraphParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV2GetGraph>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetGraph>>,
          TError,
          Awaited<ReturnType<typeof getV2GetGraph>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetGraph<
  TData = Awaited<ReturnType<typeof getV2GetGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2GetGraphParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV2GetGraph>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Graph
 */

export function useGetV2GetGraph<
  TData = Awaited<ReturnType<typeof getV2GetGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetV2GetGraphParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV2GetGraph>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetGraphQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Graph
 */
export const prefetchGetV2GetGraphQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  params?: GetV2GetGraphParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV2GetGraph>>, TError, TData>
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetGraphQueryOptions(userId, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2TriggerNightlyBatchResponse202 = {
  data: JobTriggerResponse;
  status: 202;
};

export type postV2TriggerNightlyBatchResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2TriggerNightlyBatchResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2TriggerNightlyBatchResponseSuccess =
  postV2TriggerNightlyBatchResponse202 & {
    headers: Headers;
  };
export type postV2TriggerNightlyBatchResponseError = (
  | postV2TriggerNightlyBatchResponse401
  | postV2TriggerNightlyBatchResponse422
) & {
  headers: Headers;
};

export type postV2TriggerNightlyBatchResponse =
  | postV2TriggerNightlyBatchResponseSuccess
  | postV2TriggerNightlyBatchResponseError;

export const getPostV2TriggerNightlyBatchUrl = (userId: string) => {
  return `/api/admin/memory/${userId}/nightly`;
};

/**
 * Fire the full nightly batch fan-out and return 202 + job_id immediately.
 *
 * Frontend polls ``GET /api/admin/memory/{user_id}/nightly/{job_id}``
 * for progress. Same composition as the 03:00 cron — every enabled
 * batch-family submitter runs in sequence sharing one ``nightly_id``
 * for cost-log attribution.
 * @summary Trigger Nightly Batch
 */
export const postV2TriggerNightlyBatch = async (
  userId: string,
  options?: RequestInit,
): Promise<postV2TriggerNightlyBatchResponse> => {
  return customMutator<postV2TriggerNightlyBatchResponse>(
    getPostV2TriggerNightlyBatchUrl(userId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2TriggerNightlyBatchMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2TriggerNightlyBatch>>,
    TError,
    { userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2TriggerNightlyBatch>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ["postV2TriggerNightlyBatch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2TriggerNightlyBatch>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return postV2TriggerNightlyBatch(userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2TriggerNightlyBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2TriggerNightlyBatch>>
>;

export type PostV2TriggerNightlyBatchMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Trigger Nightly Batch
 */
export const usePostV2TriggerNightlyBatch = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2TriggerNightlyBatch>>,
      TError,
      { userId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2TriggerNightlyBatch>>,
  TError,
  { userId: string },
  TContext
> => {
  return useMutation(
    getPostV2TriggerNightlyBatchMutationOptions(options),
    queryClient,
  );
};
export type getV2GetNightlyBatchStatusResponse200 = {
  data: NightlyJobStatus;
  status: 200;
};

export type getV2GetNightlyBatchStatusResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetNightlyBatchStatusResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetNightlyBatchStatusResponseSuccess =
  getV2GetNightlyBatchStatusResponse200 & {
    headers: Headers;
  };
export type getV2GetNightlyBatchStatusResponseError = (
  | getV2GetNightlyBatchStatusResponse401
  | getV2GetNightlyBatchStatusResponse422
) & {
  headers: Headers;
};

export type getV2GetNightlyBatchStatusResponse =
  | getV2GetNightlyBatchStatusResponseSuccess
  | getV2GetNightlyBatchStatusResponseError;

export const getGetV2GetNightlyBatchStatusUrl = (
  userId: string,
  jobId: string,
) => {
  return `/api/admin/memory/${userId}/nightly/${jobId}`;
};

/**
 * Read the current status of a fire-and-forget nightly batch job.
 * @summary Get Nightly Batch Status
 */
export const getV2GetNightlyBatchStatus = async (
  userId: string,
  jobId: string,
  options?: RequestInit,
): Promise<getV2GetNightlyBatchStatusResponse> => {
  return customMutator<getV2GetNightlyBatchStatusResponse>(
    getGetV2GetNightlyBatchStatusUrl(userId, jobId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetNightlyBatchStatusQueryKey = (
  userId: string,
  jobId: string,
) => {
  return [`/api/admin/memory/${userId}/nightly/${jobId}`] as const;
};

export const getGetV2GetNightlyBatchStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2GetNightlyBatchStatusQueryKey(userId, jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>
  > = ({ signal }) =>
    getV2GetNightlyBatchStatus(userId, jobId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      userId !== null &&
      userId !== undefined &&
      jobId !== null &&
      jobId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetNightlyBatchStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>
>;
export type GetV2GetNightlyBatchStatusQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetNightlyBatchStatus<
  TData = Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  jobId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>,
          TError,
          Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetNightlyBatchStatus<
  TData = Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>,
          TError,
          Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetNightlyBatchStatus<
  TData = Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Nightly Batch Status
 */

export function useGetV2GetNightlyBatchStatus<
  TData = Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetNightlyBatchStatusQueryOptions(
    userId,
    jobId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Nightly Batch Status
 */
export const prefetchGetV2GetNightlyBatchStatusQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetNightlyBatchStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetNightlyBatchStatusQueryOptions(
    userId,
    jobId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetMemoryOverviewResponse200 = {
  data: MemoryOverview;
  status: 200;
};

export type getV2GetMemoryOverviewResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetMemoryOverviewResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetMemoryOverviewResponseSuccess =
  getV2GetMemoryOverviewResponse200 & {
    headers: Headers;
  };
export type getV2GetMemoryOverviewResponseError = (
  | getV2GetMemoryOverviewResponse401
  | getV2GetMemoryOverviewResponse422
) & {
  headers: Headers;
};

export type getV2GetMemoryOverviewResponse =
  | getV2GetMemoryOverviewResponseSuccess
  | getV2GetMemoryOverviewResponseError;

export const getGetV2GetMemoryOverviewUrl = (userId: string) => {
  return `/api/admin/memory/${userId}/overview`;
};

/**
 * Count summary of the user's account (Otto) memory graph.
 * @summary Get Memory Overview
 */
export const getV2GetMemoryOverview = async (
  userId: string,
  options?: RequestInit,
): Promise<getV2GetMemoryOverviewResponse> => {
  return customMutator<getV2GetMemoryOverviewResponse>(
    getGetV2GetMemoryOverviewUrl(userId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetMemoryOverviewQueryKey = (userId: string) => {
  return [`/api/admin/memory/${userId}/overview`] as const;
};

export const getGetV2GetMemoryOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetMemoryOverview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMemoryOverview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetMemoryOverviewQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetMemoryOverview>>
  > = ({ signal }) =>
    getV2GetMemoryOverview(userId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetMemoryOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetMemoryOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetMemoryOverview>>
>;
export type GetV2GetMemoryOverviewQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetMemoryOverview<
  TData = Awaited<ReturnType<typeof getV2GetMemoryOverview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMemoryOverview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetMemoryOverview>>,
          TError,
          Awaited<ReturnType<typeof getV2GetMemoryOverview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetMemoryOverview<
  TData = Awaited<ReturnType<typeof getV2GetMemoryOverview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMemoryOverview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetMemoryOverview>>,
          TError,
          Awaited<ReturnType<typeof getV2GetMemoryOverview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetMemoryOverview<
  TData = Awaited<ReturnType<typeof getV2GetMemoryOverview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMemoryOverview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Memory Overview
 */

export function useGetV2GetMemoryOverview<
  TData = Awaited<ReturnType<typeof getV2GetMemoryOverview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMemoryOverview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetMemoryOverviewQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Memory Overview
 */
export const prefetchGetV2GetMemoryOverviewQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetMemoryOverview>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMemoryOverview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetMemoryOverviewQueryOptions(userId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2TriggerRatificationPassResponse200 = {
  data: RatificationResult;
  status: 200;
};

export type postV2TriggerRatificationPassResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2TriggerRatificationPassResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2TriggerRatificationPassResponseSuccess =
  postV2TriggerRatificationPassResponse200 & {
    headers: Headers;
  };
export type postV2TriggerRatificationPassResponseError = (
  | postV2TriggerRatificationPassResponse401
  | postV2TriggerRatificationPassResponse422
) & {
  headers: Headers;
};

export type postV2TriggerRatificationPassResponse =
  | postV2TriggerRatificationPassResponseSuccess
  | postV2TriggerRatificationPassResponseError;

export const getPostV2TriggerRatificationPassUrl = (userId: string) => {
  return `/api/admin/memory/${userId}/ratification`;
};

/**
 * Trigger an on-demand ratification sweep for the user (in isolation).
 *
 * Forwards to ``Scheduler.execute_ratification_pass_now``. Runs ONLY
 * the ratification supersession sweep — does NOT run dream pass or
 * community rebuild. Useful for testing ratification behavior
 * without the full nightly fan-out.
 * @summary Trigger Ratification Pass
 */
export const postV2TriggerRatificationPass = async (
  userId: string,
  options?: RequestInit,
): Promise<postV2TriggerRatificationPassResponse> => {
  return customMutator<postV2TriggerRatificationPassResponse>(
    getPostV2TriggerRatificationPassUrl(userId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2TriggerRatificationPassMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2TriggerRatificationPass>>,
    TError,
    { userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2TriggerRatificationPass>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ["postV2TriggerRatificationPass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2TriggerRatificationPass>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return postV2TriggerRatificationPass(userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2TriggerRatificationPassMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2TriggerRatificationPass>>
>;

export type PostV2TriggerRatificationPassMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Trigger Ratification Pass
 */
export const usePostV2TriggerRatificationPass = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2TriggerRatificationPass>>,
      TError,
      { userId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2TriggerRatificationPass>>,
  TError,
  { userId: string },
  TContext
> => {
  return useMutation(
    getPostV2TriggerRatificationPassMutationOptions(options),
    queryClient,
  );
};
export type getV2GetPlatformCostDashboardResponse200 = {
  data: PlatformCostDashboard;
  status: 200;
};

export type getV2GetPlatformCostDashboardResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetPlatformCostDashboardResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetPlatformCostDashboardResponseSuccess =
  getV2GetPlatformCostDashboardResponse200 & {
    headers: Headers;
  };
export type getV2GetPlatformCostDashboardResponseError = (
  | getV2GetPlatformCostDashboardResponse401
  | getV2GetPlatformCostDashboardResponse422
) & {
  headers: Headers;
};

export type getV2GetPlatformCostDashboardResponse =
  | getV2GetPlatformCostDashboardResponseSuccess
  | getV2GetPlatformCostDashboardResponseError;

export const getGetV2GetPlatformCostDashboardUrl = (
  params?: GetV2GetPlatformCostDashboardParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/platform-costs/dashboard?${stringifiedParams}`
    : `/api/admin/platform-costs/dashboard`;
};

/**
 * @summary Get Platform Cost Dashboard
 */
export const getV2GetPlatformCostDashboard = async (
  params?: GetV2GetPlatformCostDashboardParams,
  options?: RequestInit,
): Promise<getV2GetPlatformCostDashboardResponse> => {
  return customMutator<getV2GetPlatformCostDashboardResponse>(
    getGetV2GetPlatformCostDashboardUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetPlatformCostDashboardQueryKey = (
  params?: GetV2GetPlatformCostDashboardParams,
) => {
  return [
    `/api/admin/platform-costs/dashboard`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2GetPlatformCostDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetPlatformCostDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetPlatformCostDashboardQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>
  > = ({ signal }) =>
    getV2GetPlatformCostDashboard(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetPlatformCostDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>
>;
export type GetV2GetPlatformCostDashboardQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetPlatformCostDashboard<
  TData = Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2GetPlatformCostDashboardParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>,
          TError,
          Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetPlatformCostDashboard<
  TData = Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetPlatformCostDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>,
          TError,
          Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetPlatformCostDashboard<
  TData = Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetPlatformCostDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Platform Cost Dashboard
 */

export function useGetV2GetPlatformCostDashboard<
  TData = Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetPlatformCostDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetPlatformCostDashboardQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Platform Cost Dashboard
 */
export const prefetchGetV2GetPlatformCostDashboardQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2GetPlatformCostDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPlatformCostDashboard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetPlatformCostDashboardQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetPlatformCostLogsResponse200 = {
  data: PlatformCostLogsResponse;
  status: 200;
};

export type getV2GetPlatformCostLogsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetPlatformCostLogsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetPlatformCostLogsResponseSuccess =
  getV2GetPlatformCostLogsResponse200 & {
    headers: Headers;
  };
export type getV2GetPlatformCostLogsResponseError = (
  | getV2GetPlatformCostLogsResponse401
  | getV2GetPlatformCostLogsResponse422
) & {
  headers: Headers;
};

export type getV2GetPlatformCostLogsResponse =
  | getV2GetPlatformCostLogsResponseSuccess
  | getV2GetPlatformCostLogsResponseError;

export const getGetV2GetPlatformCostLogsUrl = (
  params?: GetV2GetPlatformCostLogsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/platform-costs/logs?${stringifiedParams}`
    : `/api/admin/platform-costs/logs`;
};

/**
 * @summary Get Platform Cost Logs
 */
export const getV2GetPlatformCostLogs = async (
  params?: GetV2GetPlatformCostLogsParams,
  options?: RequestInit,
): Promise<getV2GetPlatformCostLogsResponse> => {
  return customMutator<getV2GetPlatformCostLogsResponse>(
    getGetV2GetPlatformCostLogsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetPlatformCostLogsQueryKey = (
  params?: GetV2GetPlatformCostLogsParams,
) => {
  return [
    `/api/admin/platform-costs/logs`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2GetPlatformCostLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetPlatformCostLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetPlatformCostLogsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>
  > = ({ signal }) =>
    getV2GetPlatformCostLogs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetPlatformCostLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>
>;
export type GetV2GetPlatformCostLogsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetPlatformCostLogs<
  TData = Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2GetPlatformCostLogsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>,
          TError,
          Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetPlatformCostLogs<
  TData = Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetPlatformCostLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>,
          TError,
          Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetPlatformCostLogs<
  TData = Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetPlatformCostLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Platform Cost Logs
 */

export function useGetV2GetPlatformCostLogs<
  TData = Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetPlatformCostLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetPlatformCostLogsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Platform Cost Logs
 */
export const prefetchGetV2GetPlatformCostLogsQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2GetPlatformCostLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPlatformCostLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetPlatformCostLogsQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ExportPlatformCostLogsResponse200 = {
  data: PlatformCostExportResponse;
  status: 200;
};

export type getV2ExportPlatformCostLogsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ExportPlatformCostLogsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ExportPlatformCostLogsResponseSuccess =
  getV2ExportPlatformCostLogsResponse200 & {
    headers: Headers;
  };
export type getV2ExportPlatformCostLogsResponseError = (
  | getV2ExportPlatformCostLogsResponse401
  | getV2ExportPlatformCostLogsResponse422
) & {
  headers: Headers;
};

export type getV2ExportPlatformCostLogsResponse =
  | getV2ExportPlatformCostLogsResponseSuccess
  | getV2ExportPlatformCostLogsResponseError;

export const getGetV2ExportPlatformCostLogsUrl = (
  params?: GetV2ExportPlatformCostLogsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/platform-costs/logs/export?${stringifiedParams}`
    : `/api/admin/platform-costs/logs/export`;
};

/**
 * @summary Export Platform Cost Logs
 */
export const getV2ExportPlatformCostLogs = async (
  params?: GetV2ExportPlatformCostLogsParams,
  options?: RequestInit,
): Promise<getV2ExportPlatformCostLogsResponse> => {
  return customMutator<getV2ExportPlatformCostLogsResponse>(
    getGetV2ExportPlatformCostLogsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ExportPlatformCostLogsQueryKey = (
  params?: GetV2ExportPlatformCostLogsParams,
) => {
  return [
    `/api/admin/platform-costs/logs/export`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ExportPlatformCostLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportPlatformCostLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ExportPlatformCostLogsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>
  > = ({ signal }) =>
    getV2ExportPlatformCostLogs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ExportPlatformCostLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>
>;
export type GetV2ExportPlatformCostLogsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ExportPlatformCostLogs<
  TData = Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ExportPlatformCostLogsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>,
          TError,
          Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ExportPlatformCostLogs<
  TData = Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportPlatformCostLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>,
          TError,
          Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ExportPlatformCostLogs<
  TData = Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportPlatformCostLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Platform Cost Logs
 */

export function useGetV2ExportPlatformCostLogs<
  TData = Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportPlatformCostLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ExportPlatformCostLogsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Export Platform Cost Logs
 */
export const prefetchGetV2ExportPlatformCostLogsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ExportPlatformCostLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportPlatformCostLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ExportPlatformCostLogsQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getAdminGetUserIpReportResponse200 = {
  data: AccountIPReport;
  status: 200;
};

export type getAdminGetUserIpReportResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getAdminGetUserIpReportResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getAdminGetUserIpReportResponseSuccess =
  getAdminGetUserIpReportResponse200 & {
    headers: Headers;
  };
export type getAdminGetUserIpReportResponseError = (
  | getAdminGetUserIpReportResponse401
  | getAdminGetUserIpReportResponse422
) & {
  headers: Headers;
};

export type getAdminGetUserIpReportResponse =
  | getAdminGetUserIpReportResponseSuccess
  | getAdminGetUserIpReportResponseError;

export const getGetAdminGetUserIpReportUrl = (userId: string) => {
  return `/api/admin/users/${userId}/ip-report`;
};

/**
 * Where an account signed up and signed in from, the other accounts on
 * those IPs or its email domain, and the blocks covering them. Admin-only.
 * @summary Get user IP report
 */
export const getAdminGetUserIpReport = async (
  userId: string,
  options?: RequestInit,
): Promise<getAdminGetUserIpReportResponse> => {
  return customMutator<getAdminGetUserIpReportResponse>(
    getGetAdminGetUserIpReportUrl(userId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminGetUserIpReportQueryKey = (userId: string) => {
  return [`/api/admin/users/${userId}/ip-report`] as const;
};

export const getGetAdminGetUserIpReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminGetUserIpReport>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminGetUserIpReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminGetUserIpReportQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminGetUserIpReport>>
  > = ({ signal }) =>
    getAdminGetUserIpReport(userId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminGetUserIpReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminGetUserIpReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminGetUserIpReport>>
>;
export type GetAdminGetUserIpReportQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetAdminGetUserIpReport<
  TData = Awaited<ReturnType<typeof getAdminGetUserIpReport>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminGetUserIpReport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminGetUserIpReport>>,
          TError,
          Awaited<ReturnType<typeof getAdminGetUserIpReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminGetUserIpReport<
  TData = Awaited<ReturnType<typeof getAdminGetUserIpReport>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminGetUserIpReport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminGetUserIpReport>>,
          TError,
          Awaited<ReturnType<typeof getAdminGetUserIpReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminGetUserIpReport<
  TData = Awaited<ReturnType<typeof getAdminGetUserIpReport>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminGetUserIpReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get user IP report
 */

export function useGetAdminGetUserIpReport<
  TData = Awaited<ReturnType<typeof getAdminGetUserIpReport>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminGetUserIpReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminGetUserIpReportQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get user IP report
 */
export const prefetchGetAdminGetUserIpReportQuery = async <
  TData = Awaited<ReturnType<typeof getAdminGetUserIpReport>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminGetUserIpReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetAdminGetUserIpReportQueryOptions(userId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getAdminGetUserOrganizationsResponse200 = {
  data: OrgResponse[];
  status: 200;
};

export type getAdminGetUserOrganizationsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getAdminGetUserOrganizationsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getAdminGetUserOrganizationsResponseSuccess =
  getAdminGetUserOrganizationsResponse200 & {
    headers: Headers;
  };
export type getAdminGetUserOrganizationsResponseError = (
  | getAdminGetUserOrganizationsResponse401
  | getAdminGetUserOrganizationsResponse422
) & {
  headers: Headers;
};

export type getAdminGetUserOrganizationsResponse =
  | getAdminGetUserOrganizationsResponseSuccess
  | getAdminGetUserOrganizationsResponseError;

export const getGetAdminGetUserOrganizationsUrl = (userId: string) => {
  return `/api/admin/users/${userId}/organizations`;
};

/**
 * The organizations a user is an active member of. Admin-only.
 * @summary Get user organizations
 */
export const getAdminGetUserOrganizations = async (
  userId: string,
  options?: RequestInit,
): Promise<getAdminGetUserOrganizationsResponse> => {
  return customMutator<getAdminGetUserOrganizationsResponse>(
    getGetAdminGetUserOrganizationsUrl(userId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminGetUserOrganizationsQueryKey = (userId: string) => {
  return [`/api/admin/users/${userId}/organizations`] as const;
};

export const getGetAdminGetUserOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminGetUserOrganizations>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminGetUserOrganizations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminGetUserOrganizationsQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminGetUserOrganizations>>
  > = ({ signal }) =>
    getAdminGetUserOrganizations(userId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminGetUserOrganizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminGetUserOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminGetUserOrganizations>>
>;
export type GetAdminGetUserOrganizationsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetAdminGetUserOrganizations<
  TData = Awaited<ReturnType<typeof getAdminGetUserOrganizations>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminGetUserOrganizations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminGetUserOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getAdminGetUserOrganizations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminGetUserOrganizations<
  TData = Awaited<ReturnType<typeof getAdminGetUserOrganizations>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminGetUserOrganizations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminGetUserOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getAdminGetUserOrganizations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminGetUserOrganizations<
  TData = Awaited<ReturnType<typeof getAdminGetUserOrganizations>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminGetUserOrganizations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get user organizations
 */

export function useGetAdminGetUserOrganizations<
  TData = Awaited<ReturnType<typeof getAdminGetUserOrganizations>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminGetUserOrganizations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminGetUserOrganizationsQueryOptions(
    userId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get user organizations
 */
export const prefetchGetAdminGetUserOrganizationsQuery = async <
  TData = Awaited<ReturnType<typeof getAdminGetUserOrganizations>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminGetUserOrganizations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetAdminGetUserOrganizationsQueryOptions(
    userId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetUserRateLimitResponse200 = {
  data: UserRateLimitResponse;
  status: 200;
};

export type getV2GetUserRateLimitResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetUserRateLimitResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetUserRateLimitResponseSuccess =
  getV2GetUserRateLimitResponse200 & {
    headers: Headers;
  };
export type getV2GetUserRateLimitResponseError = (
  | getV2GetUserRateLimitResponse401
  | getV2GetUserRateLimitResponse422
) & {
  headers: Headers;
};

export type getV2GetUserRateLimitResponse =
  | getV2GetUserRateLimitResponseSuccess
  | getV2GetUserRateLimitResponseError;

export const getGetV2GetUserRateLimitUrl = (
  params?: GetV2GetUserRateLimitParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/copilot/admin/rate_limit?${stringifiedParams}`
    : `/api/copilot/admin/rate_limit`;
};

/**
 * Get a user's current usage and effective rate limits. Admin-only.
 *
 * Accepts either ``user_id`` or ``email`` as a query parameter.
 * When ``email`` is provided the user is looked up by email first.
 * @summary Get User Rate Limit
 */
export const getV2GetUserRateLimit = async (
  params?: GetV2GetUserRateLimitParams,
  options?: RequestInit,
): Promise<getV2GetUserRateLimitResponse> => {
  return customMutator<getV2GetUserRateLimitResponse>(
    getGetV2GetUserRateLimitUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetUserRateLimitQueryKey = (
  params?: GetV2GetUserRateLimitParams,
) => {
  return [
    `/api/copilot/admin/rate_limit`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2GetUserRateLimitQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetUserRateLimit>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetUserRateLimitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserRateLimit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetUserRateLimitQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetUserRateLimit>>
  > = ({ signal }) =>
    getV2GetUserRateLimit(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetUserRateLimit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetUserRateLimitQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetUserRateLimit>>
>;
export type GetV2GetUserRateLimitQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetUserRateLimit<
  TData = Awaited<ReturnType<typeof getV2GetUserRateLimit>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2GetUserRateLimitParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserRateLimit>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetUserRateLimit>>,
          TError,
          Awaited<ReturnType<typeof getV2GetUserRateLimit>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetUserRateLimit<
  TData = Awaited<ReturnType<typeof getV2GetUserRateLimit>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetUserRateLimitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserRateLimit>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetUserRateLimit>>,
          TError,
          Awaited<ReturnType<typeof getV2GetUserRateLimit>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetUserRateLimit<
  TData = Awaited<ReturnType<typeof getV2GetUserRateLimit>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetUserRateLimitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserRateLimit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User Rate Limit
 */

export function useGetV2GetUserRateLimit<
  TData = Awaited<ReturnType<typeof getV2GetUserRateLimit>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetUserRateLimitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserRateLimit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetUserRateLimitQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get User Rate Limit
 */
export const prefetchGetV2GetUserRateLimitQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetUserRateLimit>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2GetUserRateLimitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserRateLimit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetUserRateLimitQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2ResetUserRateLimitUsageResponse200 = {
  data: UserRateLimitResponse;
  status: 200;
};

export type postV2ResetUserRateLimitUsageResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2ResetUserRateLimitUsageResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2ResetUserRateLimitUsageResponseSuccess =
  postV2ResetUserRateLimitUsageResponse200 & {
    headers: Headers;
  };
export type postV2ResetUserRateLimitUsageResponseError = (
  | postV2ResetUserRateLimitUsageResponse401
  | postV2ResetUserRateLimitUsageResponse422
) & {
  headers: Headers;
};

export type postV2ResetUserRateLimitUsageResponse =
  | postV2ResetUserRateLimitUsageResponseSuccess
  | postV2ResetUserRateLimitUsageResponseError;

export const getPostV2ResetUserRateLimitUsageUrl = () => {
  return `/api/copilot/admin/rate_limit/reset`;
};

/**
 * Reset a user's daily usage counter (and optionally weekly). Admin-only.
 * @summary Reset User Rate Limit Usage
 */
export const postV2ResetUserRateLimitUsage = async (
  bodyPostV2ResetUserRateLimitUsage: BodyPostV2ResetUserRateLimitUsage,
  options?: RequestInit,
): Promise<postV2ResetUserRateLimitUsageResponse> => {
  return customMutator<postV2ResetUserRateLimitUsageResponse>(
    getPostV2ResetUserRateLimitUsageUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(bodyPostV2ResetUserRateLimitUsage),
    },
  );
};

export const getPostV2ResetUserRateLimitUsageMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2ResetUserRateLimitUsage>>,
    TError,
    { data: BodyPostV2ResetUserRateLimitUsage },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2ResetUserRateLimitUsage>>,
  TError,
  { data: BodyPostV2ResetUserRateLimitUsage },
  TContext
> => {
  const mutationKey = ["postV2ResetUserRateLimitUsage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2ResetUserRateLimitUsage>>,
    { data: BodyPostV2ResetUserRateLimitUsage }
  > = (props) => {
    const { data } = props ?? {};

    return postV2ResetUserRateLimitUsage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2ResetUserRateLimitUsageMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2ResetUserRateLimitUsage>>
>;
export type PostV2ResetUserRateLimitUsageMutationBody =
  BodyPostV2ResetUserRateLimitUsage;
export type PostV2ResetUserRateLimitUsageMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Reset User Rate Limit Usage
 */
export const usePostV2ResetUserRateLimitUsage = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2ResetUserRateLimitUsage>>,
      TError,
      { data: BodyPostV2ResetUserRateLimitUsage },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2ResetUserRateLimitUsage>>,
  TError,
  { data: BodyPostV2ResetUserRateLimitUsage },
  TContext
> => {
  return useMutation(
    getPostV2ResetUserRateLimitUsageMutationOptions(options),
    queryClient,
  );
};
export type getV2SearchUsersByNameOrEmailResponse200 = {
  data: UserSearchResult[];
  status: 200;
};

export type getV2SearchUsersByNameOrEmailResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2SearchUsersByNameOrEmailResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2SearchUsersByNameOrEmailResponseSuccess =
  getV2SearchUsersByNameOrEmailResponse200 & {
    headers: Headers;
  };
export type getV2SearchUsersByNameOrEmailResponseError = (
  | getV2SearchUsersByNameOrEmailResponse401
  | getV2SearchUsersByNameOrEmailResponse422
) & {
  headers: Headers;
};

export type getV2SearchUsersByNameOrEmailResponse =
  | getV2SearchUsersByNameOrEmailResponseSuccess
  | getV2SearchUsersByNameOrEmailResponseError;

export const getGetV2SearchUsersByNameOrEmailUrl = (
  params: GetV2SearchUsersByNameOrEmailParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/copilot/admin/rate_limit/search_users?${stringifiedParams}`
    : `/api/copilot/admin/rate_limit/search_users`;
};

/**
 * Search users by partial email or name. Admin-only.
 *
 * Queries the User table directly — returns results even for users
 * without credit transaction history.
 * @summary Search Users by Name or Email
 */
export const getV2SearchUsersByNameOrEmail = async (
  params: GetV2SearchUsersByNameOrEmailParams,
  options?: RequestInit,
): Promise<getV2SearchUsersByNameOrEmailResponse> => {
  return customMutator<getV2SearchUsersByNameOrEmailResponse>(
    getGetV2SearchUsersByNameOrEmailUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2SearchUsersByNameOrEmailQueryKey = (
  params?: GetV2SearchUsersByNameOrEmailParams,
) => {
  return [
    `/api/copilot/admin/rate_limit/search_users`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2SearchUsersByNameOrEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2SearchUsersByNameOrEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2SearchUsersByNameOrEmailQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>
  > = ({ signal }) =>
    getV2SearchUsersByNameOrEmail(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2SearchUsersByNameOrEmailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>
>;
export type GetV2SearchUsersByNameOrEmailQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2SearchUsersByNameOrEmail<
  TData = Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2SearchUsersByNameOrEmailParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>,
          TError,
          Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2SearchUsersByNameOrEmail<
  TData = Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2SearchUsersByNameOrEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>,
          TError,
          Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2SearchUsersByNameOrEmail<
  TData = Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2SearchUsersByNameOrEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Users by Name or Email
 */

export function useGetV2SearchUsersByNameOrEmail<
  TData = Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2SearchUsersByNameOrEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2SearchUsersByNameOrEmailQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Search Users by Name or Email
 */
export const prefetchGetV2SearchUsersByNameOrEmailQuery = async <
  TData = Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params: GetV2SearchUsersByNameOrEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2SearchUsersByNameOrEmail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2SearchUsersByNameOrEmailQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetUserRateLimitTierResponse200 = {
  data: UserTierResponse;
  status: 200;
};

export type getV2GetUserRateLimitTierResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetUserRateLimitTierResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetUserRateLimitTierResponseSuccess =
  getV2GetUserRateLimitTierResponse200 & {
    headers: Headers;
  };
export type getV2GetUserRateLimitTierResponseError = (
  | getV2GetUserRateLimitTierResponse401
  | getV2GetUserRateLimitTierResponse422
) & {
  headers: Headers;
};

export type getV2GetUserRateLimitTierResponse =
  | getV2GetUserRateLimitTierResponseSuccess
  | getV2GetUserRateLimitTierResponseError;

export const getGetV2GetUserRateLimitTierUrl = (
  params: GetV2GetUserRateLimitTierParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/copilot/admin/rate_limit/tier?${stringifiedParams}`
    : `/api/copilot/admin/rate_limit/tier`;
};

/**
 * Get a user's current rate-limit tier. Admin-only.
 *
 * Returns 404 if the user does not exist in the database.
 * @summary Get User Rate Limit Tier
 */
export const getV2GetUserRateLimitTier = async (
  params: GetV2GetUserRateLimitTierParams,
  options?: RequestInit,
): Promise<getV2GetUserRateLimitTierResponse> => {
  return customMutator<getV2GetUserRateLimitTierResponse>(
    getGetV2GetUserRateLimitTierUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetUserRateLimitTierQueryKey = (
  params?: GetV2GetUserRateLimitTierParams,
) => {
  return [
    `/api/copilot/admin/rate_limit/tier`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2GetUserRateLimitTierQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2GetUserRateLimitTierParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetUserRateLimitTierQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>
  > = ({ signal }) =>
    getV2GetUserRateLimitTier(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetUserRateLimitTierQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>
>;
export type GetV2GetUserRateLimitTierQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetUserRateLimitTier<
  TData = Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2GetUserRateLimitTierParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>,
          TError,
          Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetUserRateLimitTier<
  TData = Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2GetUserRateLimitTierParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>,
          TError,
          Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetUserRateLimitTier<
  TData = Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2GetUserRateLimitTierParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User Rate Limit Tier
 */

export function useGetV2GetUserRateLimitTier<
  TData = Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2GetUserRateLimitTierParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetUserRateLimitTierQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get User Rate Limit Tier
 */
export const prefetchGetV2GetUserRateLimitTierQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params: GetV2GetUserRateLimitTierParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserRateLimitTier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetUserRateLimitTierQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2SetUserRateLimitTierResponse200 = {
  data: UserTierResponse;
  status: 200;
};

export type postV2SetUserRateLimitTierResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2SetUserRateLimitTierResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2SetUserRateLimitTierResponseSuccess =
  postV2SetUserRateLimitTierResponse200 & {
    headers: Headers;
  };
export type postV2SetUserRateLimitTierResponseError = (
  | postV2SetUserRateLimitTierResponse401
  | postV2SetUserRateLimitTierResponse422
) & {
  headers: Headers;
};

export type postV2SetUserRateLimitTierResponse =
  | postV2SetUserRateLimitTierResponseSuccess
  | postV2SetUserRateLimitTierResponseError;

export const getPostV2SetUserRateLimitTierUrl = () => {
  return `/api/copilot/admin/rate_limit/tier`;
};

/**
 * Set a user's rate-limit tier. Admin-only.
 *
 * Returns 404 if the user does not exist in the database.
 * @summary Set User Rate Limit Tier
 */
export const postV2SetUserRateLimitTier = async (
  setUserTierRequest: SetUserTierRequest,
  options?: RequestInit,
): Promise<postV2SetUserRateLimitTierResponse> => {
  return customMutator<postV2SetUserRateLimitTierResponse>(
    getPostV2SetUserRateLimitTierUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(setUserTierRequest),
    },
  );
};

export const getPostV2SetUserRateLimitTierMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2SetUserRateLimitTier>>,
    TError,
    { data: SetUserTierRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2SetUserRateLimitTier>>,
  TError,
  { data: SetUserTierRequest },
  TContext
> => {
  const mutationKey = ["postV2SetUserRateLimitTier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2SetUserRateLimitTier>>,
    { data: SetUserTierRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2SetUserRateLimitTier(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2SetUserRateLimitTierMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2SetUserRateLimitTier>>
>;
export type PostV2SetUserRateLimitTierMutationBody = SetUserTierRequest;
export type PostV2SetUserRateLimitTierMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Set User Rate Limit Tier
 */
export const usePostV2SetUserRateLimitTier = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2SetUserRateLimitTier>>,
      TError,
      { data: SetUserTierRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2SetUserRateLimitTier>>,
  TError,
  { data: SetUserTierRequest },
  TContext
> => {
  return useMutation(
    getPostV2SetUserRateLimitTierMutationOptions(options),
    queryClient,
  );
};
export type postV2AddCreditsToUserResponse200 = {
  data: AddUserCreditsResponse;
  status: 200;
};

export type postV2AddCreditsToUserResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2AddCreditsToUserResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2AddCreditsToUserResponseSuccess =
  postV2AddCreditsToUserResponse200 & {
    headers: Headers;
  };
export type postV2AddCreditsToUserResponseError = (
  | postV2AddCreditsToUserResponse401
  | postV2AddCreditsToUserResponse422
) & {
  headers: Headers;
};

export type postV2AddCreditsToUserResponse =
  | postV2AddCreditsToUserResponseSuccess
  | postV2AddCreditsToUserResponseError;

export const getPostV2AddCreditsToUserUrl = () => {
  return `/api/credits/admin/add_credits`;
};

/**
 * @summary Add Credits to User
 */
export const postV2AddCreditsToUser = async (
  bodyPostV2AddCreditsToUser: BodyPostV2AddCreditsToUser,
  options?: RequestInit,
): Promise<postV2AddCreditsToUserResponse> => {
  return customMutator<postV2AddCreditsToUserResponse>(
    getPostV2AddCreditsToUserUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(bodyPostV2AddCreditsToUser),
    },
  );
};

export const getPostV2AddCreditsToUserMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2AddCreditsToUser>>,
    TError,
    { data: BodyPostV2AddCreditsToUser },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2AddCreditsToUser>>,
  TError,
  { data: BodyPostV2AddCreditsToUser },
  TContext
> => {
  const mutationKey = ["postV2AddCreditsToUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2AddCreditsToUser>>,
    { data: BodyPostV2AddCreditsToUser }
  > = (props) => {
    const { data } = props ?? {};

    return postV2AddCreditsToUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2AddCreditsToUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2AddCreditsToUser>>
>;
export type PostV2AddCreditsToUserMutationBody = BodyPostV2AddCreditsToUser;
export type PostV2AddCreditsToUserMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Add Credits to User
 */
export const usePostV2AddCreditsToUser = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2AddCreditsToUser>>,
      TError,
      { data: BodyPostV2AddCreditsToUser },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2AddCreditsToUser>>,
  TError,
  { data: BodyPostV2AddCreditsToUser },
  TContext
> => {
  return useMutation(
    getPostV2AddCreditsToUserMutationOptions(options),
    queryClient,
  );
};
export type getV2ExportCopilotWeeklyUsageVsRateLimitResponse200 = {
  data: CopilotUsageExportResponse;
  status: 200;
};

export type getV2ExportCopilotWeeklyUsageVsRateLimitResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ExportCopilotWeeklyUsageVsRateLimitResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ExportCopilotWeeklyUsageVsRateLimitResponseSuccess =
  getV2ExportCopilotWeeklyUsageVsRateLimitResponse200 & {
    headers: Headers;
  };
export type getV2ExportCopilotWeeklyUsageVsRateLimitResponseError = (
  | getV2ExportCopilotWeeklyUsageVsRateLimitResponse401
  | getV2ExportCopilotWeeklyUsageVsRateLimitResponse422
) & {
  headers: Headers;
};

export type getV2ExportCopilotWeeklyUsageVsRateLimitResponse =
  | getV2ExportCopilotWeeklyUsageVsRateLimitResponseSuccess
  | getV2ExportCopilotWeeklyUsageVsRateLimitResponseError;

export const getGetV2ExportCopilotWeeklyUsageVsRateLimitUrl = (
  params?: GetV2ExportCopilotWeeklyUsageVsRateLimitParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/credits/admin/copilot-usage/export?${stringifiedParams}`
    : `/api/credits/admin/copilot-usage/export`;
};

/**
 * Export per-(user, ISO week) copilot spend with the user's tier limit.
 *
 * Uses the same 90-day window cap and 100k row cap as the credit export.
 * @summary Export Copilot Weekly Usage vs Rate Limit
 */
export const getV2ExportCopilotWeeklyUsageVsRateLimit = async (
  params?: GetV2ExportCopilotWeeklyUsageVsRateLimitParams,
  options?: RequestInit,
): Promise<getV2ExportCopilotWeeklyUsageVsRateLimitResponse> => {
  return customMutator<getV2ExportCopilotWeeklyUsageVsRateLimitResponse>(
    getGetV2ExportCopilotWeeklyUsageVsRateLimitUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ExportCopilotWeeklyUsageVsRateLimitQueryKey = (
  params?: GetV2ExportCopilotWeeklyUsageVsRateLimitParams,
) => {
  return [
    `/api/credits/admin/copilot-usage/export`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ExportCopilotWeeklyUsageVsRateLimitQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportCopilotWeeklyUsageVsRateLimitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2ExportCopilotWeeklyUsageVsRateLimitQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>
  > = ({ signal }) =>
    getV2ExportCopilotWeeklyUsageVsRateLimit(params, {
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ExportCopilotWeeklyUsageVsRateLimitQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>
>;
export type GetV2ExportCopilotWeeklyUsageVsRateLimitQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ExportCopilotWeeklyUsageVsRateLimit<
  TData = Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ExportCopilotWeeklyUsageVsRateLimitParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>,
          TError,
          Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ExportCopilotWeeklyUsageVsRateLimit<
  TData = Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportCopilotWeeklyUsageVsRateLimitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>,
          TError,
          Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ExportCopilotWeeklyUsageVsRateLimit<
  TData = Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportCopilotWeeklyUsageVsRateLimitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Copilot Weekly Usage vs Rate Limit
 */

export function useGetV2ExportCopilotWeeklyUsageVsRateLimit<
  TData = Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportCopilotWeeklyUsageVsRateLimitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ExportCopilotWeeklyUsageVsRateLimitQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Export Copilot Weekly Usage vs Rate Limit
 */
export const prefetchGetV2ExportCopilotWeeklyUsageVsRateLimitQuery = async <
  TData = Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ExportCopilotWeeklyUsageVsRateLimitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportCopilotWeeklyUsageVsRateLimit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ExportCopilotWeeklyUsageVsRateLimitQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ExportCreditTransactionsResponse200 = {
  data: CreditTransactionsExportResponse;
  status: 200;
};

export type getV2ExportCreditTransactionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ExportCreditTransactionsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ExportCreditTransactionsResponseSuccess =
  getV2ExportCreditTransactionsResponse200 & {
    headers: Headers;
  };
export type getV2ExportCreditTransactionsResponseError = (
  | getV2ExportCreditTransactionsResponse401
  | getV2ExportCreditTransactionsResponse422
) & {
  headers: Headers;
};

export type getV2ExportCreditTransactionsResponse =
  | getV2ExportCreditTransactionsResponseSuccess
  | getV2ExportCreditTransactionsResponseError;

export const getGetV2ExportCreditTransactionsUrl = (
  params?: GetV2ExportCreditTransactionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/credits/admin/transactions/export?${stringifiedParams}`
    : `/api/credits/admin/transactions/export`;
};

/**
 * Export CreditTransaction rows in [start, end].
 *
 * Capped at CREDIT_EXPORT_MAX_DAYS days and CREDIT_EXPORT_MAX_ROWS rows;
 * over-cap requests fail fast with 400 so callers narrow the window
 * instead of receiving silently truncated data.
 * @summary Export Credit Transactions
 */
export const getV2ExportCreditTransactions = async (
  params?: GetV2ExportCreditTransactionsParams,
  options?: RequestInit,
): Promise<getV2ExportCreditTransactionsResponse> => {
  return customMutator<getV2ExportCreditTransactionsResponse>(
    getGetV2ExportCreditTransactionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ExportCreditTransactionsQueryKey = (
  params?: GetV2ExportCreditTransactionsParams,
) => {
  return [
    `/api/credits/admin/transactions/export`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ExportCreditTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ExportCreditTransactions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportCreditTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportCreditTransactions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ExportCreditTransactionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ExportCreditTransactions>>
  > = ({ signal }) =>
    getV2ExportCreditTransactions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ExportCreditTransactions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ExportCreditTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ExportCreditTransactions>>
>;
export type GetV2ExportCreditTransactionsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ExportCreditTransactions<
  TData = Awaited<ReturnType<typeof getV2ExportCreditTransactions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ExportCreditTransactionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportCreditTransactions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ExportCreditTransactions>>,
          TError,
          Awaited<ReturnType<typeof getV2ExportCreditTransactions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ExportCreditTransactions<
  TData = Awaited<ReturnType<typeof getV2ExportCreditTransactions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportCreditTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportCreditTransactions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ExportCreditTransactions>>,
          TError,
          Awaited<ReturnType<typeof getV2ExportCreditTransactions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ExportCreditTransactions<
  TData = Awaited<ReturnType<typeof getV2ExportCreditTransactions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportCreditTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportCreditTransactions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Credit Transactions
 */

export function useGetV2ExportCreditTransactions<
  TData = Awaited<ReturnType<typeof getV2ExportCreditTransactions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ExportCreditTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportCreditTransactions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ExportCreditTransactionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Export Credit Transactions
 */
export const prefetchGetV2ExportCreditTransactionsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ExportCreditTransactions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ExportCreditTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ExportCreditTransactions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ExportCreditTransactionsQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetAllUsersHistoryResponse200 = {
  data: UserHistoryResponse;
  status: 200;
};

export type getV2GetAllUsersHistoryResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetAllUsersHistoryResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetAllUsersHistoryResponseSuccess =
  getV2GetAllUsersHistoryResponse200 & {
    headers: Headers;
  };
export type getV2GetAllUsersHistoryResponseError = (
  | getV2GetAllUsersHistoryResponse401
  | getV2GetAllUsersHistoryResponse422
) & {
  headers: Headers;
};

export type getV2GetAllUsersHistoryResponse =
  | getV2GetAllUsersHistoryResponseSuccess
  | getV2GetAllUsersHistoryResponseError;

export const getGetV2GetAllUsersHistoryUrl = (
  params?: GetV2GetAllUsersHistoryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/credits/admin/users_history?${stringifiedParams}`
    : `/api/credits/admin/users_history`;
};

/**
 * @summary Get All Users History
 */
export const getV2GetAllUsersHistory = async (
  params?: GetV2GetAllUsersHistoryParams,
  options?: RequestInit,
): Promise<getV2GetAllUsersHistoryResponse> => {
  return customMutator<getV2GetAllUsersHistoryResponse>(
    getGetV2GetAllUsersHistoryUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetAllUsersHistoryQueryKey = (
  params?: GetV2GetAllUsersHistoryParams,
) => {
  return [
    `/api/credits/admin/users_history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2GetAllUsersHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetAllUsersHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetAllUsersHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAllUsersHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetAllUsersHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetAllUsersHistory>>
  > = ({ signal }) =>
    getV2GetAllUsersHistory(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetAllUsersHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetAllUsersHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetAllUsersHistory>>
>;
export type GetV2GetAllUsersHistoryQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetAllUsersHistory<
  TData = Awaited<ReturnType<typeof getV2GetAllUsersHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2GetAllUsersHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAllUsersHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetAllUsersHistory>>,
          TError,
          Awaited<ReturnType<typeof getV2GetAllUsersHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetAllUsersHistory<
  TData = Awaited<ReturnType<typeof getV2GetAllUsersHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetAllUsersHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAllUsersHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetAllUsersHistory>>,
          TError,
          Awaited<ReturnType<typeof getV2GetAllUsersHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetAllUsersHistory<
  TData = Awaited<ReturnType<typeof getV2GetAllUsersHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetAllUsersHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAllUsersHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All Users History
 */

export function useGetV2GetAllUsersHistory<
  TData = Awaited<ReturnType<typeof getV2GetAllUsersHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetAllUsersHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAllUsersHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetAllUsersHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get All Users History
 */
export const prefetchGetV2GetAllUsersHistoryQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetAllUsersHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2GetAllUsersHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAllUsersHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetAllUsersHistoryQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetExecutionAccuracyTrendsAndAlertsResponse200 = {
  data: AccuracyTrendsResponse;
  status: 200;
};

export type getV2GetExecutionAccuracyTrendsAndAlertsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetExecutionAccuracyTrendsAndAlertsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetExecutionAccuracyTrendsAndAlertsResponseSuccess =
  getV2GetExecutionAccuracyTrendsAndAlertsResponse200 & {
    headers: Headers;
  };
export type getV2GetExecutionAccuracyTrendsAndAlertsResponseError = (
  | getV2GetExecutionAccuracyTrendsAndAlertsResponse401
  | getV2GetExecutionAccuracyTrendsAndAlertsResponse422
) & {
  headers: Headers;
};

export type getV2GetExecutionAccuracyTrendsAndAlertsResponse =
  | getV2GetExecutionAccuracyTrendsAndAlertsResponseSuccess
  | getV2GetExecutionAccuracyTrendsAndAlertsResponseError;

export const getGetV2GetExecutionAccuracyTrendsAndAlertsUrl = (
  params: GetV2GetExecutionAccuracyTrendsAndAlertsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/executions/admin/execution_accuracy_trends?${stringifiedParams}`
    : `/api/executions/admin/execution_accuracy_trends`;
};

/**
 * Get execution accuracy trends with moving averages and alert detection.
 * Simple single-query approach.
 * @summary Get Execution Accuracy Trends and Alerts
 */
export const getV2GetExecutionAccuracyTrendsAndAlerts = async (
  params: GetV2GetExecutionAccuracyTrendsAndAlertsParams,
  options?: RequestInit,
): Promise<getV2GetExecutionAccuracyTrendsAndAlertsResponse> => {
  return customMutator<getV2GetExecutionAccuracyTrendsAndAlertsResponse>(
    getGetV2GetExecutionAccuracyTrendsAndAlertsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetExecutionAccuracyTrendsAndAlertsQueryKey = (
  params?: GetV2GetExecutionAccuracyTrendsAndAlertsParams,
) => {
  return [
    `/api/executions/admin/execution_accuracy_trends`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2GetExecutionAccuracyTrendsAndAlertsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2GetExecutionAccuracyTrendsAndAlertsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2GetExecutionAccuracyTrendsAndAlertsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>
  > = ({ signal }) =>
    getV2GetExecutionAccuracyTrendsAndAlerts(params, {
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetExecutionAccuracyTrendsAndAlertsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>
>;
export type GetV2GetExecutionAccuracyTrendsAndAlertsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetExecutionAccuracyTrendsAndAlerts<
  TData = Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2GetExecutionAccuracyTrendsAndAlertsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>,
          TError,
          Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetExecutionAccuracyTrendsAndAlerts<
  TData = Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2GetExecutionAccuracyTrendsAndAlertsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>,
          TError,
          Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetExecutionAccuracyTrendsAndAlerts<
  TData = Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2GetExecutionAccuracyTrendsAndAlertsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Execution Accuracy Trends and Alerts
 */

export function useGetV2GetExecutionAccuracyTrendsAndAlerts<
  TData = Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: GetV2GetExecutionAccuracyTrendsAndAlertsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetExecutionAccuracyTrendsAndAlertsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Execution Accuracy Trends and Alerts
 */
export const prefetchGetV2GetExecutionAccuracyTrendsAndAlertsQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params: GetV2GetExecutionAccuracyTrendsAndAlertsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionAccuracyTrendsAndAlerts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetExecutionAccuracyTrendsAndAlertsQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2GenerateExecutionAnalyticsResponse200 = {
  data: ExecutionAnalyticsResponse;
  status: 200;
};

export type postV2GenerateExecutionAnalyticsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2GenerateExecutionAnalyticsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2GenerateExecutionAnalyticsResponseSuccess =
  postV2GenerateExecutionAnalyticsResponse200 & {
    headers: Headers;
  };
export type postV2GenerateExecutionAnalyticsResponseError = (
  | postV2GenerateExecutionAnalyticsResponse401
  | postV2GenerateExecutionAnalyticsResponse422
) & {
  headers: Headers;
};

export type postV2GenerateExecutionAnalyticsResponse =
  | postV2GenerateExecutionAnalyticsResponseSuccess
  | postV2GenerateExecutionAnalyticsResponseError;

export const getPostV2GenerateExecutionAnalyticsUrl = () => {
  return `/api/executions/admin/execution_analytics`;
};

/**
 * Generate activity summaries and correctness scores for graph executions.
 *
 * This endpoint:
 * 1. Fetches all terminal executions matching the criteria
 * 2. Identifies executions missing a complete activity analysis
 * 3. Generates missing data in batches, using deterministic results where available
 * 4. Updates the database with new stats
 * 5. Returns a detailed report of the analytics operation
 * @summary Generate Execution Analytics
 */
export const postV2GenerateExecutionAnalytics = async (
  executionAnalyticsRequest: ExecutionAnalyticsRequest,
  options?: RequestInit,
): Promise<postV2GenerateExecutionAnalyticsResponse> => {
  return customMutator<postV2GenerateExecutionAnalyticsResponse>(
    getPostV2GenerateExecutionAnalyticsUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(executionAnalyticsRequest),
    },
  );
};

export const getPostV2GenerateExecutionAnalyticsMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2GenerateExecutionAnalytics>>,
    TError,
    { data: ExecutionAnalyticsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2GenerateExecutionAnalytics>>,
  TError,
  { data: ExecutionAnalyticsRequest },
  TContext
> => {
  const mutationKey = ["postV2GenerateExecutionAnalytics"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2GenerateExecutionAnalytics>>,
    { data: ExecutionAnalyticsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2GenerateExecutionAnalytics(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2GenerateExecutionAnalyticsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2GenerateExecutionAnalytics>>
>;
export type PostV2GenerateExecutionAnalyticsMutationBody =
  ExecutionAnalyticsRequest;
export type PostV2GenerateExecutionAnalyticsMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Generate Execution Analytics
 */
export const usePostV2GenerateExecutionAnalytics = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2GenerateExecutionAnalytics>>,
      TError,
      { data: ExecutionAnalyticsRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2GenerateExecutionAnalytics>>,
  TError,
  { data: ExecutionAnalyticsRequest },
  TContext
> => {
  return useMutation(
    getPostV2GenerateExecutionAnalyticsMutationOptions(options),
    queryClient,
  );
};
export type getV2GetExecutionAnalyticsConfigurationResponse200 = {
  data: ExecutionAnalyticsConfig;
  status: 200;
};

export type getV2GetExecutionAnalyticsConfigurationResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetExecutionAnalyticsConfigurationResponseSuccess =
  getV2GetExecutionAnalyticsConfigurationResponse200 & {
    headers: Headers;
  };
export type getV2GetExecutionAnalyticsConfigurationResponseError =
  getV2GetExecutionAnalyticsConfigurationResponse401 & {
    headers: Headers;
  };

export type getV2GetExecutionAnalyticsConfigurationResponse =
  | getV2GetExecutionAnalyticsConfigurationResponseSuccess
  | getV2GetExecutionAnalyticsConfigurationResponseError;

export const getGetV2GetExecutionAnalyticsConfigurationUrl = () => {
  return `/api/executions/admin/execution_analytics/config`;
};

/**
 * Get the configuration for execution analytics including:
 * - Available AI models with metadata
 * - Default system and user prompts
 * - Recommended model selection
 * @summary Get Execution Analytics Configuration
 */
export const getV2GetExecutionAnalyticsConfiguration = async (
  options?: RequestInit,
): Promise<getV2GetExecutionAnalyticsConfigurationResponse> => {
  return customMutator<getV2GetExecutionAnalyticsConfigurationResponse>(
    getGetV2GetExecutionAnalyticsConfigurationUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetExecutionAnalyticsConfigurationQueryKey = () => {
  return [`/api/executions/admin/execution_analytics/config`] as const;
};

export const getGetV2GetExecutionAnalyticsConfigurationQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2GetExecutionAnalyticsConfigurationQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>
  > = ({ signal }) =>
    getV2GetExecutionAnalyticsConfiguration({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetExecutionAnalyticsConfigurationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>
>;
export type GetV2GetExecutionAnalyticsConfigurationQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV2GetExecutionAnalyticsConfiguration<
  TData = Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetExecutionAnalyticsConfiguration<
  TData = Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetExecutionAnalyticsConfiguration<
  TData = Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Execution Analytics Configuration
 */

export function useGetV2GetExecutionAnalyticsConfiguration<
  TData = Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetV2GetExecutionAnalyticsConfigurationQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Execution Analytics Configuration
 */
export const prefetchGetV2GetExecutionAnalyticsConfigurationQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetExecutionAnalyticsConfiguration>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions =
    getGetV2GetExecutionAnalyticsConfigurationQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetAdminListingsHistoryResponse200 = {
  data: StoreListingsWithVersionsAdminViewResponse;
  status: 200;
};

export type getV2GetAdminListingsHistoryResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetAdminListingsHistoryResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetAdminListingsHistoryResponseSuccess =
  getV2GetAdminListingsHistoryResponse200 & {
    headers: Headers;
  };
export type getV2GetAdminListingsHistoryResponseError = (
  | getV2GetAdminListingsHistoryResponse401
  | getV2GetAdminListingsHistoryResponse422
) & {
  headers: Headers;
};

export type getV2GetAdminListingsHistoryResponse =
  | getV2GetAdminListingsHistoryResponseSuccess
  | getV2GetAdminListingsHistoryResponseError;

export const getGetV2GetAdminListingsHistoryUrl = (
  params?: GetV2GetAdminListingsHistoryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/store/admin/listings?${stringifiedParams}`
    : `/api/store/admin/listings`;
};

/**
 * Get store listings with their version history for admins.
 *
 * This provides a consolidated view of listings with their versions,
 * allowing for an expandable UI in the admin dashboard.
 *
 * Args:
 *     status: Filter by submission status (PENDING, APPROVED, REJECTED)
 *     search: Search by name, description, or user email
 *     page: Page number for pagination
 *     page_size: Number of items per page
 *
 * Returns:
 *     Paginated listings with their versions
 * @summary Get Admin Listings History
 */
export const getV2GetAdminListingsHistory = async (
  params?: GetV2GetAdminListingsHistoryParams,
  options?: RequestInit,
): Promise<getV2GetAdminListingsHistoryResponse> => {
  return customMutator<getV2GetAdminListingsHistoryResponse>(
    getGetV2GetAdminListingsHistoryUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetAdminListingsHistoryQueryKey = (
  params?: GetV2GetAdminListingsHistoryParams,
) => {
  return [`/api/store/admin/listings`, ...(params ? [params] : [])] as const;
};

export const getGetV2GetAdminListingsHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetAdminListingsHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetAdminListingsHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>
  > = ({ signal }) =>
    getV2GetAdminListingsHistory(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetAdminListingsHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>
>;
export type GetV2GetAdminListingsHistoryQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetAdminListingsHistory<
  TData = Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2GetAdminListingsHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>,
          TError,
          Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetAdminListingsHistory<
  TData = Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetAdminListingsHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>,
          TError,
          Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetAdminListingsHistory<
  TData = Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetAdminListingsHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Admin Listings History
 */

export function useGetV2GetAdminListingsHistory<
  TData = Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetAdminListingsHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetAdminListingsHistoryQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Admin Listings History
 */
export const prefetchGetV2GetAdminListingsHistoryQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2GetAdminListingsHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAdminListingsHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetAdminListingsHistoryQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2AdminListPendingSkillSubmissionsResponse200 = {
  data: SkillSubmission[];
  status: 200;
};

export type getV2AdminListPendingSkillSubmissionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2AdminListPendingSkillSubmissionsResponseSuccess =
  getV2AdminListPendingSkillSubmissionsResponse200 & {
    headers: Headers;
  };
export type getV2AdminListPendingSkillSubmissionsResponseError =
  getV2AdminListPendingSkillSubmissionsResponse401 & {
    headers: Headers;
  };

export type getV2AdminListPendingSkillSubmissionsResponse =
  | getV2AdminListPendingSkillSubmissionsResponseSuccess
  | getV2AdminListPendingSkillSubmissionsResponseError;

export const getGetV2AdminListPendingSkillSubmissionsUrl = () => {
  return `/api/store/admin/skills/submissions`;
};

/**
 * Skill submissions awaiting review, oldest first.
 * @summary Admin List Pending Skill Submissions
 */
export const getV2AdminListPendingSkillSubmissions = async (
  options?: RequestInit,
): Promise<getV2AdminListPendingSkillSubmissionsResponse> => {
  return customMutator<getV2AdminListPendingSkillSubmissionsResponse>(
    getGetV2AdminListPendingSkillSubmissionsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2AdminListPendingSkillSubmissionsQueryKey = () => {
  return [`/api/store/admin/skills/submissions`] as const;
};

export const getGetV2AdminListPendingSkillSubmissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2AdminListPendingSkillSubmissionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>
  > = ({ signal }) =>
    getV2AdminListPendingSkillSubmissions({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2AdminListPendingSkillSubmissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>
>;
export type GetV2AdminListPendingSkillSubmissionsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV2AdminListPendingSkillSubmissions<
  TData = Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>,
          TError,
          Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2AdminListPendingSkillSubmissions<
  TData = Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>,
          TError,
          Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2AdminListPendingSkillSubmissions<
  TData = Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Admin List Pending Skill Submissions
 */

export function useGetV2AdminListPendingSkillSubmissions<
  TData = Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetV2AdminListPendingSkillSubmissionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Admin List Pending Skill Submissions
 */
export const prefetchGetV2AdminListPendingSkillSubmissionsQuery = async <
  TData = Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminListPendingSkillSubmissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions =
    getGetV2AdminListPendingSkillSubmissionsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2AdminReadSkillSubmissionFileResponse200 = {
  data: string;
  status: 200;
};

export type getV2AdminReadSkillSubmissionFileResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2AdminReadSkillSubmissionFileResponse404 = {
  data: void;
  status: 404;
};

export type getV2AdminReadSkillSubmissionFileResponse413 = {
  data: void;
  status: 413;
};

export type getV2AdminReadSkillSubmissionFileResponse415 = {
  data: void;
  status: 415;
};

export type getV2AdminReadSkillSubmissionFileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2AdminReadSkillSubmissionFileResponseSuccess =
  getV2AdminReadSkillSubmissionFileResponse200 & {
    headers: Headers;
  };
export type getV2AdminReadSkillSubmissionFileResponseError = (
  | getV2AdminReadSkillSubmissionFileResponse401
  | getV2AdminReadSkillSubmissionFileResponse404
  | getV2AdminReadSkillSubmissionFileResponse413
  | getV2AdminReadSkillSubmissionFileResponse415
  | getV2AdminReadSkillSubmissionFileResponse422
) & {
  headers: Headers;
};

export type getV2AdminReadSkillSubmissionFileResponse =
  | getV2AdminReadSkillSubmissionFileResponseSuccess
  | getV2AdminReadSkillSubmissionFileResponseError;

export const getGetV2AdminReadSkillSubmissionFileUrl = (
  skillListingVersionId: string,
  path: string,
) => {
  return `/api/store/admin/skills/submissions/${skillListingVersionId}/files/${path}`;
};

/**
 * One submitted file's text, so a reviewer reads a script before approving.
 *
 * The version is addressed directly rather than through its listing: a first
 * submission has no approved version for a slug to resolve to, and this
 * router's admin check is what grants the pending read.
 * @summary Admin Read Skill Submission File
 */
export const getV2AdminReadSkillSubmissionFile = async (
  skillListingVersionId: string,
  path: string,
  options?: RequestInit,
): Promise<getV2AdminReadSkillSubmissionFileResponse> => {
  return customMutator<getV2AdminReadSkillSubmissionFileResponse>(
    getGetV2AdminReadSkillSubmissionFileUrl(skillListingVersionId, path),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2AdminReadSkillSubmissionFileQueryKey = (
  skillListingVersionId: string,
  path: string,
) => {
  return [
    `/api/store/admin/skills/submissions/${skillListingVersionId}/files/${path}`,
  ] as const;
};

export const getGetV2AdminReadSkillSubmissionFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  skillListingVersionId: string,
  path: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2AdminReadSkillSubmissionFileQueryKey(skillListingVersionId, path);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>
  > = ({ signal }) =>
    getV2AdminReadSkillSubmissionFile(skillListingVersionId, path, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      skillListingVersionId !== null &&
      skillListingVersionId !== undefined &&
      path !== null &&
      path !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2AdminReadSkillSubmissionFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>
>;
export type GetV2AdminReadSkillSubmissionFileQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

export function useGetV2AdminReadSkillSubmissionFile<
  TData = Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  skillListingVersionId: string,
  path: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>,
          TError,
          Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2AdminReadSkillSubmissionFile<
  TData = Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  skillListingVersionId: string,
  path: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>,
          TError,
          Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2AdminReadSkillSubmissionFile<
  TData = Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  skillListingVersionId: string,
  path: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Admin Read Skill Submission File
 */

export function useGetV2AdminReadSkillSubmissionFile<
  TData = Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  skillListingVersionId: string,
  path: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2AdminReadSkillSubmissionFileQueryOptions(
    skillListingVersionId,
    path,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Admin Read Skill Submission File
 */
export const prefetchGetV2AdminReadSkillSubmissionFileQuery = async <
  TData = Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  queryClient: QueryClient,
  skillListingVersionId: string,
  path: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminReadSkillSubmissionFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2AdminReadSkillSubmissionFileQueryOptions(
    skillListingVersionId,
    path,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2ReviewSkillSubmissionResponse200 = {
  data: SkillSubmission;
  status: 200;
};

export type postV2ReviewSkillSubmissionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2ReviewSkillSubmissionResponse404 = {
  data: void;
  status: 404;
};

export type postV2ReviewSkillSubmissionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2ReviewSkillSubmissionResponseSuccess =
  postV2ReviewSkillSubmissionResponse200 & {
    headers: Headers;
  };
export type postV2ReviewSkillSubmissionResponseError = (
  | postV2ReviewSkillSubmissionResponse401
  | postV2ReviewSkillSubmissionResponse404
  | postV2ReviewSkillSubmissionResponse422
) & {
  headers: Headers;
};

export type postV2ReviewSkillSubmissionResponse =
  | postV2ReviewSkillSubmissionResponseSuccess
  | postV2ReviewSkillSubmissionResponseError;

export const getPostV2ReviewSkillSubmissionUrl = (
  skillListingVersionId: string,
) => {
  return `/api/store/admin/skills/submissions/${skillListingVersionId}/review`;
};

/**
 * Approve or reject a skill submission.
 *
 * Approval promotes the version to the one the marketplace serves, so the
 * browse cache is dropped; a rejection changes nothing shoppers can see.
 * @summary Review Skill Submission
 */
export const postV2ReviewSkillSubmission = async (
  skillListingVersionId: string,
  skillReviewRequest: SkillReviewRequest,
  options?: RequestInit,
): Promise<postV2ReviewSkillSubmissionResponse> => {
  return customMutator<postV2ReviewSkillSubmissionResponse>(
    getPostV2ReviewSkillSubmissionUrl(skillListingVersionId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(skillReviewRequest),
    },
  );
};

export const getPostV2ReviewSkillSubmissionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2ReviewSkillSubmission>>,
    TError,
    { skillListingVersionId: string; data: SkillReviewRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2ReviewSkillSubmission>>,
  TError,
  { skillListingVersionId: string; data: SkillReviewRequest },
  TContext
> => {
  const mutationKey = ["postV2ReviewSkillSubmission"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2ReviewSkillSubmission>>,
    { skillListingVersionId: string; data: SkillReviewRequest }
  > = (props) => {
    const { skillListingVersionId, data } = props ?? {};

    return postV2ReviewSkillSubmission(
      skillListingVersionId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2ReviewSkillSubmissionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2ReviewSkillSubmission>>
>;
export type PostV2ReviewSkillSubmissionMutationBody = SkillReviewRequest;
export type PostV2ReviewSkillSubmissionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Review Skill Submission
 */
export const usePostV2ReviewSkillSubmission = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2ReviewSkillSubmission>>,
      TError,
      { skillListingVersionId: string; data: SkillReviewRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2ReviewSkillSubmission>>,
  TError,
  { skillListingVersionId: string; data: SkillReviewRequest },
  TContext
> => {
  return useMutation(
    getPostV2ReviewSkillSubmissionMutationOptions(options),
    queryClient,
  );
};
export type getV2AdminDownloadAgentFileResponse200 = {
  data: unknown;
  status: 200;
};

export type getV2AdminDownloadAgentFileResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2AdminDownloadAgentFileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2AdminDownloadAgentFileResponseSuccess =
  getV2AdminDownloadAgentFileResponse200 & {
    headers: Headers;
  };
export type getV2AdminDownloadAgentFileResponseError = (
  | getV2AdminDownloadAgentFileResponse401
  | getV2AdminDownloadAgentFileResponse422
) & {
  headers: Headers;
};

export type getV2AdminDownloadAgentFileResponse =
  | getV2AdminDownloadAgentFileResponseSuccess
  | getV2AdminDownloadAgentFileResponseError;

export const getGetV2AdminDownloadAgentFileUrl = (
  storeListingVersionId: string,
) => {
  return `/api/store/admin/submissions/download/${storeListingVersionId}`;
};

/**
 * Download the agent file by streaming its content.
 *
 * Args:
 *     store_listing_version_id (str): The ID of the agent to download
 *
 * Returns:
 *     StreamingResponse: A streaming response containing the agent's graph data.
 *
 * Raises:
 *     HTTPException: If the agent is not found or an unexpected error occurs.
 * @summary Admin Download Agent File
 */
export const getV2AdminDownloadAgentFile = async (
  storeListingVersionId: string,
  options?: RequestInit,
): Promise<getV2AdminDownloadAgentFileResponse> => {
  return customMutator<getV2AdminDownloadAgentFileResponse>(
    getGetV2AdminDownloadAgentFileUrl(storeListingVersionId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2AdminDownloadAgentFileQueryKey = (
  storeListingVersionId: string,
) => {
  return [
    `/api/store/admin/submissions/download/${storeListingVersionId}`,
  ] as const;
};

export const getGetV2AdminDownloadAgentFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2AdminDownloadAgentFileQueryKey(storeListingVersionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>
  > = ({ signal }) =>
    getV2AdminDownloadAgentFile(storeListingVersionId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      storeListingVersionId !== null && storeListingVersionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2AdminDownloadAgentFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>
>;
export type GetV2AdminDownloadAgentFileQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2AdminDownloadAgentFile<
  TData = Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>,
          TError,
          Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2AdminDownloadAgentFile<
  TData = Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>,
          TError,
          Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2AdminDownloadAgentFile<
  TData = Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Admin Download Agent File
 */

export function useGetV2AdminDownloadAgentFile<
  TData = Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2AdminDownloadAgentFileQueryOptions(
    storeListingVersionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Admin Download Agent File
 */
export const prefetchGetV2AdminDownloadAgentFileQuery = async <
  TData = Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminDownloadAgentFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2AdminDownloadAgentFileQueryOptions(
    storeListingVersionId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2AdminAddPendingAgentToLibraryResponse201 = {
  data: LibraryAgent;
  status: 201;
};

export type postV2AdminAddPendingAgentToLibraryResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2AdminAddPendingAgentToLibraryResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2AdminAddPendingAgentToLibraryResponseSuccess =
  postV2AdminAddPendingAgentToLibraryResponse201 & {
    headers: Headers;
  };
export type postV2AdminAddPendingAgentToLibraryResponseError = (
  | postV2AdminAddPendingAgentToLibraryResponse401
  | postV2AdminAddPendingAgentToLibraryResponse422
) & {
  headers: Headers;
};

export type postV2AdminAddPendingAgentToLibraryResponse =
  | postV2AdminAddPendingAgentToLibraryResponseSuccess
  | postV2AdminAddPendingAgentToLibraryResponseError;

export const getPostV2AdminAddPendingAgentToLibraryUrl = (
  storeListingVersionId: string,
) => {
  return `/api/store/admin/submissions/${storeListingVersionId}/add-to-library`;
};

/**
 * Add a pending marketplace agent to the admin's library for review.
 * Uses admin-level access to bypass marketplace APPROVED-only checks.
 *
 * The builder can then load the graph: get_graph() grants a library
 * version that was submitted, and PENDING counts as submitted.
 * @summary Admin Add Pending Agent to Library
 */
export const postV2AdminAddPendingAgentToLibrary = async (
  storeListingVersionId: string,
  options?: RequestInit,
): Promise<postV2AdminAddPendingAgentToLibraryResponse> => {
  return customMutator<postV2AdminAddPendingAgentToLibraryResponse>(
    getPostV2AdminAddPendingAgentToLibraryUrl(storeListingVersionId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2AdminAddPendingAgentToLibraryMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2AdminAddPendingAgentToLibrary>>,
    TError,
    { storeListingVersionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2AdminAddPendingAgentToLibrary>>,
  TError,
  { storeListingVersionId: string },
  TContext
> => {
  const mutationKey = ["postV2AdminAddPendingAgentToLibrary"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2AdminAddPendingAgentToLibrary>>,
    { storeListingVersionId: string }
  > = (props) => {
    const { storeListingVersionId } = props ?? {};

    return postV2AdminAddPendingAgentToLibrary(
      storeListingVersionId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2AdminAddPendingAgentToLibraryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2AdminAddPendingAgentToLibrary>>
>;

export type PostV2AdminAddPendingAgentToLibraryMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Admin Add Pending Agent to Library
 */
export const usePostV2AdminAddPendingAgentToLibrary = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2AdminAddPendingAgentToLibrary>>,
      TError,
      { storeListingVersionId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2AdminAddPendingAgentToLibrary>>,
  TError,
  { storeListingVersionId: string },
  TContext
> => {
  return useMutation(
    getPostV2AdminAddPendingAgentToLibraryMutationOptions(options),
    queryClient,
  );
};
export type getV2AdminPreviewSubmissionListingResponse200 = {
  data: StoreAgentDetails;
  status: 200;
};

export type getV2AdminPreviewSubmissionListingResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2AdminPreviewSubmissionListingResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2AdminPreviewSubmissionListingResponseSuccess =
  getV2AdminPreviewSubmissionListingResponse200 & {
    headers: Headers;
  };
export type getV2AdminPreviewSubmissionListingResponseError = (
  | getV2AdminPreviewSubmissionListingResponse401
  | getV2AdminPreviewSubmissionListingResponse422
) & {
  headers: Headers;
};

export type getV2AdminPreviewSubmissionListingResponse =
  | getV2AdminPreviewSubmissionListingResponseSuccess
  | getV2AdminPreviewSubmissionListingResponseError;

export const getGetV2AdminPreviewSubmissionListingUrl = (
  storeListingVersionId: string,
) => {
  return `/api/store/admin/submissions/${storeListingVersionId}/preview`;
};

/**
 * Preview a marketplace submission as it would appear on the listing page.
 * Bypasses the APPROVED-only StoreAgent view so admins can preview pending
 * submissions before approving.
 * @summary Admin Preview Submission Listing
 */
export const getV2AdminPreviewSubmissionListing = async (
  storeListingVersionId: string,
  options?: RequestInit,
): Promise<getV2AdminPreviewSubmissionListingResponse> => {
  return customMutator<getV2AdminPreviewSubmissionListingResponse>(
    getGetV2AdminPreviewSubmissionListingUrl(storeListingVersionId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2AdminPreviewSubmissionListingQueryKey = (
  storeListingVersionId: string,
) => {
  return [
    `/api/store/admin/submissions/${storeListingVersionId}/preview`,
  ] as const;
};

export const getGetV2AdminPreviewSubmissionListingQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2AdminPreviewSubmissionListingQueryKey(storeListingVersionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>
  > = ({ signal }) =>
    getV2AdminPreviewSubmissionListing(storeListingVersionId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      storeListingVersionId !== null && storeListingVersionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2AdminPreviewSubmissionListingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>
>;
export type GetV2AdminPreviewSubmissionListingQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2AdminPreviewSubmissionListing<
  TData = Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>,
          TError,
          Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2AdminPreviewSubmissionListing<
  TData = Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>,
          TError,
          Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2AdminPreviewSubmissionListing<
  TData = Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Admin Preview Submission Listing
 */

export function useGetV2AdminPreviewSubmissionListing<
  TData = Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2AdminPreviewSubmissionListingQueryOptions(
    storeListingVersionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Admin Preview Submission Listing
 */
export const prefetchGetV2AdminPreviewSubmissionListingQuery = async <
  TData = Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2AdminPreviewSubmissionListing>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2AdminPreviewSubmissionListingQueryOptions(
    storeListingVersionId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2ReviewStoreSubmissionResponse200 = {
  data: StoreSubmissionAdminView;
  status: 200;
};

export type postV2ReviewStoreSubmissionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2ReviewStoreSubmissionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2ReviewStoreSubmissionResponseSuccess =
  postV2ReviewStoreSubmissionResponse200 & {
    headers: Headers;
  };
export type postV2ReviewStoreSubmissionResponseError = (
  | postV2ReviewStoreSubmissionResponse401
  | postV2ReviewStoreSubmissionResponse422
) & {
  headers: Headers;
};

export type postV2ReviewStoreSubmissionResponse =
  | postV2ReviewStoreSubmissionResponseSuccess
  | postV2ReviewStoreSubmissionResponseError;

export const getPostV2ReviewStoreSubmissionUrl = (
  storeListingVersionId: string,
) => {
  return `/api/store/admin/submissions/${storeListingVersionId}/review`;
};

/**
 * Review a store listing submission.
 *
 * Args:
 *     store_listing_version_id: ID of the submission to review
 *     request: Review details including approval status and comments
 *     user_id: Authenticated admin user performing the review
 *
 * Returns:
 *     StoreSubmissionAdminView with updated review information
 * @summary Review Store Submission
 */
export const postV2ReviewStoreSubmission = async (
  storeListingVersionId: string,
  reviewSubmissionRequest: ReviewSubmissionRequest,
  options?: RequestInit,
): Promise<postV2ReviewStoreSubmissionResponse> => {
  return customMutator<postV2ReviewStoreSubmissionResponse>(
    getPostV2ReviewStoreSubmissionUrl(storeListingVersionId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(reviewSubmissionRequest),
    },
  );
};

export const getPostV2ReviewStoreSubmissionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2ReviewStoreSubmission>>,
    TError,
    { storeListingVersionId: string; data: ReviewSubmissionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2ReviewStoreSubmission>>,
  TError,
  { storeListingVersionId: string; data: ReviewSubmissionRequest },
  TContext
> => {
  const mutationKey = ["postV2ReviewStoreSubmission"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2ReviewStoreSubmission>>,
    { storeListingVersionId: string; data: ReviewSubmissionRequest }
  > = (props) => {
    const { storeListingVersionId, data } = props ?? {};

    return postV2ReviewStoreSubmission(
      storeListingVersionId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2ReviewStoreSubmissionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2ReviewStoreSubmission>>
>;
export type PostV2ReviewStoreSubmissionMutationBody = ReviewSubmissionRequest;
export type PostV2ReviewStoreSubmissionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Review Store Submission
 */
export const usePostV2ReviewStoreSubmission = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2ReviewStoreSubmission>>,
      TError,
      { storeListingVersionId: string; data: ReviewSubmissionRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2ReviewStoreSubmission>>,
  TError,
  { storeListingVersionId: string; data: ReviewSubmissionRequest },
  TContext
> => {
  return useMutation(
    getPostV2ReviewStoreSubmissionMutationOptions(options),
    queryClient,
  );
};
